import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _assertThisInitialized2 from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
var _excluded = ["className", "tag", "wrapperTag", "children", "onSwiper"],
  _excluded2 = ["tag", "children", "className", "swiper", "zoom", "virtualIndex"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import "core-js/modules/esnext.global-this.js";
import React, { useState, useEffect, useLayoutEffect, createContext, forwardRef, useRef, Children, useMemo, isValidElement, cloneElement } from 'react';
import ReactDOM from 'react-dom';
var styles$u = {
  "itemHeaderSingle": "accordion-module_itemHeaderSingle__RG324",
  "itemHeader": "accordion-module_itemHeader__haY4r",
  "list": "accordion-module_list__8mo6s",
  "listTransparent": "accordion-module_listTransparent__gUB-p",
  "itemBody": "accordion-module_itemBody__8SwAL",
  "itemActive": "accordion-module_itemActive__hY-HU",
  "item": "accordion-module_item__xjf7X",
  "fadeInUp": "accordion-module_fadeInUp__Rk9Od",
  "noBorder": "accordion-module_noBorder__sA7yh",
  "fadeInDown": "accordion-module_fadeInDown__JKHdw",
  "listWithEffects": "accordion-module_listWithEffects__UaiIl",
  "fadeInDropdown": "accordion-module_fadeInDropdown__LF6pQ",
  "fadeOutDropdown": "accordion-module_fadeOutDropdown__rtA5l"
};
var Accordion = function Accordion(_a) {
  var _b = _a.withEffects,
    withEffects = _b === void 0 ? false : _b,
    items = _a.items,
    _c = _a.isTransparent,
    isTransparent = _c === void 0 ? false : _c,
    _d = _a.openIfSingleItem,
    openIfSingleItem = _d === void 0 ? false : _d,
    _e = _a.isHtmlContent,
    isHtmlContent = _e === void 0 ? false : _e,
    _f = _a.className,
    className = _f === void 0 ? "" : _f,
    _g = _a.noIconBorder,
    noIconBorder = _g === void 0 ? false : _g;
  var active = items.length === 1 && openIfSingleItem ? 0 : -1;
  var _h = useState(active),
    activeItemIndex = _h[0],
    setActiveItemIndex = _h[1];
  var isTransparentClass = isTransparent ? styles$u.listTransparent : styles$u.list;
  var withEffectsClass = withEffects ? styles$u.listWithEffects : "";
  return React.createElement("ul", {
    className: "".concat(isTransparentClass, " ").concat(withEffectsClass, " ").concat(className)
  }, items.map(function (item, i) {
    return React.createElement("li", {
      className: i === activeItemIndex ? styles$u.itemActive : styles$u.item,
      key: i
    }, React.createElement("div", {
      className: "".concat(styles$u.itemHeader, " ").concat(noIconBorder ? styles$u.noBorder : ""),
      onClick: function onClick() {
        return setActiveItemIndex(activeItemIndex !== i ? i : -1);
      }
    }, item.question), isHtmlContent ? React.createElement("div", {
      className: styles$u.itemBody,
      dangerouslySetInnerHTML: {
        __html: "".concat(item.answer)
      }
    }) : React.createElement("div", {
      className: styles$u.itemBody
    }, item.answer));
  }));
};
var styles$t = {
  "linkBack": "button-module_linkBack__xhLkY",
  "button": "button-module_button__Z331g",
  "buttonXSmall": "button-module_buttonXSmall__vcgd3",
  "buttonSuccess": "button-module_buttonSuccess__n9zxQ",
  "buttonPrimary": "button-module_buttonPrimary__waJKL",
  "buttonGhost": "button-module_buttonGhost__Z1dW-",
  "buttonGhostPrimary": "button-module_buttonGhostPrimary__z-ngC",
  "buttonLink": "button-module_buttonLink__wmqDw",
  "loader": "button-module_loader__xNewh",
  "loaderPrimary": "button-module_loaderPrimary__oZdnb",
  "load": "button-module_load__FgqWo",
  "loadPrimary": "button-module_loadPrimary__0J6RY",
  "fadeInDown": "button-module_fadeInDown__-sLos",
  "fadeInUp": "button-module_fadeInUp__puRsI",
  "fadeInDropdown": "button-module_fadeInDropdown__4JYym",
  "fadeOutDropdown": "button-module_fadeOutDropdown__u97hd"
};
var extendClassNameWith = function extendClassNameWith(className, newClass) {
  return "".concat(className, " ").concat(newClass);
};
var Button = function Button(_a) {
  var title = _a.title,
    xSmall = _a.xSmall,
    success = _a.success,
    primary = _a.primary,
    ghost = _a.ghost,
    ghostPrimary = _a.ghostPrimary,
    link = _a.link,
    back = _a.back,
    loading = _a.loading,
    disabled = _a.disabled,
    _b = _a.className,
    className = _b === void 0 ? "" : _b,
    onClick = _a.onClick;
  var classes = styles$t.button;
  if (xSmall) {
    classes = extendClassNameWith(classes, styles$t.buttonXSmall);
  }
  if (success) {
    classes = extendClassNameWith(classes, styles$t.buttonSuccess);
  }
  if (primary) {
    classes = extendClassNameWith(classes, styles$t.buttonPrimary);
  }
  if (ghost) {
    classes = extendClassNameWith(classes, styles$t.buttonGhost);
  }
  if (ghostPrimary) {
    classes = extendClassNameWith(classes, styles$t.buttonGhostPrimary);
  }
  if (link) {
    classes = extendClassNameWith(classes, styles$t.buttonLink);
  }
  if (back) {
    classes = extendClassNameWith(classes, styles$t.linkBack);
  }
  return React.createElement("button", {
    className: "".concat(classes, " ").concat(className),
    disabled: disabled || loading,
    onClick: onClick
  }, title, loading && React.createElement("span", {
    className: styles$t.loader
  }));
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var _assign$ = function __assign$1() {
  _assign$ = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return _assign$.apply(this, arguments);
};
function __rest$1(s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var reactResponsiveExports = {};
var reactResponsive = {
  get exports() {
    return reactResponsiveExports;
  },
  set exports(v) {
    reactResponsiveExports = v;
  }
};
(function (module, exports) {
  (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory(React);
  })(commonjsGlobal, function (__WEBPACK_EXTERNAL_MODULE_react__) {
    return (/******/function () {
        // webpackBootstrap
        /******/
        var __webpack_modules__ = {
          /***/"./node_modules/css-mediaquery/index.js":
          /*!**********************************************!*\
            !*** ./node_modules/css-mediaquery/index.js ***!
            \**********************************************/
          /***/
          function node_modulesCssMediaqueryIndexJs(__unused_webpack_module, exports) {
            /*
            Copyright (c) 2014, Yahoo! Inc. All rights reserved.
            Copyrights licensed under the New BSD License.
            See the accompanying LICENSE file for terms.
            */

            exports.match = matchQuery;
            exports.parse = parseQuery;

            // -----------------------------------------------------------------------------

            var RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i,
              RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/,
              RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/,
              RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/,
              RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
            function matchQuery(mediaQuery, values) {
              return parseQuery(mediaQuery).some(function (query) {
                var inverse = query.inverse;

                // Either the parsed or specified `type` is "all", or the types must be
                // equal for a match.
                var typeMatch = query.type === 'all' || values.type === query.type;

                // Quit early when `type` doesn't match, but take "not" into account.
                if (typeMatch && inverse || !(typeMatch || inverse)) {
                  return false;
                }
                var expressionsMatch = query.expressions.every(function (expression) {
                  var feature = expression.feature,
                    modifier = expression.modifier,
                    expValue = expression.value,
                    value = values[feature];

                  // Missing or falsy values don't match.
                  if (!value) {
                    return false;
                  }
                  switch (feature) {
                    case 'orientation':
                    case 'scan':
                      return value.toLowerCase() === expValue.toLowerCase();
                    case 'width':
                    case 'height':
                    case 'device-width':
                    case 'device-height':
                      expValue = toPx(expValue);
                      value = toPx(value);
                      break;
                    case 'resolution':
                      expValue = toDpi(expValue);
                      value = toDpi(value);
                      break;
                    case 'aspect-ratio':
                    case 'device-aspect-ratio':
                    case /* Deprecated */'device-pixel-ratio':
                      expValue = toDecimal(expValue);
                      value = toDecimal(value);
                      break;
                    case 'grid':
                    case 'color':
                    case 'color-index':
                    case 'monochrome':
                      expValue = parseInt(expValue, 10) || 1;
                      value = parseInt(value, 10) || 0;
                      break;
                  }
                  switch (modifier) {
                    case 'min':
                      return value >= expValue;
                    case 'max':
                      return value <= expValue;
                    default:
                      return value === expValue;
                  }
                });
                return expressionsMatch && !inverse || !expressionsMatch && inverse;
              });
            }
            function parseQuery(mediaQuery) {
              return mediaQuery.split(',').map(function (query) {
                query = query.trim();
                var captures = query.match(RE_MEDIA_QUERY),
                  modifier = captures[1],
                  type = captures[2],
                  expressions = captures[3] || '',
                  parsed = {};
                parsed.inverse = !!modifier && modifier.toLowerCase() === 'not';
                parsed.type = type ? type.toLowerCase() : 'all';

                // Split expressions into a list.
                expressions = expressions.match(/\([^\)]+\)/g) || [];
                parsed.expressions = expressions.map(function (expression) {
                  var captures = expression.match(RE_MQ_EXPRESSION),
                    feature = captures[1].toLowerCase().match(RE_MQ_FEATURE);
                  return {
                    modifier: feature[1],
                    feature: feature[2],
                    value: captures[2]
                  };
                });
                return parsed;
              });
            }

            // -- Utilities ----------------------------------------------------------------

            function toDecimal(ratio) {
              var decimal = Number(ratio),
                numbers;
              if (!decimal) {
                numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/);
                decimal = numbers[1] / numbers[2];
              }
              return decimal;
            }
            function toDpi(resolution) {
              var value = parseFloat(resolution),
                units = String(resolution).match(RE_RESOLUTION_UNIT)[1];
              switch (units) {
                case 'dpcm':
                  return value / 2.54;
                case 'dppx':
                  return value * 96;
                default:
                  return value;
              }
            }
            function toPx(length) {
              var value = parseFloat(length),
                units = String(length).match(RE_LENGTH_UNIT)[1];
              switch (units) {
                case 'em':
                  return value * 16;
                case 'rem':
                  return value * 16;
                case 'cm':
                  return value * 96 / 2.54;
                case 'mm':
                  return value * 96 / 2.54 / 10;
                case 'in':
                  return value * 96;
                case 'pt':
                  return value * 72;
                case 'pc':
                  return value * 72 / 12;
                default:
                  return value;
              }
            }

            /***/
          },

          /***/"./node_modules/hyphenate-style-name/index.js":
          /*!****************************************************!*\
            !*** ./node_modules/hyphenate-style-name/index.js ***!
            \****************************************************/
          /***/
          function node_modulesHyphenateStyleNameIndexJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            /* harmony export */
            __webpack_require__.d(__webpack_exports__, {
              /* harmony export */"default": function _default() {
                return __WEBPACK_DEFAULT_EXPORT__;
              }
              /* harmony export */
            });
            /* eslint-disable no-var, prefer-template */
            var uppercasePattern = /[A-Z]/g;
            var msPattern = /^ms-/;
            var cache = {};
            function toHyphenLower(match) {
              return '-' + match.toLowerCase();
            }
            function hyphenateStyleName(name) {
              if (cache.hasOwnProperty(name)) {
                return cache[name];
              }
              var hName = name.replace(uppercasePattern, toHyphenLower);
              return cache[name] = msPattern.test(hName) ? '-' + hName : hName;
            }

            /* harmony default export */
            var __WEBPACK_DEFAULT_EXPORT__ = hyphenateStyleName;

            /***/
          },

          /***/"./node_modules/matchmediaquery/index.js":
          /*!***********************************************!*\
            !*** ./node_modules/matchmediaquery/index.js ***!
            \***********************************************/
          /***/
          function node_modulesMatchmediaqueryIndexJs(module, __unused_webpack_exports, __webpack_require__) {
            var staticMatch = __webpack_require__( /*! css-mediaquery */"./node_modules/css-mediaquery/index.js").match;
            var dynamicMatch = typeof window !== 'undefined' ? window.matchMedia : null;

            // our fake MediaQueryList
            function Mql(query, values, forceStatic) {
              var self = this;
              if (dynamicMatch && !forceStatic) {
                var mql = dynamicMatch.call(window, query);
                this.matches = mql.matches;
                this.media = mql.media;
                // TODO: is there a time it makes sense to remove this listener?
                mql.addListener(update);
              } else {
                this.matches = staticMatch(query, values);
                this.media = query;
              }
              this.addListener = addListener;
              this.removeListener = removeListener;
              this.dispose = dispose;
              function addListener(listener) {
                if (mql) {
                  mql.addListener(listener);
                }
              }
              function removeListener(listener) {
                if (mql) {
                  mql.removeListener(listener);
                }
              }

              // update ourselves!
              function update(evt) {
                self.matches = evt.matches;
                self.media = evt.media;
              }
              function dispose() {
                if (mql) {
                  mql.removeListener(update);
                }
              }
            }
            function matchMedia(query, values, forceStatic) {
              return new Mql(query, values, forceStatic);
            }
            module.exports = matchMedia;

            /***/
          },

          /***/"./node_modules/object-assign/index.js":
          /*!*********************************************!*\
            !*** ./node_modules/object-assign/index.js ***!
            \*********************************************/
          /***/
          function node_modulesObjectAssignIndexJs(module) {
            /*
            object-assign
            (c) Sindre Sorhus
            @license MIT
            */

            /* eslint-disable no-unused-vars */
            var getOwnPropertySymbols = Object.getOwnPropertySymbols;
            var hasOwnProperty = Object.prototype.hasOwnProperty;
            var propIsEnumerable = Object.prototype.propertyIsEnumerable;
            function toObject(val) {
              if (val === null || val === undefined) {
                throw new TypeError('Object.assign cannot be called with null or undefined');
              }
              return Object(val);
            }
            function shouldUseNative() {
              try {
                if (!Object.assign) {
                  return false;
                }

                // Detect buggy property enumeration order in older V8 versions.

                // https://bugs.chromium.org/p/v8/issues/detail?id=4118
                var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
                test1[5] = 'de';
                if (Object.getOwnPropertyNames(test1)[0] === '5') {
                  return false;
                }

                // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                var test2 = {};
                for (var i = 0; i < 10; i++) {
                  test2['_' + String.fromCharCode(i)] = i;
                }
                var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
                  return test2[n];
                });
                if (order2.join('') !== '0123456789') {
                  return false;
                }

                // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                var test3 = {};
                'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
                  test3[letter] = letter;
                });
                if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
                  return false;
                }
                return true;
              } catch (err) {
                // We don't expect any of the above to throw, but better to be safe.
                return false;
              }
            }
            module.exports = shouldUseNative() ? Object.assign : function (target, source) {
              var from;
              var to = toObject(target);
              var symbols;
              for (var s = 1; s < arguments.length; s++) {
                from = Object(arguments[s]);
                for (var key in from) {
                  if (hasOwnProperty.call(from, key)) {
                    to[key] = from[key];
                  }
                }
                if (getOwnPropertySymbols) {
                  symbols = getOwnPropertySymbols(from);
                  for (var i = 0; i < symbols.length; i++) {
                    if (propIsEnumerable.call(from, symbols[i])) {
                      to[symbols[i]] = from[symbols[i]];
                    }
                  }
                }
              }
              return to;
            };

            /***/
          },

          /***/"./node_modules/prop-types/checkPropTypes.js":
          /*!***************************************************!*\
            !*** ./node_modules/prop-types/checkPropTypes.js ***!
            \***************************************************/
          /***/
          function node_modulesPropTypesCheckPropTypesJs(module, __unused_webpack_exports, __webpack_require__) {
            /**
             * Copyright (c) 2013-present, Facebook, Inc.
             *
             * This source code is licensed under the MIT license found in the
             * LICENSE file in the root directory of this source tree.
             */

            var printWarning = function printWarning() {};
            {
              var ReactPropTypesSecret = __webpack_require__( /*! ./lib/ReactPropTypesSecret */"./node_modules/prop-types/lib/ReactPropTypesSecret.js");
              var loggedTypeFailures = {};
              var has = __webpack_require__( /*! ./lib/has */"./node_modules/prop-types/lib/has.js");
              printWarning = function printWarning(text) {
                var message = 'Warning: ' + text;
                if (typeof console !== 'undefined') {
                  console.error(message);
                }
                try {
                  // --- Welcome to debugging React ---
                  // This error was thrown as a convenience so that you can use this stack
                  // to find the callsite that caused this warning to fire.
                  throw new Error(message);
                } catch (x) {/**/}
              };
            }

            /**
             * Assert that the values match with the type specs.
             * Error messages are memorized and will only be shown once.
             *
             * @param {object} typeSpecs Map of name to a ReactPropType
             * @param {object} values Runtime values that need to be type-checked
             * @param {string} location e.g. "prop", "context", "child context"
             * @param {string} componentName Name of the component for error messages.
             * @param {?Function} getStack Returns the component stack.
             * @private
             */
            function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
              {
                for (var typeSpecName in typeSpecs) {
                  if (has(typeSpecs, typeSpecName)) {
                    var error;
                    // Prop type validation may throw. In case they do, we don't want to
                    // fail the render phase where it didn't fail before. So we log it.
                    // After these have been cleaned up, we'll let them throw.
                    try {
                      // This is intentionally an invariant that gets caught. It's the same
                      // behavior as without this statement except with a better message.
                      if (typeof typeSpecs[typeSpecName] !== 'function') {
                        var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                        err.name = 'Invariant Violation';
                        throw err;
                      }
                      error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                    } catch (ex) {
                      error = ex;
                    }
                    if (error && !(error instanceof Error)) {
                      printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
                    }
                    if (error instanceof Error && !(error.message in loggedTypeFailures)) {
                      // Only monitor this failure once because there tends to be a lot of the
                      // same error.
                      loggedTypeFailures[error.message] = true;
                      var stack = getStack ? getStack() : '';
                      printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
                    }
                  }
                }
              }
            }

            /**
             * Resets warning cache when testing.
             *
             * @private
             */
            checkPropTypes.resetWarningCache = function () {
              {
                loggedTypeFailures = {};
              }
            };
            module.exports = checkPropTypes;

            /***/
          },

          /***/"./node_modules/prop-types/factoryWithTypeCheckers.js":
          /*!************************************************************!*\
            !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
            \************************************************************/
          /***/
          function node_modulesPropTypesFactoryWithTypeCheckersJs(module, __unused_webpack_exports, __webpack_require__) {
            /**
             * Copyright (c) 2013-present, Facebook, Inc.
             *
             * This source code is licensed under the MIT license found in the
             * LICENSE file in the root directory of this source tree.
             */

            var ReactIs = __webpack_require__( /*! react-is */"./node_modules/react-is/index.js");
            var assign = __webpack_require__( /*! object-assign */"./node_modules/object-assign/index.js");
            var ReactPropTypesSecret = __webpack_require__( /*! ./lib/ReactPropTypesSecret */"./node_modules/prop-types/lib/ReactPropTypesSecret.js");
            var has = __webpack_require__( /*! ./lib/has */"./node_modules/prop-types/lib/has.js");
            var checkPropTypes = __webpack_require__( /*! ./checkPropTypes */"./node_modules/prop-types/checkPropTypes.js");
            var printWarning = function printWarning() {};
            {
              printWarning = function printWarning(text) {
                var message = 'Warning: ' + text;
                if (typeof console !== 'undefined') {
                  console.error(message);
                }
                try {
                  // --- Welcome to debugging React ---
                  // This error was thrown as a convenience so that you can use this stack
                  // to find the callsite that caused this warning to fire.
                  throw new Error(message);
                } catch (x) {}
              };
            }
            function emptyFunctionThatReturnsNull() {
              return null;
            }
            module.exports = function (isValidElement, throwOnDirectAccess) {
              /* global Symbol */
              var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
              var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

              /**
               * Returns the iterator method function contained on the iterable object.
               *
               * Be sure to invoke the function with the iterable as context:
               *
               *     var iteratorFn = getIteratorFn(myIterable);
               *     if (iteratorFn) {
               *       var iterator = iteratorFn.call(myIterable);
               *       ...
               *     }
               *
               * @param {?object} maybeIterable
               * @return {?function}
               */
              function getIteratorFn(maybeIterable) {
                var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
                if (typeof iteratorFn === 'function') {
                  return iteratorFn;
                }
              }

              /**
               * Collection of methods that allow declaration and validation of props that are
               * supplied to React components. Example usage:
               *
               *   var Props = require('ReactPropTypes');
               *   var MyArticle = React.createClass({
               *     propTypes: {
               *       // An optional string prop named "description".
               *       description: Props.string,
               *
               *       // A required enum prop named "category".
               *       category: Props.oneOf(['News','Photos']).isRequired,
               *
               *       // A prop named "dialog" that requires an instance of Dialog.
               *       dialog: Props.instanceOf(Dialog).isRequired
               *     },
               *     render: function() { ... }
               *   });
               *
               * A more formal specification of how these methods are used:
               *
               *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
               *   decl := ReactPropTypes.{type}(.isRequired)?
               *
               * Each and every declaration produces a function with the same signature. This
               * allows the creation of custom validation functions. For example:
               *
               *  var MyLink = React.createClass({
               *    propTypes: {
               *      // An optional string or URI prop named "href".
               *      href: function(props, propName, componentName) {
               *        var propValue = props[propName];
               *        if (propValue != null && typeof propValue !== 'string' &&
               *            !(propValue instanceof URI)) {
               *          return new Error(
               *            'Expected a string or an URI for ' + propName + ' in ' +
               *            componentName
               *          );
               *        }
               *      }
               *    },
               *    render: function() {...}
               *  });
               *
               * @internal
               */

              var ANONYMOUS = '<<anonymous>>';

              // Important!
              // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
              var ReactPropTypes = {
                array: createPrimitiveTypeChecker('array'),
                bigint: createPrimitiveTypeChecker('bigint'),
                bool: createPrimitiveTypeChecker('boolean'),
                func: createPrimitiveTypeChecker('function'),
                number: createPrimitiveTypeChecker('number'),
                object: createPrimitiveTypeChecker('object'),
                string: createPrimitiveTypeChecker('string'),
                symbol: createPrimitiveTypeChecker('symbol'),
                any: createAnyTypeChecker(),
                arrayOf: createArrayOfTypeChecker,
                element: createElementTypeChecker(),
                elementType: createElementTypeTypeChecker(),
                instanceOf: createInstanceTypeChecker,
                node: createNodeChecker(),
                objectOf: createObjectOfTypeChecker,
                oneOf: createEnumTypeChecker,
                oneOfType: createUnionTypeChecker,
                shape: createShapeTypeChecker,
                exact: createStrictShapeTypeChecker
              };

              /**
               * inlined Object.is polyfill to avoid requiring consumers ship their own
               * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
               */
              /*eslint-disable no-self-compare*/
              function is(x, y) {
                // SameValue algorithm
                if (x === y) {
                  // Steps 1-5, 7-10
                  // Steps 6.b-6.e: +0 != -0
                  return x !== 0 || 1 / x === 1 / y;
                } else {
                  // Step 6.a: NaN == NaN
                  return x !== x && y !== y;
                }
              }
              /*eslint-enable no-self-compare*/

              /**
               * We use an Error-like object for backward compatibility as people may call
               * PropTypes directly and inspect their output. However, we don't use real
               * Errors anymore. We don't inspect their stack anyway, and creating them
               * is prohibitively expensive if they are created too often, such as what
               * happens in oneOfType() for any type before the one that matched.
               */
              function PropTypeError(message, data) {
                this.message = message;
                this.data = data && typeof data === 'object' ? data : {};
                this.stack = '';
              }
              // Make `instanceof Error` still work for returned errors.
              PropTypeError.prototype = Error.prototype;
              function createChainableTypeChecker(validate) {
                {
                  var manualPropTypeCallCache = {};
                  var manualPropTypeWarningCount = 0;
                }
                function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
                  componentName = componentName || ANONYMOUS;
                  propFullName = propFullName || propName;
                  if (secret !== ReactPropTypesSecret) {
                    if (throwOnDirectAccess) {
                      // New behavior only for users of `prop-types` package
                      var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
                      err.name = 'Invariant Violation';
                      throw err;
                    } else if (typeof console !== 'undefined') {
                      // Old behavior for people using React.PropTypes
                      var cacheKey = componentName + ':' + propName;
                      if (!manualPropTypeCallCache[cacheKey] &&
                      // Avoid spamming the console because they are often not actionable except for lib authors
                      manualPropTypeWarningCount < 3) {
                        printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
                        manualPropTypeCallCache[cacheKey] = true;
                        manualPropTypeWarningCount++;
                      }
                    }
                  }
                  if (props[propName] == null) {
                    if (isRequired) {
                      if (props[propName] === null) {
                        return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                      }
                      return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                    }
                    return null;
                  } else {
                    return validate(props, propName, componentName, location, propFullName);
                  }
                }
                var chainedCheckType = checkType.bind(null, false);
                chainedCheckType.isRequired = checkType.bind(null, true);
                return chainedCheckType;
              }
              function createPrimitiveTypeChecker(expectedType) {
                function validate(props, propName, componentName, location, propFullName, secret) {
                  var propValue = props[propName];
                  var propType = getPropType(propValue);
                  if (propType !== expectedType) {
                    // `propValue` being instance of, say, date/regexp, pass the 'object'
                    // check, but we can offer a more precise error message here rather than
                    // 'of type `object`'.
                    var preciseType = getPreciseType(propValue);
                    return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
                      expectedType: expectedType
                    });
                  }
                  return null;
                }
                return createChainableTypeChecker(validate);
              }
              function createAnyTypeChecker() {
                return createChainableTypeChecker(emptyFunctionThatReturnsNull);
              }
              function createArrayOfTypeChecker(typeChecker) {
                function validate(props, propName, componentName, location, propFullName) {
                  if (typeof typeChecker !== 'function') {
                    return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
                  }
                  var propValue = props[propName];
                  if (!Array.isArray(propValue)) {
                    var propType = getPropType(propValue);
                    return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
                  }
                  for (var i = 0; i < propValue.length; i++) {
                    var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
                    if (error instanceof Error) {
                      return error;
                    }
                  }
                  return null;
                }
                return createChainableTypeChecker(validate);
              }
              function createElementTypeChecker() {
                function validate(props, propName, componentName, location, propFullName) {
                  var propValue = props[propName];
                  if (!isValidElement(propValue)) {
                    var propType = getPropType(propValue);
                    return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
                  }
                  return null;
                }
                return createChainableTypeChecker(validate);
              }
              function createElementTypeTypeChecker() {
                function validate(props, propName, componentName, location, propFullName) {
                  var propValue = props[propName];
                  if (!ReactIs.isValidElementType(propValue)) {
                    var propType = getPropType(propValue);
                    return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
                  }
                  return null;
                }
                return createChainableTypeChecker(validate);
              }
              function createInstanceTypeChecker(expectedClass) {
                function validate(props, propName, componentName, location, propFullName) {
                  if (!(props[propName] instanceof expectedClass)) {
                    var expectedClassName = expectedClass.name || ANONYMOUS;
                    var actualClassName = getClassName(props[propName]);
                    return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
                  }
                  return null;
                }
                return createChainableTypeChecker(validate);
              }
              function createEnumTypeChecker(expectedValues) {
                if (!Array.isArray(expectedValues)) {
                  {
                    if (arguments.length > 1) {
                      printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
                    } else {
                      printWarning('Invalid argument supplied to oneOf, expected an array.');
                    }
                  }
                  return emptyFunctionThatReturnsNull;
                }
                function validate(props, propName, componentName, location, propFullName) {
                  var propValue = props[propName];
                  for (var i = 0; i < expectedValues.length; i++) {
                    if (is(propValue, expectedValues[i])) {
                      return null;
                    }
                  }
                  var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                    var type = getPreciseType(value);
                    if (type === 'symbol') {
                      return String(value);
                    }
                    return value;
                  });
                  return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
                }
                return createChainableTypeChecker(validate);
              }
              function createObjectOfTypeChecker(typeChecker) {
                function validate(props, propName, componentName, location, propFullName) {
                  if (typeof typeChecker !== 'function') {
                    return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
                  }
                  var propValue = props[propName];
                  var propType = getPropType(propValue);
                  if (propType !== 'object') {
                    return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
                  }
                  for (var key in propValue) {
                    if (has(propValue, key)) {
                      var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                      if (error instanceof Error) {
                        return error;
                      }
                    }
                  }
                  return null;
                }
                return createChainableTypeChecker(validate);
              }
              function createUnionTypeChecker(arrayOfTypeCheckers) {
                if (!Array.isArray(arrayOfTypeCheckers)) {
                  printWarning('Invalid argument supplied to oneOfType, expected an instance of array.');
                  return emptyFunctionThatReturnsNull;
                }
                for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                  var checker = arrayOfTypeCheckers[i];
                  if (typeof checker !== 'function') {
                    printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
                    return emptyFunctionThatReturnsNull;
                  }
                }
                function validate(props, propName, componentName, location, propFullName) {
                  var expectedTypes = [];
                  for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                    var checker = arrayOfTypeCheckers[i];
                    var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
                    if (checkerResult == null) {
                      return null;
                    }
                    if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
                      expectedTypes.push(checkerResult.data.expectedType);
                    }
                  }
                  var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
                  return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
                }
                return createChainableTypeChecker(validate);
              }
              function createNodeChecker() {
                function validate(props, propName, componentName, location, propFullName) {
                  if (!isNode(props[propName])) {
                    return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
                  }
                  return null;
                }
                return createChainableTypeChecker(validate);
              }
              function invalidValidatorError(componentName, location, propFullName, key, type) {
                return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
              }
              function createShapeTypeChecker(shapeTypes) {
                function validate(props, propName, componentName, location, propFullName) {
                  var propValue = props[propName];
                  var propType = getPropType(propValue);
                  if (propType !== 'object') {
                    return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
                  }
                  for (var key in shapeTypes) {
                    var checker = shapeTypes[key];
                    if (typeof checker !== 'function') {
                      return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                    }
                    var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                    if (error) {
                      return error;
                    }
                  }
                  return null;
                }
                return createChainableTypeChecker(validate);
              }
              function createStrictShapeTypeChecker(shapeTypes) {
                function validate(props, propName, componentName, location, propFullName) {
                  var propValue = props[propName];
                  var propType = getPropType(propValue);
                  if (propType !== 'object') {
                    return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
                  }
                  // We need to check all keys in case some are required but missing from props.
                  var allKeys = assign({}, props[propName], shapeTypes);
                  for (var key in allKeys) {
                    var checker = shapeTypes[key];
                    if (has(shapeTypes, key) && typeof checker !== 'function') {
                      return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                    }
                    if (!checker) {
                      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
                    }
                    var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                    if (error) {
                      return error;
                    }
                  }
                  return null;
                }
                return createChainableTypeChecker(validate);
              }
              function isNode(propValue) {
                switch (typeof propValue) {
                  case 'number':
                  case 'string':
                  case 'undefined':
                    return true;
                  case 'boolean':
                    return !propValue;
                  case 'object':
                    if (Array.isArray(propValue)) {
                      return propValue.every(isNode);
                    }
                    if (propValue === null || isValidElement(propValue)) {
                      return true;
                    }
                    var iteratorFn = getIteratorFn(propValue);
                    if (iteratorFn) {
                      var iterator = iteratorFn.call(propValue);
                      var step;
                      if (iteratorFn !== propValue.entries) {
                        while (!(step = iterator.next()).done) {
                          if (!isNode(step.value)) {
                            return false;
                          }
                        }
                      } else {
                        // Iterator will provide entry [k,v] tuples rather than values.
                        while (!(step = iterator.next()).done) {
                          var entry = step.value;
                          if (entry) {
                            if (!isNode(entry[1])) {
                              return false;
                            }
                          }
                        }
                      }
                    } else {
                      return false;
                    }
                    return true;
                  default:
                    return false;
                }
              }
              function isSymbol(propType, propValue) {
                // Native Symbol.
                if (propType === 'symbol') {
                  return true;
                }

                // falsy value can't be a Symbol
                if (!propValue) {
                  return false;
                }

                // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
                if (propValue['@@toStringTag'] === 'Symbol') {
                  return true;
                }

                // Fallback for non-spec compliant Symbols which are polyfilled.
                if (typeof Symbol === 'function' && propValue instanceof Symbol) {
                  return true;
                }
                return false;
              }

              // Equivalent of `typeof` but with special handling for array and regexp.
              function getPropType(propValue) {
                var propType = typeof propValue;
                if (Array.isArray(propValue)) {
                  return 'array';
                }
                if (propValue instanceof RegExp) {
                  // Old webkits (at least until Android 4.0) return 'function' rather than
                  // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
                  // passes PropTypes.object.
                  return 'object';
                }
                if (isSymbol(propType, propValue)) {
                  return 'symbol';
                }
                return propType;
              }

              // This handles more types than `getPropType`. Only used for error messages.
              // See `createPrimitiveTypeChecker`.
              function getPreciseType(propValue) {
                if (typeof propValue === 'undefined' || propValue === null) {
                  return '' + propValue;
                }
                var propType = getPropType(propValue);
                if (propType === 'object') {
                  if (propValue instanceof Date) {
                    return 'date';
                  } else if (propValue instanceof RegExp) {
                    return 'regexp';
                  }
                }
                return propType;
              }

              // Returns a string that is postfixed to a warning about an invalid type.
              // For example, "undefined" or "of type array"
              function getPostfixForTypeWarning(value) {
                var type = getPreciseType(value);
                switch (type) {
                  case 'array':
                  case 'object':
                    return 'an ' + type;
                  case 'boolean':
                  case 'date':
                  case 'regexp':
                    return 'a ' + type;
                  default:
                    return type;
                }
              }

              // Returns class name of the object, if any.
              function getClassName(propValue) {
                if (!propValue.constructor || !propValue.constructor.name) {
                  return ANONYMOUS;
                }
                return propValue.constructor.name;
              }
              ReactPropTypes.checkPropTypes = checkPropTypes;
              ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
              ReactPropTypes.PropTypes = ReactPropTypes;
              return ReactPropTypes;
            };

            /***/
          },

          /***/"./node_modules/prop-types/index.js":
          /*!******************************************!*\
            !*** ./node_modules/prop-types/index.js ***!
            \******************************************/
          /***/
          function node_modulesPropTypesIndexJs(module, __unused_webpack_exports, __webpack_require__) {
            /**
             * Copyright (c) 2013-present, Facebook, Inc.
             *
             * This source code is licensed under the MIT license found in the
             * LICENSE file in the root directory of this source tree.
             */

            {
              var ReactIs = __webpack_require__( /*! react-is */"./node_modules/react-is/index.js");

              // By explicitly using `prop-types` you are opting into new development behavior.
              // http://fb.me/prop-types-in-prod
              var throwOnDirectAccess = true;
              module.exports = __webpack_require__( /*! ./factoryWithTypeCheckers */"./node_modules/prop-types/factoryWithTypeCheckers.js")(ReactIs.isElement, throwOnDirectAccess);
            }

            /***/
          },

          /***/"./node_modules/prop-types/lib/ReactPropTypesSecret.js":
          /*!*************************************************************!*\
            !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
            \*************************************************************/
          /***/
          function node_modulesPropTypesLibReactPropTypesSecretJs(module) {
            /**
             * Copyright (c) 2013-present, Facebook, Inc.
             *
             * This source code is licensed under the MIT license found in the
             * LICENSE file in the root directory of this source tree.
             */

            var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
            module.exports = ReactPropTypesSecret;

            /***/
          },

          /***/"./node_modules/prop-types/lib/has.js":
          /*!********************************************!*\
            !*** ./node_modules/prop-types/lib/has.js ***!
            \********************************************/
          /***/
          function node_modulesPropTypesLibHasJs(module) {
            module.exports = Function.call.bind(Object.prototype.hasOwnProperty);

            /***/
          },

          /***/"./node_modules/react-is/cjs/react-is.development.js":
          /*!***********************************************************!*\
            !*** ./node_modules/react-is/cjs/react-is.development.js ***!
            \***********************************************************/
          /***/
          function node_modulesReactIsCjsReactIsDevelopmentJs(__unused_webpack_module, exports) {
            /** @license React v16.13.1
             * react-is.development.js
             *
             * Copyright (c) Facebook, Inc. and its affiliates.
             *
             * This source code is licensed under the MIT license found in the
             * LICENSE file in the root directory of this source tree.
             */

            {
              (function () {
                // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
                // nor polyfill, then a plain number is used for performance.
                var hasSymbol = typeof Symbol === 'function' && Symbol.for;
                var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
                var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
                var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
                var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
                var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
                var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
                var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
                // (unstable) APIs that have been removed. Can we remove the symbols?

                var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
                var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
                var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
                var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
                var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
                var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
                var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
                var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
                var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
                var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
                var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
                function isValidElementType(type) {
                  return typeof type === 'string' || typeof type === 'function' ||
                  // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
                }
                function typeOf(object) {
                  if (typeof object === 'object' && object !== null) {
                    var $$typeof = object.$$typeof;
                    switch ($$typeof) {
                      case REACT_ELEMENT_TYPE:
                        var type = object.type;
                        switch (type) {
                          case REACT_ASYNC_MODE_TYPE:
                          case REACT_CONCURRENT_MODE_TYPE:
                          case REACT_FRAGMENT_TYPE:
                          case REACT_PROFILER_TYPE:
                          case REACT_STRICT_MODE_TYPE:
                          case REACT_SUSPENSE_TYPE:
                            return type;
                          default:
                            var $$typeofType = type && type.$$typeof;
                            switch ($$typeofType) {
                              case REACT_CONTEXT_TYPE:
                              case REACT_FORWARD_REF_TYPE:
                              case REACT_LAZY_TYPE:
                              case REACT_MEMO_TYPE:
                              case REACT_PROVIDER_TYPE:
                                return $$typeofType;
                              default:
                                return $$typeof;
                            }
                        }
                      case REACT_PORTAL_TYPE:
                        return $$typeof;
                    }
                  }
                  return undefined;
                } // AsyncMode is deprecated along with isAsyncMode

                var AsyncMode = REACT_ASYNC_MODE_TYPE;
                var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
                var ContextConsumer = REACT_CONTEXT_TYPE;
                var ContextProvider = REACT_PROVIDER_TYPE;
                var Element = REACT_ELEMENT_TYPE;
                var ForwardRef = REACT_FORWARD_REF_TYPE;
                var Fragment = REACT_FRAGMENT_TYPE;
                var Lazy = REACT_LAZY_TYPE;
                var Memo = REACT_MEMO_TYPE;
                var Portal = REACT_PORTAL_TYPE;
                var Profiler = REACT_PROFILER_TYPE;
                var StrictMode = REACT_STRICT_MODE_TYPE;
                var Suspense = REACT_SUSPENSE_TYPE;
                var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

                function isAsyncMode(object) {
                  {
                    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
                      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

                      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
                    }
                  }
                  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
                }
                function isConcurrentMode(object) {
                  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
                }
                function isContextConsumer(object) {
                  return typeOf(object) === REACT_CONTEXT_TYPE;
                }
                function isContextProvider(object) {
                  return typeOf(object) === REACT_PROVIDER_TYPE;
                }
                function isElement(object) {
                  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
                }
                function isForwardRef(object) {
                  return typeOf(object) === REACT_FORWARD_REF_TYPE;
                }
                function isFragment(object) {
                  return typeOf(object) === REACT_FRAGMENT_TYPE;
                }
                function isLazy(object) {
                  return typeOf(object) === REACT_LAZY_TYPE;
                }
                function isMemo(object) {
                  return typeOf(object) === REACT_MEMO_TYPE;
                }
                function isPortal(object) {
                  return typeOf(object) === REACT_PORTAL_TYPE;
                }
                function isProfiler(object) {
                  return typeOf(object) === REACT_PROFILER_TYPE;
                }
                function isStrictMode(object) {
                  return typeOf(object) === REACT_STRICT_MODE_TYPE;
                }
                function isSuspense(object) {
                  return typeOf(object) === REACT_SUSPENSE_TYPE;
                }
                exports.AsyncMode = AsyncMode;
                exports.ConcurrentMode = ConcurrentMode;
                exports.ContextConsumer = ContextConsumer;
                exports.ContextProvider = ContextProvider;
                exports.Element = Element;
                exports.ForwardRef = ForwardRef;
                exports.Fragment = Fragment;
                exports.Lazy = Lazy;
                exports.Memo = Memo;
                exports.Portal = Portal;
                exports.Profiler = Profiler;
                exports.StrictMode = StrictMode;
                exports.Suspense = Suspense;
                exports.isAsyncMode = isAsyncMode;
                exports.isConcurrentMode = isConcurrentMode;
                exports.isContextConsumer = isContextConsumer;
                exports.isContextProvider = isContextProvider;
                exports.isElement = isElement;
                exports.isForwardRef = isForwardRef;
                exports.isFragment = isFragment;
                exports.isLazy = isLazy;
                exports.isMemo = isMemo;
                exports.isPortal = isPortal;
                exports.isProfiler = isProfiler;
                exports.isStrictMode = isStrictMode;
                exports.isSuspense = isSuspense;
                exports.isValidElementType = isValidElementType;
                exports.typeOf = typeOf;
              })();
            }

            /***/
          },

          /***/"./node_modules/react-is/index.js":
          /*!****************************************!*\
            !*** ./node_modules/react-is/index.js ***!
            \****************************************/
          /***/
          function node_modulesReactIsIndexJs(module, __unused_webpack_exports, __webpack_require__) {
            {
              module.exports = __webpack_require__( /*! ./cjs/react-is.development.js */"./node_modules/react-is/cjs/react-is.development.js");
            }

            /***/
          },

          /***/"./node_modules/shallow-equal/dist/index.esm.js":
          /*!******************************************************!*\
            !*** ./node_modules/shallow-equal/dist/index.esm.js ***!
            \******************************************************/
          /***/
          function node_modulesShallowEqualDistIndexEsmJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            /* harmony export */
            __webpack_require__.d(__webpack_exports__, {
              /* harmony export */"shallowEqualArrays": function shallowEqualArrays() {
                return (/* binding */_shallowEqualArrays
                );
              },
              /* harmony export */"shallowEqualObjects": function shallowEqualObjects() {
                return (/* binding */_shallowEqualObjects
                );
              }
              /* harmony export */
            });
            function _shallowEqualObjects(objA, objB) {
              if (objA === objB) {
                return true;
              }
              if (!objA || !objB) {
                return false;
              }
              var aKeys = Object.keys(objA);
              var bKeys = Object.keys(objB);
              var len = aKeys.length;
              if (bKeys.length !== len) {
                return false;
              }
              for (var i = 0; i < len; i++) {
                var key = aKeys[i];
                if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) {
                  return false;
                }
              }
              return true;
            }
            function _shallowEqualArrays(arrA, arrB) {
              if (arrA === arrB) {
                return true;
              }
              if (!arrA || !arrB) {
                return false;
              }
              var len = arrA.length;
              if (arrB.length !== len) {
                return false;
              }
              for (var i = 0; i < len; i++) {
                if (arrA[i] !== arrB[i]) {
                  return false;
                }
              }
              return true;
            }

            /***/
          },

          /***/"./src/Component.ts":
          /*!**************************!*\
            !*** ./src/Component.ts ***!
            \**************************/
          /***/
          function srcComponentTs(__unused_webpack_module, exports, __webpack_require__) {
            var __rest = this && this.__rest || function (s, e) {
              var t = {};
              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
              }
              if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
              }
              return t;
            };
            var __importDefault = this && this.__importDefault || function (mod) {
              return mod && mod.__esModule ? mod : {
                "default": mod
              };
            };
            Object.defineProperty(exports, "__esModule", {
              value: true
            });
            var useMediaQuery_1 = __importDefault(__webpack_require__( /*! ./useMediaQuery */"./src/useMediaQuery.ts"));
            // ReactNode and ReactElement typings are a little funky for functional components, so the ReactElement cast is needed on the return
            var MediaQuery = function MediaQuery(_a) {
              var children = _a.children,
                device = _a.device,
                onChange = _a.onChange,
                settings = __rest(_a, ["children", "device", "onChange"]);
              var matches = (0, useMediaQuery_1.default)(settings, device, onChange);
              if (typeof children === 'function') {
                return children(matches);
              }
              return matches ? children : null;
            };
            exports["default"] = MediaQuery;

            /***/
          },

          /***/"./src/Context.ts":
          /*!************************!*\
            !*** ./src/Context.ts ***!
            \************************/
          /***/
          function srcContextTs(__unused_webpack_module, exports, __webpack_require__) {
            Object.defineProperty(exports, "__esModule", {
              value: true
            });
            var react_1 = __webpack_require__( /*! react */"react");
            var Context = (0, react_1.createContext)(undefined);
            exports["default"] = Context;

            /***/
          },

          /***/"./src/index.ts":
          /*!**********************!*\
            !*** ./src/index.ts ***!
            \**********************/
          /***/
          function srcIndexTs(__unused_webpack_module, exports, __webpack_require__) {
            var __importDefault = this && this.__importDefault || function (mod) {
              return mod && mod.__esModule ? mod : {
                "default": mod
              };
            };
            Object.defineProperty(exports, "__esModule", {
              value: true
            });
            exports.Context = exports.toQuery = exports.useMediaQuery = exports["default"] = void 0;
            var useMediaQuery_1 = __importDefault(__webpack_require__( /*! ./useMediaQuery */"./src/useMediaQuery.ts"));
            exports.useMediaQuery = useMediaQuery_1.default;
            var Component_1 = __importDefault(__webpack_require__( /*! ./Component */"./src/Component.ts"));
            exports["default"] = Component_1.default;
            var toQuery_1 = __importDefault(__webpack_require__( /*! ./toQuery */"./src/toQuery.ts"));
            exports.toQuery = toQuery_1.default;
            var Context_1 = __importDefault(__webpack_require__( /*! ./Context */"./src/Context.ts"));
            exports.Context = Context_1.default;

            /***/
          },

          /***/"./src/mediaQuery.ts":
          /*!***************************!*\
            !*** ./src/mediaQuery.ts ***!
            \***************************/
          /***/
          function srcMediaQueryTs(__unused_webpack_module, exports, __webpack_require__) {
            var __assign = this && this.__assign || function () {
              __assign = Object.assign || function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                  s = arguments[i];
                  for (var p in s) {
                    if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                  }
                }
                return t;
              };
              return __assign.apply(this, arguments);
            };
            var __rest = this && this.__rest || function (s, e) {
              var t = {};
              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
              }
              if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
              }
              return t;
            };
            var __importDefault = this && this.__importDefault || function (mod) {
              return mod && mod.__esModule ? mod : {
                "default": mod
              };
            };
            Object.defineProperty(exports, "__esModule", {
              value: true
            });
            var prop_types_1 = __importDefault(__webpack_require__( /*! prop-types */"./node_modules/prop-types/index.js"));
            var stringOrNumber = prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]);
            // media types
            var types = {
              all: prop_types_1.default.bool,
              grid: prop_types_1.default.bool,
              aural: prop_types_1.default.bool,
              braille: prop_types_1.default.bool,
              handheld: prop_types_1.default.bool,
              print: prop_types_1.default.bool,
              projection: prop_types_1.default.bool,
              screen: prop_types_1.default.bool,
              tty: prop_types_1.default.bool,
              tv: prop_types_1.default.bool,
              embossed: prop_types_1.default.bool
            };
            // properties that match media queries
            var matchers = {
              orientation: prop_types_1.default.oneOf(['portrait', 'landscape']),
              scan: prop_types_1.default.oneOf(['progressive', 'interlace']),
              aspectRatio: prop_types_1.default.string,
              deviceAspectRatio: prop_types_1.default.string,
              height: stringOrNumber,
              deviceHeight: stringOrNumber,
              width: stringOrNumber,
              deviceWidth: stringOrNumber,
              color: prop_types_1.default.bool,
              colorIndex: prop_types_1.default.bool,
              monochrome: prop_types_1.default.bool,
              resolution: stringOrNumber,
              type: Object.keys(types)
            };
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            matchers.type;
            var featureMatchers = __rest(matchers
            // media features
            , ["type"]);
            // media features
            var features = __assign({
              minAspectRatio: prop_types_1.default.string,
              maxAspectRatio: prop_types_1.default.string,
              minDeviceAspectRatio: prop_types_1.default.string,
              maxDeviceAspectRatio: prop_types_1.default.string,
              minHeight: stringOrNumber,
              maxHeight: stringOrNumber,
              minDeviceHeight: stringOrNumber,
              maxDeviceHeight: stringOrNumber,
              minWidth: stringOrNumber,
              maxWidth: stringOrNumber,
              minDeviceWidth: stringOrNumber,
              maxDeviceWidth: stringOrNumber,
              minColor: prop_types_1.default.number,
              maxColor: prop_types_1.default.number,
              minColorIndex: prop_types_1.default.number,
              maxColorIndex: prop_types_1.default.number,
              minMonochrome: prop_types_1.default.number,
              maxMonochrome: prop_types_1.default.number,
              minResolution: stringOrNumber,
              maxResolution: stringOrNumber
            }, featureMatchers);
            var all = __assign(__assign({}, types), features);
            exports["default"] = {
              all: all,
              types: types,
              matchers: matchers,
              features: features
            };

            /***/
          },

          /***/"./src/toQuery.ts":
          /*!************************!*\
            !*** ./src/toQuery.ts ***!
            \************************/
          /***/
          function srcToQueryTs(__unused_webpack_module, exports, __webpack_require__) {
            var __importDefault = this && this.__importDefault || function (mod) {
              return mod && mod.__esModule ? mod : {
                "default": mod
              };
            };
            Object.defineProperty(exports, "__esModule", {
              value: true
            });
            var hyphenate_style_name_1 = __importDefault(__webpack_require__( /*! hyphenate-style-name */"./node_modules/hyphenate-style-name/index.js"));
            var mediaQuery_1 = __importDefault(__webpack_require__( /*! ./mediaQuery */"./src/mediaQuery.ts"));
            var negate = function negate(cond) {
              return "not ".concat(cond);
            };
            var keyVal = function keyVal(k, v) {
              var realKey = (0, hyphenate_style_name_1.default)(k);
              // px shorthand
              if (typeof v === 'number') {
                v = "".concat(v, "px");
              }
              if (v === true) {
                return realKey;
              }
              if (v === false) {
                return negate(realKey);
              }
              return "(".concat(realKey, ": ").concat(v, ")");
            };
            var join = function join(conds) {
              return conds.join(' and ');
            };
            var toQuery = function toQuery(obj) {
              var rules = [];
              Object.keys(mediaQuery_1.default.all).forEach(function (k) {
                var v = obj[k];
                if (v != null) {
                  rules.push(keyVal(k, v));
                }
              });
              return join(rules);
            };
            exports["default"] = toQuery;

            /***/
          },

          /***/"./src/useMediaQuery.ts":
          /*!******************************!*\
            !*** ./src/useMediaQuery.ts ***!
            \******************************/
          /***/
          function srcUseMediaQueryTs(__unused_webpack_module, exports, __webpack_require__) {
            var __importDefault = this && this.__importDefault || function (mod) {
              return mod && mod.__esModule ? mod : {
                "default": mod
              };
            };
            Object.defineProperty(exports, "__esModule", {
              value: true
            });
            var react_1 = __webpack_require__( /*! react */"react");
            var matchmediaquery_1 = __importDefault(__webpack_require__( /*! matchmediaquery */"./node_modules/matchmediaquery/index.js"));
            var hyphenate_style_name_1 = __importDefault(__webpack_require__( /*! hyphenate-style-name */"./node_modules/hyphenate-style-name/index.js"));
            var shallow_equal_1 = __webpack_require__( /*! shallow-equal */"./node_modules/shallow-equal/dist/index.esm.js");
            var toQuery_1 = __importDefault(__webpack_require__( /*! ./toQuery */"./src/toQuery.ts"));
            var Context_1 = __importDefault(__webpack_require__( /*! ./Context */"./src/Context.ts"));
            var makeQuery = function makeQuery(settings) {
              return settings.query || (0, toQuery_1.default)(settings);
            };
            var hyphenateKeys = function hyphenateKeys(obj) {
              if (!obj) return undefined;
              var keys = Object.keys(obj);
              return keys.reduce(function (result, key) {
                result[(0, hyphenate_style_name_1.default)(key)] = obj[key];
                return result;
              }, {});
            };
            var useIsUpdate = function useIsUpdate() {
              var ref = (0, react_1.useRef)(false);
              (0, react_1.useEffect)(function () {
                ref.current = true;
              }, []);
              return ref.current;
            };
            var useDevice = function useDevice(deviceFromProps) {
              var deviceFromContext = (0, react_1.useContext)(Context_1.default);
              var getDevice = function getDevice() {
                return hyphenateKeys(deviceFromProps) || hyphenateKeys(deviceFromContext);
              };
              var _a = (0, react_1.useState)(getDevice),
                device = _a[0],
                setDevice = _a[1];
              (0, react_1.useEffect)(function () {
                var newDevice = getDevice();
                if (!(0, shallow_equal_1.shallowEqualObjects)(device, newDevice)) {
                  setDevice(newDevice);
                }
              }, [deviceFromProps, deviceFromContext]);
              return device;
            };
            var useQuery = function useQuery(settings) {
              var getQuery = function getQuery() {
                return makeQuery(settings);
              };
              var _a = (0, react_1.useState)(getQuery),
                query = _a[0],
                setQuery = _a[1];
              (0, react_1.useEffect)(function () {
                var newQuery = getQuery();
                if (query !== newQuery) {
                  setQuery(newQuery);
                }
              }, [settings]);
              return query;
            };
            var useMatchMedia = function useMatchMedia(query, device) {
              var getMatchMedia = function getMatchMedia() {
                return (0, matchmediaquery_1.default)(query, device || {}, !!device);
              };
              var _a = (0, react_1.useState)(getMatchMedia),
                mq = _a[0],
                setMq = _a[1];
              var isUpdate = useIsUpdate();
              (0, react_1.useEffect)(function () {
                if (isUpdate) {
                  // skip on mounting, it has already been set
                  var newMq_1 = getMatchMedia();
                  setMq(newMq_1);
                  return function () {
                    if (newMq_1) {
                      newMq_1.dispose();
                    }
                  };
                }
              }, [query, device]);
              return mq;
            };
            var useMatches = function useMatches(mediaQuery) {
              var _a = (0, react_1.useState)(mediaQuery.matches),
                matches = _a[0],
                setMatches = _a[1];
              (0, react_1.useEffect)(function () {
                var updateMatches = function updateMatches(ev) {
                  setMatches(ev.matches);
                };
                mediaQuery.addListener(updateMatches);
                setMatches(mediaQuery.matches);
                return function () {
                  mediaQuery.removeListener(updateMatches);
                };
              }, [mediaQuery]);
              return matches;
            };
            var useMediaQuery = function useMediaQuery(settings, device, onChange) {
              var deviceSettings = useDevice(device);
              var query = useQuery(settings);
              if (!query) throw new Error('Invalid or missing MediaQuery!');
              var mq = useMatchMedia(query, deviceSettings);
              var matches = useMatches(mq);
              var isUpdate = useIsUpdate();
              (0, react_1.useEffect)(function () {
                if (isUpdate && onChange) {
                  onChange(matches);
                }
              }, [matches]);
              (0, react_1.useEffect)(function () {
                return function () {
                  if (mq) {
                    mq.dispose();
                  }
                };
              }, []);
              return matches;
            };
            exports["default"] = useMediaQuery;

            /***/
          },

          /***/"react":
          /*!**************************************************************************************!*\
            !*** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"} ***!
            \**************************************************************************************/
          /***/
          function react(module) {
            module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

            /***/
          }

          /******/
        };
        /************************************************************************/
        /******/ // The module cache
        /******/
        var __webpack_module_cache__ = {};
        /******/
        /******/ // The require function
        /******/
        function __webpack_require__(moduleId) {
          /******/ // Check if module is in cache
          /******/var cachedModule = __webpack_module_cache__[moduleId];
          /******/
          if (cachedModule !== undefined) {
            /******/return cachedModule.exports;
            /******/
          }
          /******/ // Create a new module (and put it into the cache)
          /******/
          var module = __webpack_module_cache__[moduleId] = {
            /******/ // no module.id needed
            /******/ // no module.loaded needed
            /******/exports: {}
            /******/
          };
          /******/
          /******/ // Execute the module function
          /******/
          __webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
          /******/
          /******/ // Return the exports of the module
          /******/
          return module.exports;
          /******/
        }
        /******/
        /************************************************************************/
        /******/ /* webpack/runtime/define property getters */
        /******/
        (function () {
          /******/ // define getter functions for harmony exports
          /******/__webpack_require__.d = function (exports, definition) {
            /******/for (var key in definition) {
              /******/if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
                /******/Object.defineProperty(exports, key, {
                  enumerable: true,
                  get: definition[key]
                });
                /******/
              }
              /******/
            }
            /******/
          };
          /******/
        })();
        /******/
        /******/ /* webpack/runtime/hasOwnProperty shorthand */
        /******/
        (function () {
          /******/__webpack_require__.o = function (obj, prop) {
            return Object.prototype.hasOwnProperty.call(obj, prop);
          };
          /******/
        })();
        /******/
        /******/ /* webpack/runtime/make namespace object */
        /******/
        (function () {
          /******/ // define __esModule on exports
          /******/__webpack_require__.r = function (exports) {
            /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
              /******/Object.defineProperty(exports, Symbol.toStringTag, {
                value: 'Module'
              });
              /******/
            }
            /******/
            Object.defineProperty(exports, '__esModule', {
              value: true
            });
            /******/
          };
          /******/
        })();
        /******/
        /************************************************************************/
        /******/
        /******/ // startup
        /******/ // Load entry module and return exports
        /******/ // This entry module is referenced by other modules so it can't be inlined
        /******/
        var __webpack_exports__ = __webpack_require__("./src/index.ts");
        /******/
        /******/
        return __webpack_exports__;
        /******/
      }()
    );
  });
})(reactResponsive);
var projectConfig = {
  mediaUrl: process.env.GATSBY_MEDIA_URL || process.env.MEDIA_URL || process.env.NEXT_PUBLIC_MEDIA_URL || "https://p-media.vitl.com/"
};
var styles$s = {
  "blur": "image-module_blur__Je0ym"
};
var DEFAULT_IMAGE_WIDTH = 2000;
var Image = function Image(_a) {
  var filename = _a.filename,
    filenameTablet = _a.filenameTablet,
    filenameMobile = _a.filenameMobile,
    url = _a.url,
    _b = _a.width,
    width = _b === void 0 ? 2000 : _b,
    height = _a.height,
    alt = _a.alt,
    _c = _a.className,
    className = _c === void 0 ? "" : _c,
    hideOnDesktop = _a.hideOnDesktop,
    hideOnTablet = _a.hideOnTablet,
    hideOnMobile = _a.hideOnMobile,
    hideBiggerThenMobile = _a.hideBiggerThenMobile,
    mediaUrl = _a.mediaUrl,
    noBlurLoading = _a.noBlurLoading;
  var _d = useState(noBlurLoading ? true : false),
    loadedSrc = _d[0],
    setLoadedSrc = _d[1];
  var onImageLoad = function onImageLoad() {
    return setLoadedSrc(true);
  };
  var isDesktop = reactResponsiveExports.useMediaQuery({
    query: "(min-width: 992px)"
  });
  var isTablet = reactResponsiveExports.useMediaQuery({
    query: "(max-width: 991px)"
  });
  var isMobile = reactResponsiveExports.useMediaQuery({
    query: "(max-width: 767px)"
  });
  if (hideOnDesktop && isDesktop) return null; // hide desktop
  if (hideOnTablet && isTablet) return null; // hide tablet and mobile
  if (hideBiggerThenMobile && !isMobile) return null; // hide tablet and desktop
  if (hideOnMobile && isMobile) return null; // hide mobile
  var getImageFilename = function getImageFilename() {
    if (isMobile && filenameMobile) return filenameMobile;
    if (isTablet && filenameTablet) return filenameTablet;
    return filename;
  };
  var getImageSize = function getImageSize() {
    var imageSize = width > 767 ? 767 : width;
    if (isTablet) imageSize = width > 992 ? 992 : width;
    if (isDesktop) imageSize = width > 1280 ? 1280 : width;
    return imageSize;
  };
  var getImageSizeRatio = function getImageSizeRatio(imageSize, ratio) {
    var imageSizeRatio = imageSize * ratio;
    return imageSizeRatio > DEFAULT_IMAGE_WIDTH ? DEFAULT_IMAGE_WIDTH : imageSizeRatio;
  };
  var pixelization = 100;
  var imgPath = url || "".concat(mediaUrl || projectConfig.mediaUrl).concat(getImageFilename());
  var imageWidth = getImageSize();
  return url ? React.createElement("img", {
    "data-testid": "image",
    style: _assign$({
      display: "inline-block",
      maxHeight: height ? "".concat(height, "px") : "auto"
    }, height ? {
      objectFit: "cover"
    } : {}),
    width: imageWidth,
    height: height,
    className: className,
    src: url,
    alt: alt,
    decoding: "async"
  }) : React.createElement(React.Fragment, null, React.createElement("img", {
    style: !loadedSrc ? {
      display: "block"
    } : {
      display: "none"
    },
    className: styles$s.blur,
    width: imageWidth,
    src: "".concat(imgPath, "?w=").concat(pixelization),
    "data-testid": "image-placeholder",
    alt: alt
  }), React.createElement("img", {
    "data-testid": "image",
    style: loadedSrc ? _assign$({
      display: "inline-block",
      maxHeight: height ? "".concat(height, "px") : "auto"
    }, height ? {
      objectFit: "cover"
    } : {}) : {
      display: "none"
    },
    width: imageWidth,
    height: height,
    onLoad: onImageLoad,
    className: className,
    src: "".concat(imgPath, "?w=").concat(imageWidth),
    srcSet: "\n        ".concat(imgPath, "?w=").concat(imageWidth, ",\n        ").concat(imgPath, "?w=").concat(getImageSizeRatio(imageWidth, 2), " 2x, \n        ").concat(imgPath, "?w=").concat(getImageSizeRatio(imageWidth, 3), " 3x\n      "),
    sizes: "\n        (max-width: 420px) 420px,\n        (max-width: 768px) 768px,\n        (max-width: 1280px) 1280px,\n        ".concat(imageWidth, "px\n      "),
    alt: alt,
    decoding: "async"
  }));
};

/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */
/* eslint-disable no-param-reassign */
function isObject$2(obj) {
  return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function extend$2() {
  var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var src = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Object.keys(src).forEach(function (key) {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject$2(src[key]) && isObject$2(target[key]) && Object.keys(src[key]).length > 0) {
      extend$2(target[key], src[key]);
    }
  });
}
var ssrDocument = {
  body: {},
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  activeElement: {
    blur: function blur() {},
    nodeName: ''
  },
  querySelector: function querySelector() {
    return null;
  },
  querySelectorAll: function querySelectorAll() {
    return [];
  },
  getElementById: function getElementById() {
    return null;
  },
  createEvent: function createEvent() {
    return {
      initEvent: function initEvent() {}
    };
  },
  createElement: function createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute: function setAttribute() {},
      getElementsByTagName: function getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS: function createElementNS() {
    return {};
  },
  importNode: function importNode() {
    return null;
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  }
};
function getDocument() {
  var doc = typeof document !== 'undefined' ? document : {};
  extend$2(doc, ssrDocument);
  return doc;
}
var ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ''
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  },
  history: {
    replaceState: function replaceState() {},
    pushState: function pushState() {},
    go: function go() {},
    back: function back() {}
  },
  CustomEvent: function CustomEvent() {
    return this;
  },
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  getComputedStyle: function getComputedStyle() {
    return {
      getPropertyValue: function getPropertyValue() {
        return '';
      }
    };
  },
  Image: function Image() {},
  Date: function Date() {},
  screen: {},
  setTimeout: function setTimeout() {},
  clearTimeout: function clearTimeout() {},
  matchMedia: function matchMedia() {
    return {};
  },
  requestAnimationFrame: function requestAnimationFrame(callback) {
    if (typeof setTimeout === 'undefined') {
      callback();
      return null;
    }
    return setTimeout(callback, 0);
  },
  cancelAnimationFrame: function cancelAnimationFrame(id) {
    if (typeof setTimeout === 'undefined') {
      return;
    }
    clearTimeout(id);
  }
};
function getWindow() {
  var win = typeof window !== 'undefined' ? window : {};
  extend$2(win, ssrWindow);
  return win;
}

/**
 * Dom7 4.0.4
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2022, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: January 11, 2022
 */

/* eslint-disable no-proto */
function makeReactive(obj) {
  var proto = obj.__proto__;
  Object.defineProperty(obj, '__proto__', {
    get: function get() {
      return proto;
    },
    set: function set(value) {
      proto.__proto__ = value;
    }
  });
}
var Dom7 = /*#__PURE__*/function (_Array) {
  _inherits(Dom7, _Array);
  var _super = _createSuper(Dom7);
  function Dom7(items) {
    var _this5;
    _classCallCheck(this, Dom7);
    if (typeof items === 'number') {
      _this5 = _super.call(this, items);
    } else {
      _this5 = _super.call.apply(_super, [this].concat(_toConsumableArray(items || [])));
      makeReactive(_assertThisInitialized2(_this5));
    }
    return _possibleConstructorReturn(_this5);
  }
  return _createClass(Dom7);
}( /*#__PURE__*/_wrapNativeSuper(Array));
function arrayFlat() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var res = [];
  arr.forEach(function (el) {
    if (Array.isArray(el)) {
      res.push.apply(res, _toConsumableArray(arrayFlat(el)));
    } else {
      res.push(el);
    }
  });
  return res;
}
function arrayFilter(arr, callback) {
  return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
  var uniqueArray = [];
  for (var i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }
  return uniqueArray;
}

// eslint-disable-next-line

function qsa(selector, context) {
  if (typeof selector !== 'string') {
    return [selector];
  }
  var a = [];
  var res = context.querySelectorAll(selector);
  for (var i = 0; i < res.length; i += 1) {
    a.push(res[i]);
  }
  return a;
}
function $(selector, context) {
  var window = getWindow();
  var document = getDocument();
  var arr = [];
  if (!context && selector instanceof Dom7) {
    return selector;
  }
  if (!selector) {
    return new Dom7(arr);
  }
  if (typeof selector === 'string') {
    var _html = selector.trim();
    if (_html.indexOf('<') >= 0 && _html.indexOf('>') >= 0) {
      var toCreate = 'div';
      if (_html.indexOf('<li') === 0) toCreate = 'ul';
      if (_html.indexOf('<tr') === 0) toCreate = 'tbody';
      if (_html.indexOf('<td') === 0 || _html.indexOf('<th') === 0) toCreate = 'tr';
      if (_html.indexOf('<tbody') === 0) toCreate = 'table';
      if (_html.indexOf('<option') === 0) toCreate = 'select';
      var tempParent = document.createElement(toCreate);
      tempParent.innerHTML = _html;
      for (var i = 0; i < tempParent.childNodes.length; i += 1) {
        arr.push(tempParent.childNodes[i]);
      }
    } else {
      arr = qsa(selector.trim(), context || document);
    } // arr = qsa(selector, document);
  } else if (selector.nodeType || selector === window || selector === document) {
    arr.push(selector);
  } else if (Array.isArray(selector)) {
    if (selector instanceof Dom7) return selector;
    arr = selector;
  }
  return new Dom7(arrayUnique(arr));
}
$.fn = Dom7.prototype;

// eslint-disable-next-line

function addClass$1() {
  for (var _len8 = arguments.length, classes = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    classes[_key8] = arguments[_key8];
  }
  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    var _el$classList;
    (_el$classList = el.classList).add.apply(_el$classList, _toConsumableArray(classNames));
  });
  return this;
}
function removeClass$2() {
  for (var _len9 = arguments.length, classes = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    classes[_key9] = arguments[_key9];
  }
  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    var _el$classList2;
    (_el$classList2 = el.classList).remove.apply(_el$classList2, _toConsumableArray(classNames));
  });
  return this;
}
function toggleClass() {
  for (var _len10 = arguments.length, classes = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
    classes[_key10] = arguments[_key10];
  }
  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    classNames.forEach(function (className) {
      el.classList.toggle(className);
    });
  });
}
function hasClass$1() {
  for (var _len11 = arguments.length, classes = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
    classes[_key11] = arguments[_key11];
  }
  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  return arrayFilter(this, function (el) {
    return classNames.filter(function (className) {
      return el.classList.contains(className);
    }).length > 0;
  }).length > 0;
}
function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  } // Set attrs

  for (var i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      for (var attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }
  return this;
}
function removeAttr(attr) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }
  return this;
}
function transform(transform) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.transform = transform;
  }
  return this;
}
function transition$1(duration) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.transitionDuration = typeof duration !== 'string' ? "".concat(duration, "ms") : duration;
  }
  return this;
}
function on() {
  for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
    args[_key12] = arguments[_key12];
  }
  var eventType = args[0],
    targetSelector = args[1],
    listener = args[2],
    capture = args[3];
  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }
  if (!capture) capture = false;
  function handleLiveEvent(e) {
    var target = e.target;
    if (!target) return;
    var eventData = e.target.dom7EventData || [];
    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }
    if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
      var _parents = $(target).parents(); // eslint-disable-line

      for (var k = 0; k < _parents.length; k += 1) {
        if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
      }
    }
  }
  function handleEvent(e) {
    var eventData = e && e.target ? e.target.dom7EventData || [] : [];
    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }
    listener.apply(this, eventData);
  }
  var events = eventType.split(' ');
  var j;
  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];
    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        var event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener: listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        var _event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];
        el.dom7LiveListeners[_event].push({
          listener: listener,
          proxyListener: handleLiveEvent
        });
        el.addEventListener(_event, handleLiveEvent, capture);
      }
    }
  }
  return this;
}
function off() {
  for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
    args[_key13] = arguments[_key13];
  }
  var eventType = args[0],
    targetSelector = args[1],
    listener = args[2],
    capture = args[3];
  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }
  if (!capture) capture = false;
  var events = eventType.split(' ');
  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];
    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];
      var handlers = void 0;
      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }
      if (handlers && handlers.length) {
        for (var k = handlers.length - 1; k >= 0; k -= 1) {
          var handler = handlers[k];
          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }
  return this;
}
function trigger() {
  var window = getWindow();
  for (var _len14 = arguments.length, args = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
    args[_key14] = arguments[_key14];
  }
  var events = args[0].split(' ');
  var eventData = args[1];
  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];
    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];
      if (window.CustomEvent) {
        var evt = new window.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true
        });
        el.dom7EventData = args.filter(function (data, dataIndex) {
          return dataIndex > 0;
        });
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
  }
  return this;
}
function transitionEnd$1(callback) {
  var dom = this;
  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('transitionend', fireCallBack);
  }
  if (callback) {
    dom.on('transitionend', fireCallBack);
  }
  return this;
}
function outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      var _styles = this.styles();
      return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
    }
    return this[0].offsetWidth;
  }
  return null;
}
function outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      var _styles2 = this.styles();
      return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
    }
    return this[0].offsetHeight;
  }
  return null;
}
function offset() {
  if (this.length > 0) {
    var _window = getWindow();
    var _document = getDocument();
    var el = this[0];
    var box = el.getBoundingClientRect();
    var body = _document.body;
    var clientTop = el.clientTop || body.clientTop || 0;
    var clientLeft = el.clientLeft || body.clientLeft || 0;
    var scrollTop = el === _window ? _window.scrollY : el.scrollTop;
    var scrollLeft = el === _window ? _window.scrollX : el.scrollLeft;
    return {
      top: box.top + scrollTop - clientTop,
      left: box.left + scrollLeft - clientLeft
    };
  }
  return null;
}
function styles$r() {
  var window = getWindow();
  if (this[0]) return window.getComputedStyle(this[0], null);
  return {};
}
function css(props, value) {
  var window = getWindow();
  var i;
  if (arguments.length === 1) {
    if (typeof props === 'string') {
      // .css('width')
      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      // .css({ width: '100px' })
      for (i = 0; i < this.length; i += 1) {
        for (var prop in props) {
          this[i].style[prop] = props[prop];
        }
      }
      return this;
    }
  }
  if (arguments.length === 2 && typeof props === 'string') {
    // .css('width', '100px')
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }
    return this;
  }
  return this;
}
function each(callback) {
  if (!callback) return this;
  this.forEach(function (el, index) {
    callback.apply(el, [el, index]);
  });
  return this;
}
function filter(callback) {
  var result = arrayFilter(this, callback);
  return $(result);
}
function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : null;
  }
  for (var i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }
  return this;
}
function text(text) {
  if (typeof text === 'undefined') {
    return this[0] ? this[0].textContent.trim() : null;
  }
  for (var i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }
  return this;
}
function is(selector) {
  var window = getWindow();
  var document = getDocument();
  var el = this[0];
  var compareWith;
  var i;
  if (!el || typeof selector === 'undefined') return false;
  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);
    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
    compareWith = $(selector);
    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }
    return false;
  }
  if (selector === document) {
    return el === document;
  }
  if (selector === window) {
    return el === window;
  }
  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;
    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }
    return false;
  }
  return false;
}
function index() {
  var child = this[0];
  var i;
  if (child) {
    i = 0; // eslint-disable-next-line

    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }
    return i;
  }
  return undefined;
}
function eq(index) {
  if (typeof index === 'undefined') return this;
  var length = this.length;
  if (index > length - 1) {
    return $([]);
  }
  if (index < 0) {
    var returnIndex = length + index;
    if (returnIndex < 0) return $([]);
    return $([this[returnIndex]]);
  }
  return $([this[index]]);
}
function append() {
  var newChild;
  var document = getDocument();
  for (var k = 0; k < arguments.length; k += 1) {
    newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];
    for (var i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = newChild;
        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (var j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }
  return this;
}
function prepend(newChild) {
  var document = getDocument();
  var i;
  var j;
  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = newChild;
      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }
  return this;
}
function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
        return $([this[0].nextElementSibling]);
      }
      return $([]);
    }
    if (this[0].nextElementSibling) return $([this[0].nextElementSibling]);
    return $([]);
  }
  return $([]);
}
function nextAll(selector) {
  var nextEls = [];
  var el = this[0];
  if (!el) return $([]);
  while (el.nextElementSibling) {
    var _next = el.nextElementSibling; // eslint-disable-line

    if (selector) {
      if ($(_next).is(selector)) nextEls.push(_next);
    } else nextEls.push(_next);
    el = _next;
  }
  return $(nextEls);
}
function prev(selector) {
  if (this.length > 0) {
    var el = this[0];
    if (selector) {
      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
        return $([el.previousElementSibling]);
      }
      return $([]);
    }
    if (el.previousElementSibling) return $([el.previousElementSibling]);
    return $([]);
  }
  return $([]);
}
function prevAll(selector) {
  var prevEls = [];
  var el = this[0];
  if (!el) return $([]);
  while (el.previousElementSibling) {
    var _prev = el.previousElementSibling; // eslint-disable-line

    if (selector) {
      if ($(_prev).is(selector)) prevEls.push(_prev);
    } else prevEls.push(_prev);
    el = _prev;
  }
  return $(prevEls);
}
function parent(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }
  return $(parents);
}
function parents(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var _parent = this[i].parentNode; // eslint-disable-line

    while (_parent) {
      if (selector) {
        if ($(_parent).is(selector)) parents.push(_parent);
      } else {
        parents.push(_parent);
      }
      _parent = _parent.parentNode;
    }
  }
  return $(parents);
}
function closest(selector) {
  var closest = this; // eslint-disable-line

  if (typeof selector === 'undefined') {
    return $([]);
  }
  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }
  return closest;
}
function find(selector) {
  var foundElements = [];
  for (var i = 0; i < this.length; i += 1) {
    var found = this[i].querySelectorAll(selector);
    for (var j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }
  return $(foundElements);
}
function children(selector) {
  var children = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var childNodes = this[i].children;
    for (var j = 0; j < childNodes.length; j += 1) {
      if (!selector || $(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }
  return $(children);
}
function remove() {
  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }
  return this;
}
var Methods = {
  addClass: addClass$1,
  removeClass: removeClass$2,
  hasClass: hasClass$1,
  toggleClass: toggleClass,
  attr: attr,
  removeAttr: removeAttr,
  transform: transform,
  transition: transition$1,
  on: on,
  off: off,
  trigger: trigger,
  transitionEnd: transitionEnd$1,
  outerWidth: outerWidth,
  outerHeight: outerHeight,
  styles: styles$r,
  offset: offset,
  css: css,
  each: each,
  html: html,
  text: text,
  is: is,
  index: index,
  eq: eq,
  append: append,
  prepend: prepend,
  next: next,
  nextAll: nextAll,
  prev: prev,
  prevAll: prevAll,
  parent: parent,
  parents: parents,
  closest: closest,
  find: find,
  children: children,
  filter: filter,
  remove: remove
};
Object.keys(Methods).forEach(function (methodName) {
  Object.defineProperty($.fn, methodName, {
    value: Methods[methodName],
    writable: true
  });
});
function deleteProps(obj) {
  var object = obj;
  Object.keys(object).forEach(function (key) {
    try {
      object[key] = null;
    } catch (e) {// no getter for object
    }
    try {
      delete object[key];
    } catch (e) {// something got wrong
    }
  });
}
function nextTick(callback) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return setTimeout(callback, delay);
}
function now() {
  return Date.now();
}
function getComputedStyle$1(el) {
  var window = getWindow();
  var style;
  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }
  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }
  if (!style) {
    style = el.style;
  }
  return style;
}
function getTranslate(el) {
  var axis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';
  var window = getWindow();
  var matrix;
  var curTransform;
  var transformMatrix;
  var curStyle = getComputedStyle$1(el);
  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;
    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(function (a) {
        return a.replace(',', '.');
      }).join(', ');
    } // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case

    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }
  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
    else curTransform = parseFloat(matrix[4]);
  }
  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
    else curTransform = parseFloat(matrix[5]);
  }
  return curTransform || 0;
}
function isObject$1(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function isNode(node) {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
    return node instanceof HTMLElement;
  }
  return node && (node.nodeType === 1 || node.nodeType === 11);
}
function extend$1() {
  var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
  var noExtend = ['__proto__', 'constructor', 'prototype'];
  for (var i = 1; i < arguments.length; i += 1) {
    var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
      var keysArray = Object.keys(Object(nextSource)).filter(function (key) {
        return noExtend.indexOf(key) < 0;
      });
      for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        var nextKey = keysArray[nextIndex];
        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
        if (desc !== undefined && desc.enumerable) {
          if (isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
            to[nextKey] = {};
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }
  return to;
}
function setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}
function animateCSSModeScroll(_ref5) {
  var swiper = _ref5.swiper,
    targetPosition = _ref5.targetPosition,
    side = _ref5.side;
  var window = getWindow();
  var startPosition = -swiper.translate;
  var startTime = null;
  var time;
  var duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = 'none';
  window.cancelAnimationFrame(swiper.cssModeFrameID);
  var dir = targetPosition > startPosition ? 'next' : 'prev';
  var isOutOfBound = function isOutOfBound(current, target) {
    return dir === 'next' && current >= target || dir === 'prev' && current <= target;
  };
  var animate = function animate() {
    time = new Date().getTime();
    if (startTime === null) {
      startTime = time;
    }
    var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
    var easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    var currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }
    swiper.wrapperEl.scrollTo(_defineProperty({}, side, currentPosition));
    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.scrollSnapType = '';
      setTimeout(function () {
        swiper.wrapperEl.style.overflow = '';
        swiper.wrapperEl.scrollTo(_defineProperty({}, side, currentPosition));
      });
      window.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }
    swiper.cssModeFrameID = window.requestAnimationFrame(animate);
  };
  animate();
}
var support;
function calcSupport() {
  var window = getWindow();
  var document = getDocument();
  return {
    smoothScroll: document.documentElement && 'scrollBehavior' in document.documentElement.style,
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
    passiveListener: function checkPassiveListener() {
      var supportsPassive = false;
      try {
        var opts = Object.defineProperty({}, 'passive', {
          // eslint-disable-next-line
          get: function get() {
            supportsPassive = true;
          }
        });
        window.addEventListener('testPassiveListener', null, opts);
      } catch (e) {// No support
      }
      return supportsPassive;
    }(),
    gestures: function checkGestures() {
      return 'ongesturestart' in window;
    }()
  };
}
function getSupport() {
  if (!support) {
    support = calcSupport();
  }
  return support;
}
var deviceCached;
function calcDevice() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    userAgent = _ref6.userAgent;
  var support = getSupport();
  var window = getWindow();
  var platform = window.navigator.platform;
  var ua = userAgent || window.navigator.userAgent;
  var device = {
    ios: false,
    android: false
  };
  var screenWidth = window.screen.width;
  var screenHeight = window.screen.height;
  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  var windows = platform === 'Win32';
  var macos = platform === 'MacIntel'; // iPadOs 13 fix

  var iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];
  if (!ipad && macos && support.touch && iPadScreens.indexOf("".concat(screenWidth, "x").concat(screenHeight)) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  } // Android

  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }
  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  } // Export object

  return device;
}
function getDevice() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }
  return deviceCached;
}
var browser;
function calcBrowser() {
  var window = getWindow();
  function isSafari() {
    var ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }
  return {
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
  };
}
function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }
  return browser;
}
function Resize(_ref7) {
  var swiper = _ref7.swiper,
    on = _ref7.on,
    emit = _ref7.emit;
  var window = getWindow();
  var observer = null;
  var animationFrame = null;
  var resizeHandler = function resizeHandler() {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('beforeResize');
    emit('resize');
  };
  var createObserver = function createObserver() {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    observer = new ResizeObserver(function (entries) {
      animationFrame = window.requestAnimationFrame(function () {
        var width = swiper.width,
          height = swiper.height;
        var newWidth = width;
        var newHeight = height;
        entries.forEach(function (_ref8) {
          var contentBoxSize = _ref8.contentBoxSize,
            contentRect = _ref8.contentRect,
            target = _ref8.target;
          if (target && target !== swiper.el) return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });
        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer.observe(swiper.el);
  };
  var removeObserver = function removeObserver() {
    if (animationFrame) {
      window.cancelAnimationFrame(animationFrame);
    }
    if (observer && observer.unobserve && swiper.el) {
      observer.unobserve(swiper.el);
      observer = null;
    }
  };
  var orientationChangeHandler = function orientationChangeHandler() {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('orientationchange');
  };
  on('init', function () {
    if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
      createObserver();
      return;
    }
    window.addEventListener('resize', resizeHandler);
    window.addEventListener('orientationchange', orientationChangeHandler);
  });
  on('destroy', function () {
    removeObserver();
    window.removeEventListener('resize', resizeHandler);
    window.removeEventListener('orientationchange', orientationChangeHandler);
  });
}
function Observer(_ref9) {
  var swiper = _ref9.swiper,
    extendParams = _ref9.extendParams,
    on = _ref9.on,
    emit = _ref9.emit;
  var observers = [];
  var window = getWindow();
  var attach = function attach(target) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    var observer = new ObserverFunc(function (mutations) {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (mutations.length === 1) {
        emit('observerUpdate', mutations[0]);
        return;
      }
      var observerUpdate = function observerUpdate() {
        emit('observerUpdate', mutations[0]);
      };
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    observers.push(observer);
  };
  var init = function init() {
    if (!swiper.params.observer) return;
    if (swiper.params.observeParents) {
      var containerParents = swiper.$el.parents();
      for (var i = 0; i < containerParents.length; i += 1) {
        attach(containerParents[i]);
      }
    } // Observe container

    attach(swiper.$el[0], {
      childList: swiper.params.observeSlideChildren
    }); // Observe wrapper

    attach(swiper.$wrapperEl[0], {
      attributes: false
    });
  };
  var destroy = function destroy() {
    observers.forEach(function (observer) {
      observer.disconnect();
    });
    observers.splice(0, observers.length);
  };
  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on('init', init);
  on('destroy', destroy);
}

/* eslint-disable no-underscore-dangle */
var eventsEmitter = {
  on: function on(events, handler, priority) {
    var self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(function (event) {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },
  once: function once(events, handler, priority) {
    var self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    function onceHandler() {
      self.off(events, onceHandler);
      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }
      for (var _len15 = arguments.length, args = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
        args[_key15] = arguments[_key15];
      }
      handler.apply(self, args);
    }
    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },
  onAny: function onAny(handler, priority) {
    var self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';
    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }
    return self;
  },
  offAny: function offAny(handler) {
    var self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsAnyListeners) return self;
    var index = self.eventsAnyListeners.indexOf(handler);
    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }
    return self;
  },
  off: function off(events, handler) {
    var self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(function (event) {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(function (eventHandler, index) {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },
  emit: function emit() {
    var self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    var events;
    var data;
    var context;
    for (var _len16 = arguments.length, args = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
      args[_key16] = arguments[_key16];
    }
    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }
    data.unshift(context);
    var eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(function (event) {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(function (eventHandler) {
          eventHandler.apply(context, [event].concat(_toConsumableArray(data)));
        });
      }
      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(function (eventHandler) {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }
};
function updateSize() {
  var swiper = this;
  var width;
  var height;
  var $el = swiper.$el;
  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }
  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }
  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  } // Subtract paddings

  width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
  height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  Object.assign(swiper, {
    width: width,
    height: height,
    size: swiper.isHorizontal() ? width : height
  });
}
function updateSlides() {
  var swiper = this;
  function getDirectionLabel(property) {
    if (swiper.isHorizontal()) {
      return property;
    } // prettier-ignore

    return {
      'width': 'height',
      'margin-top': 'margin-left',
      'margin-bottom ': 'margin-right',
      'margin-left': 'margin-top',
      'margin-right': 'margin-bottom',
      'padding-left': 'padding-top',
      'padding-right': 'padding-bottom',
      'marginRight': 'marginBottom'
    }[property];
  }
  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
  }
  var params = swiper.params;
  var $wrapperEl = swiper.$wrapperEl,
    swiperSize = swiper.size,
    rtl = swiper.rtlTranslate,
    wrongRTL = swiper.wrongRTL;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  var slides = $wrapperEl.children(".".concat(swiper.params.slideClass));
  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  var snapGrid = [];
  var slidesGrid = [];
  var slidesSizesGrid = [];
  var offsetBefore = params.slidesOffsetBefore;
  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }
  var offsetAfter = params.slidesOffsetAfter;
  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }
  var previousSnapGridLength = swiper.snapGrid.length;
  var previousSlidesGridLength = swiper.slidesGrid.length;
  var spaceBetween = params.spaceBetween;
  var slidePosition = -offsetBefore;
  var prevSlideSize = 0;
  var index = 0;
  if (typeof swiperSize === 'undefined') {
    return;
  }
  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  }
  swiper.virtualSize = -spaceBetween; // reset margins

  if (rtl) slides.css({
    marginLeft: '',
    marginBottom: '',
    marginTop: ''
  });else slides.css({
    marginRight: '',
    marginBottom: '',
    marginTop: ''
  }); // reset cssMode offsets

  if (params.centeredSlides && params.cssMode) {
    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-before', '');
    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-after', '');
  }
  var gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
  if (gridEnabled) {
    swiper.grid.initSlides(slidesLength);
  } // Calc slides

  var slideSize;
  var shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(function (key) {
    return typeof params.breakpoints[key].slidesPerView !== 'undefined';
  }).length > 0;
  for (var i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    var _slide = slides.eq(i);
    if (gridEnabled) {
      swiper.grid.updateSlide(i, _slide, slidesLength, getDirectionLabel);
    }
    if (_slide.css('display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      if (shouldResetSlideSize) {
        slides[i].style[getDirectionLabel('width')] = "";
      }
      var slideStyles = getComputedStyle(_slide[0]);
      var currentTransform = _slide[0].style.transform;
      var currentWebKitTransform = _slide[0].style.webkitTransform;
      if (currentTransform) {
        _slide[0].style.transform = 'none';
      }
      if (currentWebKitTransform) {
        _slide[0].style.webkitTransform = 'none';
      }
      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? _slide.outerWidth(true) : _slide.outerHeight(true);
      } else {
        // eslint-disable-next-line
        var width = getDirectionPropertyValue(slideStyles, 'width');
        var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        var boxSizing = slideStyles.getPropertyValue('box-sizing');
        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          var _slide$ = _slide[0],
            clientWidth = _slide$.clientWidth,
            offsetWidth = _slide$.offsetWidth;
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }
      if (currentTransform) {
        _slide[0].style.transform = currentTransform;
      }
      if (currentWebKitTransform) {
        _slide[0].style.webkitTransform = currentWebKitTransform;
      }
      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);
      if (slides[i]) {
        slides[i].style[getDirectionLabel('width')] = "".concat(slideSize, "px");
      }
    }
    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }
    slidesSizesGrid.push(slideSize);
    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }
    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }
  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    $wrapperEl.css({
      width: "".concat(swiper.virtualSize + params.spaceBetween, "px")
    });
  }
  if (params.setWrapperSize) {
    $wrapperEl.css(_defineProperty({}, getDirectionLabel('width'), "".concat(swiper.virtualSize + params.spaceBetween, "px")));
  }
  if (gridEnabled) {
    swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
  } // Remove last grid elements depending on width

  if (!params.centeredSlides) {
    var newSlidesGrid = [];
    for (var _i = 0; _i < snapGrid.length; _i += 1) {
      var slidesGridItem = snapGrid[_i];
      if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
      if (snapGrid[_i] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }
    snapGrid = newSlidesGrid;
    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }
  if (snapGrid.length === 0) snapGrid = [0];
  if (params.spaceBetween !== 0) {
    var key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
    slides.filter(function (_, slideIndex) {
      if (!params.cssMode) return true;
      if (slideIndex === slides.length - 1) {
        return false;
      }
      return true;
    }).css(_defineProperty({}, key, "".concat(spaceBetween, "px")));
  }
  if (params.centeredSlides && params.centeredSlidesBounds) {
    var allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    var maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map(function (snap) {
      if (snap < 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }
  if (params.centerInsufficientSlides) {
    var _allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      _allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    _allSlidesSize -= params.spaceBetween;
    if (_allSlidesSize < swiperSize) {
      var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
      snapGrid.forEach(function (snap, snapIndex) {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach(function (snap, snapIndex) {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }
  Object.assign(swiper, {
    slides: slides,
    snapGrid: snapGrid,
    slidesGrid: slidesGrid,
    slidesSizesGrid: slidesSizesGrid
  });
  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-before', "".concat(-snapGrid[0], "px"));
    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-after', "".concat(swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2, "px"));
    var addToSnapGrid = -swiper.snapGrid[0];
    var addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map(function (v) {
      return v + addToSnapGrid;
    });
    swiper.slidesGrid = swiper.slidesGrid.map(function (v) {
      return v + addToSlidesGrid;
    });
  }
  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }
  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }
  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
    var backFaceHiddenClass = "".concat(params.containerModifierClass, "backface-hidden");
    var hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);
    if (slidesLength <= params.maxBackfaceHiddenSlides) {
      if (!hasClassBackfaceClassAdded) swiper.$el.addClass(backFaceHiddenClass);
    } else if (hasClassBackfaceClassAdded) {
      swiper.$el.removeClass(backFaceHiddenClass);
    }
  }
}
function updateAutoHeight(speed) {
  var swiper = this;
  var activeSlides = [];
  var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  var newHeight = 0;
  var i;
  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }
  var getSlideByIndex = function getSlideByIndex(index) {
    if (isVirtual) {
      return swiper.slides.filter(function (el) {
        return parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index;
      })[0];
    }
    return swiper.slides.eq(index)[0];
  }; // Find slides currently in view

  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      (swiper.visibleSlides || $([])).each(function (slide) {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        var _index = swiper.activeIndex + i;
        if (_index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(_index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  } // Find new height from highest slide in view

  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      var _height = activeSlides[i].offsetHeight;
      newHeight = _height > newHeight ? _height : newHeight;
    }
  } // Update Height

  if (newHeight || newHeight === 0) swiper.$wrapperEl.css('height', "".concat(newHeight, "px"));
}
function updateSlidesOffset() {
  var swiper = this;
  var slides = swiper.slides;
  for (var i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}
function updateSlidesProgress() {
  var translate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this && this.translate || 0;
  var swiper = this;
  var params = swiper.params;
  var slides = swiper.slides,
    rtl = swiper.rtlTranslate,
    snapGrid = swiper.snapGrid;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  var offsetCenter = -translate;
  if (rtl) offsetCenter = translate; // Visible Slides

  slides.removeClass(params.slideVisibleClass);
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];
  for (var i = 0; i < slides.length; i += 1) {
    var _slide2 = slides[i];
    var slideOffset = _slide2.swiperSlideOffset;
    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }
    var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (_slide2.swiperSlideSize + params.spaceBetween);
    var originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (_slide2.swiperSlideSize + params.spaceBetween);
    var slideBefore = -(offsetCenter - slideOffset);
    var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
    var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
    if (isVisible) {
      swiper.visibleSlides.push(_slide2);
      swiper.visibleSlidesIndexes.push(i);
      slides.eq(i).addClass(params.slideVisibleClass);
    }
    _slide2.progress = rtl ? -slideProgress : slideProgress;
    _slide2.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }
  swiper.visibleSlides = $(swiper.visibleSlides);
}
function updateProgress(translate) {
  var swiper = this;
  if (typeof translate === 'undefined') {
    var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }
  var params = swiper.params;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  var progress = swiper.progress,
    isBeginning = swiper.isBeginning,
    isEnd = swiper.isEnd;
  var wasBeginning = isBeginning;
  var wasEnd = isEnd;
  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }
  Object.assign(swiper, {
    progress: progress,
    isBeginning: isBeginning,
    isEnd: isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }
  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }
  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }
  swiper.emit('progress', progress);
}
function updateSlidesClasses() {
  var swiper = this;
  var slides = swiper.slides,
    params = swiper.params,
    $wrapperEl = swiper.$wrapperEl,
    activeIndex = swiper.activeIndex,
    realIndex = swiper.realIndex;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  slides.removeClass("".concat(params.slideActiveClass, " ").concat(params.slideNextClass, " ").concat(params.slidePrevClass, " ").concat(params.slideDuplicateActiveClass, " ").concat(params.slideDuplicateNextClass, " ").concat(params.slideDuplicatePrevClass));
  var activeSlide;
  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find(".".concat(params.slideClass, "[data-swiper-slide-index=\"").concat(activeIndex, "\"]"));
  } else {
    activeSlide = slides.eq(activeIndex);
  } // Active classes

  activeSlide.addClass(params.slideActiveClass);
  if (params.loop) {
    // Duplicate to all looped slides
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ")[data-swiper-slide-index=\"").concat(realIndex, "\"]")).addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(realIndex, "\"]")).addClass(params.slideDuplicateActiveClass);
    }
  } // Next Slide

  var nextSlide = activeSlide.nextAll(".".concat(params.slideClass)).eq(0).addClass(params.slideNextClass);
  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  } // Prev Slide

  var prevSlide = activeSlide.prevAll(".".concat(params.slideClass)).eq(0).addClass(params.slidePrevClass);
  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }
  if (params.loop) {
    // Duplicate to all looped slides
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ")[data-swiper-slide-index=\"").concat(nextSlide.attr('data-swiper-slide-index'), "\"]")).addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(nextSlide.attr('data-swiper-slide-index'), "\"]")).addClass(params.slideDuplicateNextClass);
    }
    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ")[data-swiper-slide-index=\"").concat(prevSlide.attr('data-swiper-slide-index'), "\"]")).addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(prevSlide.attr('data-swiper-slide-index'), "\"]")).addClass(params.slideDuplicatePrevClass);
    }
  }
  swiper.emitSlidesClasses();
}
function updateActiveIndex(newActiveIndex) {
  var swiper = this;
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  var slidesGrid = swiper.slidesGrid,
    snapGrid = swiper.snapGrid,
    params = swiper.params,
    previousIndex = swiper.activeIndex,
    previousRealIndex = swiper.realIndex,
    previousSnapIndex = swiper.snapIndex;
  var activeIndex = newActiveIndex;
  var snapIndex;
  if (typeof activeIndex === 'undefined') {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate >= slidesGrid[i]) {
        activeIndex = i;
      }
    } // Normalize slideIndex

    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
  }
  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }
    return;
  } // Get real index

  var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
  Object.assign(swiper, {
    snapIndex: snapIndex,
    realIndex: realIndex,
    previousIndex: previousIndex,
    activeIndex: activeIndex
  });
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');
  if (previousRealIndex !== realIndex) {
    swiper.emit('realIndexChange');
  }
  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    swiper.emit('slideChange');
  }
}
function updateClickedSlide(e) {
  var swiper = this;
  var params = swiper.params;
  var slide = $(e).closest(".".concat(params.slideClass))[0];
  var slideFound = false;
  var slideIndex;
  if (slide) {
    for (var i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }
  if (slide && slideFound) {
    swiper.clickedSlide = slide;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }
  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}
var update = {
  updateSize: updateSize,
  updateSlides: updateSlides,
  updateAutoHeight: updateAutoHeight,
  updateSlidesOffset: updateSlidesOffset,
  updateSlidesProgress: updateSlidesProgress,
  updateProgress: updateProgress,
  updateSlidesClasses: updateSlidesClasses,
  updateActiveIndex: updateActiveIndex,
  updateClickedSlide: updateClickedSlide
};
function getSwiperTranslate() {
  var axis = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.isHorizontal() ? 'x' : 'y';
  var swiper = this;
  var params = swiper.params,
    rtl = swiper.rtlTranslate,
    translate = swiper.translate,
    $wrapperEl = swiper.$wrapperEl;
  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }
  if (params.cssMode) {
    return translate;
  }
  var currentTranslate = getTranslate($wrapperEl[0], axis);
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}
function setTranslate(translate, byController) {
  var swiper = this;
  var rtl = swiper.rtlTranslate,
    params = swiper.params,
    $wrapperEl = swiper.$wrapperEl,
    wrapperEl = swiper.wrapperEl,
    progress = swiper.progress;
  var x = 0;
  var y = 0;
  var z = 0;
  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }
  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }
  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    $wrapperEl.transform("translate3d(".concat(x, "px, ").concat(y, "px, ").concat(z, "px)"));
  }
  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }
  swiper.emit('setTranslate', swiper.translate, byController);
}
function minTranslate() {
  return -this.snapGrid[0];
}
function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function translateTo() {
  var translate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.params.speed;
  var runCallbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var translateBounds = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var internal = arguments.length > 4 ? arguments[4] : undefined;
  var swiper = this;
  var params = swiper.params,
    wrapperEl = swiper.wrapperEl;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }
  var minTranslate = swiper.minTranslate();
  var maxTranslate = swiper.maxTranslate();
  var newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

  swiper.updateProgress(newTranslate);
  if (params.cssMode) {
    var isH = swiper.isHorizontal();
    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      var _wrapperEl$scrollTo;
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper: swiper,
          targetPosition: -newTranslate,
          side: isH ? 'left' : 'top'
        });
        return true;
      }
      wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _defineProperty(_wrapperEl$scrollTo, isH ? 'left' : 'top', -newTranslate), _defineProperty(_wrapperEl$scrollTo, "behavior", 'smooth'), _wrapperEl$scrollTo));
    }
    return true;
  }
  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }
    if (!swiper.animating) {
      swiper.animating = true;
      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;
          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }
      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
    }
  }
  return true;
}
var translate = {
  getTranslate: getSwiperTranslate,
  setTranslate: setTranslate,
  minTranslate: minTranslate,
  maxTranslate: maxTranslate,
  translateTo: translateTo
};
function setTransition(duration, byController) {
  var swiper = this;
  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }
  swiper.emit('setTransition', duration, byController);
}
function transitionEmit(_ref10) {
  var swiper = _ref10.swiper,
    runCallbacks = _ref10.runCallbacks,
    direction = _ref10.direction,
    step = _ref10.step;
  var activeIndex = swiper.activeIndex,
    previousIndex = swiper.previousIndex;
  var dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }
  swiper.emit("transition".concat(step));
  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit("slideResetTransition".concat(step));
      return;
    }
    swiper.emit("slideChangeTransition".concat(step));
    if (dir === 'next') {
      swiper.emit("slideNextTransition".concat(step));
    } else {
      swiper.emit("slidePrevTransition".concat(step));
    }
  }
}
function transitionStart() {
  var runCallbacks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var direction = arguments.length > 1 ? arguments[1] : undefined;
  var swiper = this;
  var params = swiper.params;
  if (params.cssMode) return;
  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }
  transitionEmit({
    swiper: swiper,
    runCallbacks: runCallbacks,
    direction: direction,
    step: 'Start'
  });
}
function transitionEnd() {
  var runCallbacks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var direction = arguments.length > 1 ? arguments[1] : undefined;
  var swiper = this;
  var params = swiper.params;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  transitionEmit({
    swiper: swiper,
    runCallbacks: runCallbacks,
    direction: direction,
    step: 'End'
  });
}
var transition = {
  setTransition: setTransition,
  transitionStart: transitionStart,
  transitionEnd: transitionEnd
};
function slideTo() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.params.speed;
  var runCallbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var internal = arguments.length > 3 ? arguments[3] : undefined;
  var initial = arguments.length > 4 ? arguments[4] : undefined;
  if (typeof index !== 'number' && typeof index !== 'string') {
    throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [".concat(typeof index, "] given."));
  }
  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    var indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    var isValidNumber = isFinite(indexAsNumber);
    if (!isValidNumber) {
      throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [".concat(index, "] given."));
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.

    index = indexAsNumber;
  }
  var swiper = this;
  var slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  var params = swiper.params,
    snapGrid = swiper.snapGrid,
    slidesGrid = swiper.slidesGrid,
    previousIndex = swiper.previousIndex,
    activeIndex = swiper.activeIndex,
    rtl = swiper.rtlTranslate,
    wrapperEl = swiper.wrapperEl,
    enabled = swiper.enabled;
  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
    return false;
  }
  var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  var translate = -snapGrid[snapIndex]; // Normalize slideIndex

  if (params.normalizeSlideIndex) {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      var normalizedTranslate = -Math.floor(translate * 100);
      var normalizedGrid = Math.floor(slidesGrid[i] * 100);
      var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i;
      }
    }
  } // Directions locks

  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
      return false;
    }
    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) return false;
    }
  }
  if (slideIndex !== (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  } // Update progress

  swiper.updateProgress(translate);
  var direction;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex); // Update Height

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    swiper.updateSlidesClasses();
    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }
    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }
    return false;
  }
  if (params.cssMode) {
    var isH = swiper.isHorizontal();
    var t = rtl ? translate : -translate;
    if (speed === 0) {
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      if (isVirtual) {
        swiper.wrapperEl.style.scrollSnapType = 'none';
        swiper._immediateVirtual = true;
      }
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
      if (isVirtual) {
        requestAnimationFrame(function () {
          swiper.wrapperEl.style.scrollSnapType = '';
          swiper._swiperImmediateVirtual = false;
        });
      }
    } else {
      var _wrapperEl$scrollTo2;
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper: swiper,
          targetPosition: t,
          side: isH ? 'left' : 'top'
        });
        return true;
      }
      wrapperEl.scrollTo((_wrapperEl$scrollTo2 = {}, _defineProperty(_wrapperEl$scrollTo2, isH ? 'left' : 'top', t), _defineProperty(_wrapperEl$scrollTo2, "behavior", 'smooth'), _wrapperEl$scrollTo2));
    }
    return true;
  }
  swiper.setTransition(speed);
  swiper.setTranslate(translate);
  swiper.updateActiveIndex(slideIndex);
  swiper.updateSlidesClasses();
  swiper.emit('beforeTransitionStart', speed, internal);
  swiper.transitionStart(runCallbacks, direction);
  if (speed === 0) {
    swiper.transitionEnd(runCallbacks, direction);
  } else if (!swiper.animating) {
    swiper.animating = true;
    if (!swiper.onSlideToWrapperTransitionEnd) {
      swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
        if (!swiper || swiper.destroyed) return;
        if (e.target !== this) return;
        swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
        swiper.onSlideToWrapperTransitionEnd = null;
        delete swiper.onSlideToWrapperTransitionEnd;
        swiper.transitionEnd(runCallbacks, direction);
      };
    }
    swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
  }
  return true;
}
function slideToLoop() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.params.speed;
  var runCallbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var internal = arguments.length > 3 ? arguments[3] : undefined;
  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    var indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    var isValidNumber = isFinite(indexAsNumber);
    if (!isValidNumber) {
      throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [".concat(index, "] given."));
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.

    index = indexAsNumber;
  }
  var swiper = this;
  var newIndex = index;
  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }
  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideNext() {
  var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
  var runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var internal = arguments.length > 2 ? arguments[2] : undefined;
  var swiper = this;
  var animating = swiper.animating,
    enabled = swiper.enabled,
    params = swiper.params;
  if (!enabled) return swiper;
  var perGroup = params.slidesPerGroup;
  if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
  }
  var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }
  if (params.rewind && swiper.isEnd) {
    return swiper.slideTo(0, speed, runCallbacks, internal);
  }
  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slidePrev() {
  var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
  var runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var internal = arguments.length > 2 ? arguments[2] : undefined;
  var swiper = this;
  var params = swiper.params,
    animating = swiper.animating,
    snapGrid = swiper.snapGrid,
    slidesGrid = swiper.slidesGrid,
    rtlTranslate = swiper.rtlTranslate,
    enabled = swiper.enabled;
  if (!enabled) return swiper;
  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }
  var translate = rtlTranslate ? swiper.translate : -swiper.translate;
  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }
  var normalizedTranslate = normalize(translate);
  var normalizedSnapGrid = snapGrid.map(function (val) {
    return normalize(val);
  });
  var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
  if (typeof prevSnap === 'undefined' && params.cssMode) {
    var prevSnapIndex;
    snapGrid.forEach(function (snap, snapIndex) {
      if (normalizedTranslate >= snap) {
        // prevSnap = snap;
        prevSnapIndex = snapIndex;
      }
    });
    if (typeof prevSnapIndex !== 'undefined') {
      prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }
  var prevIndex = 0;
  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }
  if (params.rewind && swiper.isBeginning) {
    var lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
  }
  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideReset() {
  var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
  var runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var internal = arguments.length > 2 ? arguments[2] : undefined;
  var swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideToClosest() {
  var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
  var runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var internal = arguments.length > 2 ? arguments[2] : undefined;
  var threshold = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.5;
  var swiper = this;
  var index = swiper.activeIndex;
  var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    var currentSnap = swiper.snapGrid[snapIndex];
    var nextSnap = swiper.snapGrid[snapIndex + 1];
    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    var prevSnap = swiper.snapGrid[snapIndex - 1];
    var _currentSnap = swiper.snapGrid[snapIndex];
    if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }
  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}
function slideToClickedSlide() {
  var swiper = this;
  var params = swiper.params,
    $wrapperEl = swiper.$wrapperEl;
  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  var slideToIndex = swiper.clickedIndex;
  var realIndex;
  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children(".".concat(params.slideClass, "[data-swiper-slide-index=\"").concat(realIndex, "\"]:not(.").concat(params.slideDuplicateClass, ")")).eq(0).index();
        nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl.children(".".concat(params.slideClass, "[data-swiper-slide-index=\"").concat(realIndex, "\"]:not(.").concat(params.slideDuplicateClass, ")")).eq(0).index();
      nextTick(function () {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}
var slide = {
  slideTo: slideTo,
  slideToLoop: slideToLoop,
  slideNext: slideNext,
  slidePrev: slidePrev,
  slideReset: slideReset,
  slideToClosest: slideToClosest,
  slideToClickedSlide: slideToClickedSlide
};
function loopCreate() {
  var swiper = this;
  var document = getDocument();
  var params = swiper.params,
    $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides

  var $selector = $wrapperEl.children().length > 0 ? $($wrapperEl.children()[0].parentNode) : $wrapperEl;
  $selector.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass)).remove();
  var slides = $selector.children(".".concat(params.slideClass));
  if (params.loopFillGroupWithBlank) {
    var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
    if (blankSlidesNum !== params.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankNode = $(document.createElement('div')).addClass("".concat(params.slideClass, " ").concat(params.slideBlankClass));
        $selector.append(blankNode);
      }
      slides = $selector.children(".".concat(params.slideClass));
    }
  }
  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
  swiper.loopedSlides += params.loopAdditionalSlides;
  if (swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit) {
    swiper.loopedSlides = slides.length;
  }
  var prependSlides = [];
  var appendSlides = [];
  slides.each(function (el, index) {
    var slide = $(el);
    slide.attr('data-swiper-slide-index', index);
  });
  for (var _i2 = 0; _i2 < swiper.loopedSlides; _i2 += 1) {
    var _index2 = _i2 - Math.floor(_i2 / slides.length) * slides.length;
    appendSlides.push(slides.eq(_index2)[0]);
    prependSlides.unshift(slides.eq(slides.length - _index2 - 1)[0]);
  }
  for (var _i3 = 0; _i3 < appendSlides.length; _i3 += 1) {
    $selector.append($(appendSlides[_i3].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
  for (var _i4 = prependSlides.length - 1; _i4 >= 0; _i4 -= 1) {
    $selector.prepend($(prependSlides[_i4].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}
function loopFix() {
  var swiper = this;
  swiper.emit('beforeLoopFix');
  var activeIndex = swiper.activeIndex,
    slides = swiper.slides,
    loopedSlides = swiper.loopedSlides,
    allowSlidePrev = swiper.allowSlidePrev,
    allowSlideNext = swiper.allowSlideNext,
    snapGrid = swiper.snapGrid,
    rtl = swiper.rtlTranslate;
  var newIndex;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  var snapTranslate = -snapGrid[activeIndex];
  var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

  if (activeIndex < loopedSlides) {
    newIndex = slides.length - loopedSlides * 3 + activeIndex;
    newIndex += loopedSlides;
    var slideChanged = swiper.slideTo(newIndex, 0, false, true);
    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (activeIndex >= slides.length - loopedSlides) {
    // Fix For Positive Oversliding
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;
    var _slideChanged = swiper.slideTo(newIndex, 0, false, true);
    if (_slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  swiper.emit('loopFix');
}
function loopDestroy() {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
    params = swiper.params,
    slides = swiper.slides;
  $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, ",.").concat(params.slideClass, ".").concat(params.slideBlankClass)).remove();
  slides.removeAttr('data-swiper-slide-index');
}
var loop = {
  loopCreate: loopCreate,
  loopFix: loopFix,
  loopDestroy: loopDestroy
};
function setGrabCursor(moving) {
  var swiper = this;
  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  var el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
  el.style.cursor = 'move';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}
function unsetGrabCursor() {
  var swiper = this;
  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }
  swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
}
var grabCursor = {
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
};
function closestElement(selector) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
  function __closestFrom(el) {
    if (!el || el === getDocument() || el === getWindow()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    var found = el.closest(selector);
    if (!found && !el.getRootNode) {
      return null;
    }
    return found || __closestFrom(el.getRootNode().host);
  }
  return __closestFrom(base);
}
function onTouchStart(event) {
  var swiper = this;
  var document = getDocument();
  var window = getWindow();
  var data = swiper.touchEventsData;
  var params = swiper.params,
    touches = swiper.touches,
    enabled = swiper.enabled;
  if (!enabled) return;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }
  if (!swiper.animating && params.cssMode && params.loop) {
    swiper.loopFix();
  }
  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  var $targetEl = $(e.target);
  if (params.touchEventsTarget === 'wrapper') {
    if (!$targetEl.closest(swiper.wrapperEl).length) return;
  }
  data.isTouchEvent = e.type === 'touchstart';
  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return; // change target el for shadow root component

  var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== ''; // eslint-disable-next-line

  var eventPath = event.composedPath ? event.composedPath() : event.path;
  if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
    $targetEl = $(eventPath[0]);
  }
  var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : ".".concat(params.noSwipingClass);
  var isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element

  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
    swiper.allowClick = true;
    return;
  }
  if (params.swipeHandler) {
    if (!$targetEl.closest(params.swipeHandler)[0]) return;
  }
  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  var startX = touches.currentX;
  var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
    } else {
      return;
    }
  }
  Object.assign(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;
  if (e.type !== 'touchstart') {
    var preventDefault = true;
    if ($targetEl.is(data.focusableElements)) {
      preventDefault = false;
      if ($targetEl[0].nodeName === 'SELECT') {
        data.isTouched = false;
      }
    }
    if (document.activeElement && $(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
      document.activeElement.blur();
    }
    var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
      e.preventDefault();
    }
  }
  if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
    swiper.freeMode.onTouchStart();
  }
  swiper.emit('touchStart', e);
}
function onTouchMove(event) {
  var document = getDocument();
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
    touches = swiper.touches,
    rtl = swiper.rtlTranslate,
    enabled = swiper.enabled;
  if (!enabled) return;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }
    return;
  }
  if (data.isTouchEvent && e.type !== 'touchmove') return;
  var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
  var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
  var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }
  if (!swiper.allowTouchMove) {
    if (!$(e.target).is(data.focusableElements)) {
      swiper.allowClick = false;
    }
    if (data.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = now();
    }
    return;
  }
  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }
  if (data.isTouchEvent && document.activeElement) {
    if (e.target === document.activeElement && $(e.target).is(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }
  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }
  if (e.targetTouches && e.targetTouches.length > 1) return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  var diffX = touches.currentX - touches.startX;
  var diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;
  if (typeof data.isScrolling === 'undefined') {
    var touchAngle;
    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }
  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }
  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }
  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }
  if (!data.startMoving) {
    return;
  }
  swiper.allowClick = false;
  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }
  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }
  if (!data.isMoved) {
    if (params.loop && !params.cssMode) {
      swiper.loopFix();
    }
    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);
    if (swiper.animating) {
      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
    }
    data.allowMomentumBounce = false; // Grab Cursor

    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }
    swiper.emit('sliderFirstMove', e);
  }
  swiper.emit('sliderMove', e);
  data.isMoved = true;
  var diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) diff = -diff;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  data.currentTranslate = diff + data.startTranslate;
  var disableParentSwiper = true;
  var resistanceRatio = params.resistanceRatio;
  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }
  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
  }
  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  } // Directions locks

  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  } // Threshold

  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }
  if (!params.followFinger || params.cssMode) return; // Update active index in free mode

  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) {
    swiper.freeMode.onTouchMove();
  } // Update progress

  swiper.updateProgress(data.currentTranslate); // Update translate

  swiper.setTranslate(data.currentTranslate);
}
function onTouchEnd(event) {
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
    touches = swiper.touches,
    rtl = swiper.rtlTranslate,
    slidesGrid = swiper.slidesGrid,
    enabled = swiper.enabled;
  if (!enabled) return;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }
  data.allowTouchCallbacks = false;
  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }
    data.isMoved = false;
    data.startMoving = false;
    return;
  } // Return Grab Cursor

  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  } // Time diff

  var touchEndTime = now();
  var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

  if (swiper.allowClick) {
    var pathTree = e.path || e.composedPath && e.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
    swiper.emit('tap click', e);
    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }
  data.lastClickTime = now();
  nextTick(function () {
    if (!swiper.destroyed) swiper.allowClick = true;
  });
  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  var currentPos;
  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }
  if (params.cssMode) {
    return;
  }
  if (swiper.params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos: currentPos
    });
    return;
  } // Find current slide

  var stopIndex = 0;
  var groupSize = swiper.slidesSizesGrid[0];
  for (var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (typeof slidesGrid[i + _increment] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + _increment] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }
  var rewindFirstIndex = null;
  var rewindLastIndex = null;
  if (params.rewind) {
    if (swiper.isBeginning) {
      rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    } else if (swiper.isEnd) {
      rewindFirstIndex = 0;
    }
  } // Find current slide size

  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);else swiper.slideTo(stopIndex);
    }
    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) {
        swiper.slideTo(stopIndex + increment);
      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
        swiper.slideTo(rewindLastIndex);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
      }
      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}
function onResize() {
  var swiper = this;
  var params = swiper.params,
    el = swiper.el;
  if (el && el.offsetWidth === 0) return; // Breakpoints

  if (params.breakpoints) {
    swiper.setBreakpoint();
  } // Save locks

  var allowSlideNext = swiper.allowSlideNext,
    allowSlidePrev = swiper.allowSlidePrev,
    snapGrid = swiper.snapGrid; // Disable locks on resize

  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();
  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    swiper.slideTo(swiper.activeIndex, 0, false, true);
  }
  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    swiper.autoplay.run();
  } // Return locks after resize

  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}
function onClick(e) {
  var swiper = this;
  if (!swiper.enabled) return;
  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();
    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}
function onScroll() {
  var swiper = this;
  var wrapperEl = swiper.wrapperEl,
    rtlTranslate = swiper.rtlTranslate,
    enabled = swiper.enabled;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;
  if (swiper.isHorizontal()) {
    swiper.translate = -wrapperEl.scrollLeft;
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  } // eslint-disable-next-line

  if (swiper.translate === 0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }
  swiper.emit('setTranslate', swiper.translate, false);
}
var dummyEventAttached = false;
function dummyEventListener() {}
var events = function events(swiper, method) {
  var document = getDocument();
  var params = swiper.params,
    touchEvents = swiper.touchEvents,
    el = swiper.el,
    wrapperEl = swiper.wrapperEl,
    device = swiper.device,
    support = swiper.support;
  var capture = !!params.nested;
  var domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
  var swiperMethod = method; // Touch Events

  if (!support.touch) {
    el[domMethod](touchEvents.start, swiper.onTouchStart, false);
    document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
    document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
  } else {
    var passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
    el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
      passive: false,
      capture: capture
    } : capture);
    el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);
    if (touchEvents.cancel) {
      el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    }
  } // Prevent Links Clicks

  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]('click', swiper.onClick, true);
  }
  if (params.cssMode) {
    wrapperEl[domMethod]('scroll', swiper.onScroll);
  } // Resize handler

  if (params.updateOnWindowResize) {
    swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  } else {
    swiper[swiperMethod]('observerUpdate', onResize, true);
  }
};
function attachEvents() {
  var swiper = this;
  var document = getDocument();
  var params = swiper.params,
    support = swiper.support;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);
  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }
  swiper.onClick = onClick.bind(swiper);
  if (support.touch && !dummyEventAttached) {
    document.addEventListener('touchstart', dummyEventListener);
    dummyEventAttached = true;
  }
  events(swiper, 'on');
}
function detachEvents() {
  var swiper = this;
  events(swiper, 'off');
}
var events$1 = {
  attachEvents: attachEvents,
  detachEvents: detachEvents
};
var isGridEnabled = function isGridEnabled(swiper, params) {
  return swiper.grid && params.grid && params.grid.rows > 1;
};
function setBreakpoint() {
  var swiper = this;
  var activeIndex = swiper.activeIndex,
    initialized = swiper.initialized,
    _swiper$loopedSlides = swiper.loopedSlides,
    loopedSlides = _swiper$loopedSlides === void 0 ? 0 : _swiper$loopedSlides,
    params = swiper.params,
    $el = swiper.$el;
  var breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

  var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
  var breakpointParams = breakpointOnlyParams || swiper.originalParams;
  var wasMultiRow = isGridEnabled(swiper, params);
  var isMultiRow = isGridEnabled(swiper, breakpointParams);
  var wasEnabled = params.enabled;
  if (wasMultiRow && !isMultiRow) {
    $el.removeClass("".concat(params.containerModifierClass, "grid ").concat(params.containerModifierClass, "grid-column"));
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    $el.addClass("".concat(params.containerModifierClass, "grid"));
    if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') {
      $el.addClass("".concat(params.containerModifierClass, "grid-column"));
    }
    swiper.emitContainerClasses();
  } // Toggle navigation, pagination, scrollbar

  ['navigation', 'pagination', 'scrollbar'].forEach(function (prop) {
    var wasModuleEnabled = params[prop] && params[prop].enabled;
    var isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
    if (wasModuleEnabled && !isModuleEnabled) {
      swiper[prop].disable();
    }
    if (!wasModuleEnabled && isModuleEnabled) {
      swiper[prop].enable();
    }
  });
  var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
  if (directionChanged && initialized) {
    swiper.changeDirection();
  }
  extend$1(swiper.params, breakpointParams);
  var isEnabled = swiper.params.enabled;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });
  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }
  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);
  if (needsReLoop && initialized) {
    swiper.loopDestroy();
    swiper.loopCreate();
    swiper.updateSlides();
    swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
  }
  swiper.emit('breakpoint', breakpointParams);
}
function getBreakpoint(breakpoints) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'window';
  var containerEl = arguments.length > 2 ? arguments[2] : undefined;
  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  var breakpoint = false;
  var window = getWindow();
  var currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  var points = Object.keys(breakpoints).map(function (point) {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      var minRatio = parseFloat(point.substr(1));
      var value = currentHeight * minRatio;
      return {
        value: value,
        point: point
      };
    }
    return {
      value: point,
      point: point
    };
  });
  points.sort(function (a, b) {
    return parseInt(a.value, 10) - parseInt(b.value, 10);
  });
  for (var i = 0; i < points.length; i += 1) {
    var _points$i = points[i],
      point = _points$i.point,
      value = _points$i.value;
    if (base === 'window') {
      if (window.matchMedia("(min-width: ".concat(value, "px)")).matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }
  return breakpoint || 'max';
}
var breakpoints = {
  setBreakpoint: setBreakpoint,
  getBreakpoint: getBreakpoint
};
function prepareClasses(entries, prefix) {
  var resultClasses = [];
  entries.forEach(function (item) {
    if (typeof item === 'object') {
      Object.keys(item).forEach(function (classNames) {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}
function addClasses() {
  var swiper = this;
  var classNames = swiper.classNames,
    params = swiper.params,
    rtl = swiper.rtl,
    $el = swiper.$el,
    device = swiper.device,
    support = swiper.support; // prettier-ignore

  var suffixes = prepareClasses(['initialized', params.direction, {
    'pointer-events': !support.touch
  }, {
    'free-mode': swiper.params.freeMode && params.freeMode.enabled
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'grid': params.grid && params.grid.rows > 1
  }, {
    'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }, {
    'centered': params.cssMode && params.centeredSlides
  }, {
    'watch-progress': params.watchSlidesProgress
  }], params.containerModifierClass);
  classNames.push.apply(classNames, _toConsumableArray(suffixes));
  $el.addClass(_toConsumableArray(classNames).join(' '));
  swiper.emitContainerClasses();
}
function removeClasses() {
  var swiper = this;
  var $el = swiper.$el,
    classNames = swiper.classNames;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}
var classes = {
  addClasses: addClasses,
  removeClasses: removeClasses
};
function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
  var window = getWindow();
  var image;
  function onReady() {
    if (callback) callback();
  }
  var isPicture = $(imageEl).parent('picture')[0];
  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
    if (src) {
      image = new window.Image();
      image.onload = onReady;
      image.onerror = onReady;
      if (sizes) {
        image.sizes = sizes;
      }
      if (srcset) {
        image.srcset = srcset;
      }
      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    // image already loaded...
    onReady();
  }
}
function preloadImages() {
  var swiper = this;
  swiper.imagesToLoad = swiper.$el.find('img');
  function onReady() {
    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady) swiper.update();
      swiper.emit('imagesReady');
    }
  }
  for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
    var imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
  }
}
var images = {
  loadImage: loadImage,
  preloadImages: preloadImages
};
function checkOverflow() {
  var swiper = this;
  var wasLocked = swiper.isLocked,
    params = swiper.params;
  var slidesOffsetBefore = params.slidesOffsetBefore;
  if (slidesOffsetBefore) {
    var lastSlideIndex = swiper.slides.length - 1;
    var lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }
  if (params.allowSlideNext === true) {
    swiper.allowSlideNext = !swiper.isLocked;
  }
  if (params.allowSlidePrev === true) {
    swiper.allowSlidePrev = !swiper.isLocked;
  }
  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
  }
  if (wasLocked !== swiper.isLocked) {
    swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
  }
}
var checkOverflow$1 = {
  checkOverflow: checkOverflow
};
var defaults = {
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'wrapper',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // Images
  preloadImages: true,
  updateOnImagesReady: true,
  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopedSlidesLimit: true,
  loopFillGroupWithBlank: false,
  loopPreventsSlide: true,
  // rewind
  rewind: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: 'swiper-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
};
function moduleExtendParams(params, allModulesParams) {
  return function extendParams() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var moduleParamName = Object.keys(obj)[0];
    var moduleParams = obj[moduleParamName];
    if (typeof moduleParams !== 'object' || moduleParams === null) {
      extend$1(allModulesParams, obj);
      return;
    }
    if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
      params[moduleParamName] = {
        auto: true
      };
    }
    if (!(moduleParamName in params && 'enabled' in moduleParams)) {
      extend$1(allModulesParams, obj);
      return;
    }
    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }
    if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }
    if (!params[moduleParamName]) params[moduleParamName] = {
      enabled: false
    };
    extend$1(allModulesParams, obj);
  };
}

/* eslint no-param-reassign: "off" */
var prototypes = {
  eventsEmitter: eventsEmitter,
  update: update,
  translate: translate,
  transition: transition,
  slide: slide,
  loop: loop,
  grabCursor: grabCursor,
  events: events$1,
  breakpoints: breakpoints,
  checkOverflow: checkOverflow$1,
  classes: classes,
  images: images
};
var extendedDefaults = {};
var Swiper$1 = /*#__PURE__*/function () {
  function Swiper() {
    _classCallCheck(this, Swiper);
    var el;
    var params;
    for (var _len17 = arguments.length, args = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
      args[_key17] = arguments[_key17];
    }
    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      el = args[0];
      params = args[1];
    }
    if (!params) params = {};
    params = extend$1({}, params);
    if (el && !params.el) params.el = el;
    if (params.el && $(params.el).length > 1) {
      var swipers = [];
      $(params.el).each(function (containerEl) {
        var newParams = extend$1({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      }); // eslint-disable-next-line no-constructor-return

      return swipers;
    } // Swiper Instance

    var swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];
    swiper.modules = _toConsumableArray(swiper.__modules__);
    if (params.modules && Array.isArray(params.modules)) {
      var _swiper$modules;
      (_swiper$modules = swiper.modules).push.apply(_swiper$modules, _toConsumableArray(params.modules));
    }
    var allModulesParams = {};
    swiper.modules.forEach(function (mod) {
      mod({
        swiper: swiper,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    }); // Extend defaults with modules params

    var swiperParams = extend$1({}, defaults, allModulesParams); // Extend defaults with passed params

    swiper.params = extend$1({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = extend$1({}, swiper.params);
    swiper.passedParams = extend$1({}, params); // add event listeners

    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(function (eventName) {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }
    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    } // Save Dom lib

    swiper.$ = $; // Extend Swiper

    Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el: el,
      // Classes
      classNames: [],
      // Slides
      slides: $(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal: function isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },
      isVertical: function isVertical() {
        return swiper.params.direction === 'vertical';
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEvents: function touchEvents() {
        var touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
        var desktop = ['pointerdown', 'pointermove', 'pointerup'];
        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2],
          cancel: touch[3]
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        };
        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: now(),
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        isTouchEvent: undefined,
        startMoving: undefined
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper.emit('_swiper'); // Init

    if (swiper.params.init) {
      swiper.init();
    } // Return app instance
    // eslint-disable-next-line no-constructor-return

    return swiper;
  }
  _createClass(Swiper, [{
    key: "enable",
    value: function enable() {
      var swiper = this;
      if (swiper.enabled) return;
      swiper.enabled = true;
      if (swiper.params.grabCursor) {
        swiper.setGrabCursor();
      }
      swiper.emit('enable');
    }
  }, {
    key: "disable",
    value: function disable() {
      var swiper = this;
      if (!swiper.enabled) return;
      swiper.enabled = false;
      if (swiper.params.grabCursor) {
        swiper.unsetGrabCursor();
      }
      swiper.emit('disable');
    }
  }, {
    key: "setProgress",
    value: function setProgress(progress, speed) {
      var swiper = this;
      progress = Math.min(Math.max(progress, 0), 1);
      var min = swiper.minTranslate();
      var max = swiper.maxTranslate();
      var current = (max - min) * progress + min;
      swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
  }, {
    key: "emitContainerClasses",
    value: function emitContainerClasses() {
      var swiper = this;
      if (!swiper.params._emitClasses || !swiper.el) return;
      var cls = swiper.el.className.split(' ').filter(function (className) {
        return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
      });
      swiper.emit('_containerClasses', cls.join(' '));
    }
  }, {
    key: "getSlideClasses",
    value: function getSlideClasses(slideEl) {
      var swiper = this;
      if (swiper.destroyed) return '';
      return slideEl.className.split(' ').filter(function (className) {
        return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
      }).join(' ');
    }
  }, {
    key: "emitSlidesClasses",
    value: function emitSlidesClasses() {
      var swiper = this;
      if (!swiper.params._emitClasses || !swiper.el) return;
      var updates = [];
      swiper.slides.each(function (slideEl) {
        var classNames = swiper.getSlideClasses(slideEl);
        updates.push({
          slideEl: slideEl,
          classNames: classNames
        });
        swiper.emit('_slideClass', slideEl, classNames);
      });
      swiper.emit('_slideClasses', updates);
    }
  }, {
    key: "slidesPerViewDynamic",
    value: function slidesPerViewDynamic() {
      var view = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'current';
      var exact = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var swiper = this;
      var params = swiper.params,
        slides = swiper.slides,
        slidesGrid = swiper.slidesGrid,
        slidesSizesGrid = swiper.slidesSizesGrid,
        swiperSize = swiper.size,
        activeIndex = swiper.activeIndex;
      var spv = 1;
      if (params.centeredSlides) {
        var slideSize = slides[activeIndex].swiperSlideSize;
        var breakLoop;
        for (var i = activeIndex + 1; i < slides.length; i += 1) {
          if (slides[i] && !breakLoop) {
            slideSize += slides[i].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }
        for (var _i5 = activeIndex - 1; _i5 >= 0; _i5 -= 1) {
          if (slides[_i5] && !breakLoop) {
            slideSize += slides[_i5].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }
      } else {
        // eslint-disable-next-line
        if (view === 'current') {
          for (var _i6 = activeIndex + 1; _i6 < slides.length; _i6 += 1) {
            var slideInView = exact ? slidesGrid[_i6] + slidesSizesGrid[_i6] - slidesGrid[activeIndex] < swiperSize : slidesGrid[_i6] - slidesGrid[activeIndex] < swiperSize;
            if (slideInView) {
              spv += 1;
            }
          }
        } else {
          // previous
          for (var _i7 = activeIndex - 1; _i7 >= 0; _i7 -= 1) {
            var _slideInView = slidesGrid[activeIndex] - slidesGrid[_i7] < swiperSize;
            if (_slideInView) {
              spv += 1;
            }
          }
        }
      }
      return spv;
    }
  }, {
    key: "update",
    value: function update() {
      var swiper = this;
      if (!swiper || swiper.destroyed) return;
      var snapGrid = swiper.snapGrid,
        params = swiper.params; // Breakpoints

      if (params.breakpoints) {
        swiper.setBreakpoint();
      }
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();
      function setTranslate() {
        var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
        var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      var translated;
      if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
        setTranslate();
        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
          translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
        } else {
          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
        }
        if (!translated) {
          setTranslate();
        }
      }
      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
      swiper.emit('update');
    }
  }, {
    key: "changeDirection",
    value: function changeDirection(newDirection) {
      var needUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var swiper = this;
      var currentDirection = swiper.params.direction;
      if (!newDirection) {
        // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
      }
      if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
        return swiper;
      }
      swiper.$el.removeClass("".concat(swiper.params.containerModifierClass).concat(currentDirection)).addClass("".concat(swiper.params.containerModifierClass).concat(newDirection));
      swiper.emitContainerClasses();
      swiper.params.direction = newDirection;
      swiper.slides.each(function (slideEl) {
        if (newDirection === 'vertical') {
          slideEl.style.width = '';
        } else {
          slideEl.style.height = '';
        }
      });
      swiper.emit('changeDirection');
      if (needUpdate) swiper.update();
      return swiper;
    }
  }, {
    key: "changeLanguageDirection",
    value: function changeLanguageDirection(direction) {
      var swiper = this;
      if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
      swiper.rtl = direction === 'rtl';
      swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
      if (swiper.rtl) {
        swiper.$el.addClass("".concat(swiper.params.containerModifierClass, "rtl"));
        swiper.el.dir = 'rtl';
      } else {
        swiper.$el.removeClass("".concat(swiper.params.containerModifierClass, "rtl"));
        swiper.el.dir = 'ltr';
      }
      swiper.update();
    }
  }, {
    key: "mount",
    value: function mount(el) {
      var swiper = this;
      if (swiper.mounted) return true; // Find el

      var $el = $(el || swiper.params.el);
      el = $el[0];
      if (!el) {
        return false;
      }
      el.swiper = swiper;
      var getWrapperSelector = function getWrapperSelector() {
        return ".".concat((swiper.params.wrapperClass || '').trim().split(' ').join('.'));
      };
      var getWrapper = function getWrapper() {
        if (el && el.shadowRoot && el.shadowRoot.querySelector) {
          var res = $(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items

          res.children = function (options) {
            return $el.children(options);
          };
          return res;
        }
        if (!$el.children) {
          return $($el).children(getWrapperSelector());
        }
        return $el.children(getWrapperSelector());
      }; // Find Wrapper

      var $wrapperEl = getWrapper();
      if ($wrapperEl.length === 0 && swiper.params.createElements) {
        var _document2 = getDocument();
        var wrapper = _document2.createElement('div');
        $wrapperEl = $(wrapper);
        wrapper.className = swiper.params.wrapperClass;
        $el.append(wrapper);
        $el.children(".".concat(swiper.params.slideClass)).each(function (slideEl) {
          $wrapperEl.append(slideEl);
        });
      }
      Object.assign(swiper, {
        $el: $el,
        el: el,
        $wrapperEl: $wrapperEl,
        wrapperEl: $wrapperEl[0],
        mounted: true,
        // RTL
        rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
        rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
        wrongRTL: $wrapperEl.css('display') === '-webkit-box'
      });
      return true;
    }
  }, {
    key: "init",
    value: function init(el) {
      var swiper = this;
      if (swiper.initialized) return swiper;
      var mounted = swiper.mount(el);
      if (mounted === false) return swiper;
      swiper.emit('beforeInit'); // Set breakpoint

      if (swiper.params.breakpoints) {
        swiper.setBreakpoint();
      } // Add Classes

      swiper.addClasses(); // Create loop

      if (swiper.params.loop) {
        swiper.loopCreate();
      } // Update size

      swiper.updateSize(); // Update slides

      swiper.updateSlides();
      if (swiper.params.watchOverflow) {
        swiper.checkOverflow();
      } // Set Grab Cursor

      if (swiper.params.grabCursor && swiper.enabled) {
        swiper.setGrabCursor();
      }
      if (swiper.params.preloadImages) {
        swiper.preloadImages();
      } // Slide To Initial Slide

      if (swiper.params.loop) {
        swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
      } else {
        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
      } // Attach events

      swiper.attachEvents(); // Init Flag

      swiper.initialized = true; // Emit

      swiper.emit('init');
      swiper.emit('afterInit');
      return swiper;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var deleteInstance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var cleanStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var swiper = this;
      var params = swiper.params,
        $el = swiper.$el,
        $wrapperEl = swiper.$wrapperEl,
        slides = swiper.slides;
      if (typeof swiper.params === 'undefined' || swiper.destroyed) {
        return null;
      }
      swiper.emit('beforeDestroy'); // Init Flag

      swiper.initialized = false; // Detach events

      swiper.detachEvents(); // Destroy loop

      if (params.loop) {
        swiper.loopDestroy();
      } // Cleanup styles

      if (cleanStyles) {
        swiper.removeClasses();
        $el.removeAttr('style');
        $wrapperEl.removeAttr('style');
        if (slides && slides.length) {
          slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
        }
      }
      swiper.emit('destroy'); // Detach emitter events

      Object.keys(swiper.eventsListeners).forEach(function (eventName) {
        swiper.off(eventName);
      });
      if (deleteInstance !== false) {
        swiper.$el[0].swiper = null;
        deleteProps(swiper);
      }
      swiper.destroyed = true;
      return null;
    }
  }], [{
    key: "extendDefaults",
    value: function extendDefaults(newDefaults) {
      extend$1(extendedDefaults, newDefaults);
    }
  }, {
    key: "extendedDefaults",
    get: function get() {
      return extendedDefaults;
    }
  }, {
    key: "defaults",
    get: function get() {
      return defaults;
    }
  }, {
    key: "installModule",
    value: function installModule(mod) {
      if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
      var modules = Swiper.prototype.__modules__;
      if (typeof mod === 'function' && modules.indexOf(mod) < 0) {
        modules.push(mod);
      }
    }
  }, {
    key: "use",
    value: function use(module) {
      if (Array.isArray(module)) {
        module.forEach(function (m) {
          return Swiper.installModule(m);
        });
        return Swiper;
      }
      Swiper.installModule(module);
      return Swiper;
    }
  }]);
  return Swiper;
}();
Object.keys(prototypes).forEach(function (prototypeGroup) {
  Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
    Swiper$1.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper$1.use([Resize, Observer]);
function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
  var document = getDocument();
  if (swiper.params.createElements) {
    Object.keys(checkProps).forEach(function (key) {
      if (!params[key] && params.auto === true) {
        var element = swiper.$el.children(".".concat(checkProps[key]))[0];
        if (!element) {
          element = document.createElement('div');
          element.className = checkProps[key];
          swiper.$el.append(element);
        }
        params[key] = element;
        originalParams[key] = element;
      }
    });
  }
  return params;
}
function classesToSelector() {
  var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return ".".concat(classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.'));
}
function Pagination(_ref11) {
  var swiper = _ref11.swiper,
    extendParams = _ref11.extendParams,
    on = _ref11.on,
    emit = _ref11.emit;
  var pfx = 'swiper-pagination';
  extendParams({
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: function formatFractionCurrent(number) {
        return number;
      },
      formatFractionTotal: function formatFractionTotal(number) {
        return number;
      },
      bulletClass: "".concat(pfx, "-bullet"),
      bulletActiveClass: "".concat(pfx, "-bullet-active"),
      modifierClass: "".concat(pfx, "-"),
      currentClass: "".concat(pfx, "-current"),
      totalClass: "".concat(pfx, "-total"),
      hiddenClass: "".concat(pfx, "-hidden"),
      progressbarFillClass: "".concat(pfx, "-progressbar-fill"),
      progressbarOppositeClass: "".concat(pfx, "-progressbar-opposite"),
      clickableClass: "".concat(pfx, "-clickable"),
      lockClass: "".concat(pfx, "-lock"),
      horizontalClass: "".concat(pfx, "-horizontal"),
      verticalClass: "".concat(pfx, "-vertical"),
      paginationDisabledClass: "".concat(pfx, "-disabled")
    }
  });
  swiper.pagination = {
    el: null,
    $el: null,
    bullets: []
  };
  var bulletSize;
  var dynamicBulletIndex = 0;
  function isPaginationDisabled() {
    return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
  }
  function setSideBullets($bulletEl, position) {
    var bulletActiveClass = swiper.params.pagination.bulletActiveClass;
    $bulletEl[position]().addClass("".concat(bulletActiveClass, "-").concat(position))[position]().addClass("".concat(bulletActiveClass, "-").concat(position, "-").concat(position));
  }
  function update() {
    // Render || Update Pagination bullets/items
    var rtl = swiper.rtl;
    var params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el; // Current/Total

    var current;
    var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }
      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    } // Types

    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      var bullets = swiper.pagination.bullets;
      var firstIndex;
      var lastIndex;
      var midIndex;
      if (params.dynamicBullets) {
        bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', "".concat(bulletSize * (params.dynamicMainBullets + 4), "px"));
        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);
          if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
            dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (dynamicBulletIndex < 0) {
            dynamicBulletIndex = 0;
          }
        }
        firstIndex = Math.max(current - dynamicBulletIndex, 0);
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }
      bullets.removeClass(['', '-next', '-next-next', '-prev', '-prev-prev', '-main'].map(function (suffix) {
        return "".concat(params.bulletActiveClass).concat(suffix);
      }).join(' '));
      if ($el.length > 1) {
        bullets.each(function (bullet) {
          var $bullet = $(bullet);
          var bulletIndex = $bullet.index();
          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }
          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass("".concat(params.bulletActiveClass, "-main"));
            }
            if (bulletIndex === firstIndex) {
              setSideBullets($bullet, 'prev');
            }
            if (bulletIndex === lastIndex) {
              setSideBullets($bullet, 'next');
            }
          }
        });
      } else {
        var $bullet = bullets.eq(current);
        var bulletIndex = $bullet.index();
        $bullet.addClass(params.bulletActiveClass);
        if (params.dynamicBullets) {
          var $firstDisplayedBullet = bullets.eq(firstIndex);
          var $lastDisplayedBullet = bullets.eq(lastIndex);
          for (var i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass("".concat(params.bulletActiveClass, "-main"));
          }
          if (swiper.params.loop) {
            if (bulletIndex >= bullets.length) {
              for (var _i8 = params.dynamicMainBullets; _i8 >= 0; _i8 -= 1) {
                bullets.eq(bullets.length - _i8).addClass("".concat(params.bulletActiveClass, "-main"));
              }
              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass("".concat(params.bulletActiveClass, "-prev"));
            } else {
              setSideBullets($firstDisplayedBullet, 'prev');
              setSideBullets($lastDisplayedBullet, 'next');
            }
          } else {
            setSideBullets($firstDisplayedBullet, 'prev');
            setSideBullets($lastDisplayedBullet, 'next');
          }
        }
      }
      if (params.dynamicBullets) {
        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        var bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
        var offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', "".concat(bulletsOffset, "px"));
      }
    }
    if (params.type === 'fraction') {
      $el.find(classesToSelector(params.currentClass)).text(params.formatFractionCurrent(current + 1));
      $el.find(classesToSelector(params.totalClass)).text(params.formatFractionTotal(total));
    }
    if (params.type === 'progressbar') {
      var progressbarDirection;
      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }
      var scale = (current + 1) / total;
      var scaleX = 1;
      var scaleY = 1;
      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }
      $el.find(classesToSelector(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(".concat(scaleX, ") scaleY(").concat(scaleY, ")")).transition(swiper.params.speed);
    }
    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      emit('paginationRender', $el[0]);
    } else {
      emit('paginationUpdate', $el[0]);
    }
    if (swiper.params.watchOverflow && swiper.enabled) {
      $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  }
  function render() {
    // Render Container
    var params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el;
    var paginationHTML = '';
    if (params.type === 'bullets') {
      var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }
      for (var i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += "<".concat(params.bulletElement, " class=\"").concat(params.bulletClass, "\"></").concat(params.bulletElement, ">");
        }
      }
      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find(classesToSelector(params.bulletClass));
    }
    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = "<span class=\"".concat(params.currentClass, "\"></span>") + ' / ' + "<span class=\"".concat(params.totalClass, "\"></span>");
      }
      $el.html(paginationHTML);
    }
    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = "<span class=\"".concat(params.progressbarFillClass, "\"></span>");
      }
      $el.html(paginationHTML);
    }
    if (params.type !== 'custom') {
      emit('paginationRender', swiper.pagination.$el[0]);
    }
  }
  function init() {
    swiper.params.pagination = createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
      el: 'swiper-pagination'
    });
    var params = swiper.params.pagination;
    if (!params.el) return;
    var $el = $(params.el);
    if ($el.length === 0) return;
    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
      $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper

      if ($el.length > 1) {
        $el = $el.filter(function (el) {
          if ($(el).parents('.swiper')[0] !== swiper.el) return false;
          return true;
        });
      }
    }
    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }
    $el.addClass(params.modifierClass + params.type);
    $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass("".concat(params.modifierClass).concat(params.type, "-dynamic"));
      dynamicBulletIndex = 0;
      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }
    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }
    if (params.clickable) {
      $el.on('click', classesToSelector(params.bulletClass), function onClick(e) {
        e.preventDefault();
        var index = $(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }
    Object.assign(swiper.pagination, {
      $el: $el,
      el: $el[0]
    });
    if (!swiper.enabled) {
      $el.addClass(params.lockClass);
    }
  }
  function destroy() {
    var params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    var $el = swiper.pagination.$el;
    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
    if (params.clickable) {
      $el.off('click', classesToSelector(params.bulletClass));
    }
  }
  on('init', function () {
    if (swiper.params.pagination.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      render();
      update();
    }
  });
  on('activeIndexChange', function () {
    if (swiper.params.loop) {
      update();
    } else if (typeof swiper.snapIndex === 'undefined') {
      update();
    }
  });
  on('snapIndexChange', function () {
    if (!swiper.params.loop) {
      update();
    }
  });
  on('slidesLengthChange', function () {
    if (swiper.params.loop) {
      render();
      update();
    }
  });
  on('snapGridLengthChange', function () {
    if (!swiper.params.loop) {
      render();
      update();
    }
  });
  on('destroy', function () {
    destroy();
  });
  on('enable disable', function () {
    var $el = swiper.pagination.$el;
    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
    }
  });
  on('lock unlock', function () {
    update();
  });
  on('click', function (_s, e) {
    var targetEl = e.target;
    var $el = swiper.pagination.$el;
    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !$(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
      if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
      var isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);
      if (isHidden === true) {
        emit('paginationShow');
      } else {
        emit('paginationHide');
      }
      $el.toggleClass(swiper.params.pagination.hiddenClass);
    }
  });
  var enable = function enable() {
    swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
    if (swiper.pagination.$el) {
      swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
    }
    init();
    render();
    update();
  };
  var disable = function disable() {
    swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);
    if (swiper.pagination.$el) {
      swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
    }
    destroy();
  };
  Object.assign(swiper.pagination, {
    enable: enable,
    disable: disable,
    render: render,
    update: update,
    init: init,
    destroy: destroy
  });
}
function isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function extend(target, src) {
  var noExtend = ['__proto__', 'constructor', 'prototype'];
  Object.keys(src).filter(function (key) {
    return noExtend.indexOf(key) < 0;
  }).forEach(function (key) {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      if (src[key].__swiper__) target[key] = src[key];else extend(target[key], src[key]);
    } else {
      target[key] = src[key];
    }
  });
}
function needsNavigation() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
}
function needsPagination() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return params.pagination && typeof params.pagination.el === 'undefined';
}
function needsScrollbar() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return params.scrollbar && typeof params.scrollbar.el === 'undefined';
}
function uniqueClasses() {
  var classNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var classes = classNames.split(' ').map(function (c) {
    return c.trim();
  }).filter(function (c) {
    return !!c;
  });
  var unique = [];
  classes.forEach(function (c) {
    if (unique.indexOf(c) < 0) unique.push(c);
  });
  return unique.join(' ');
}

/* underscore in name -> watch for changes */
var paramsList = ['modules', 'init', '_direction', 'touchEventsTarget', 'initialSlide', '_speed', 'cssMode', 'updateOnWindowResize', 'resizeObserver', 'nested', 'focusableElements', '_enabled', '_width', '_height', 'preventInteractionOnTransition', 'userAgent', 'url', '_edgeSwipeDetection', '_edgeSwipeThreshold', '_freeMode', '_autoHeight', 'setWrapperSize', 'virtualTranslate', '_effect', 'breakpoints', '_spaceBetween', '_slidesPerView', 'maxBackfaceHiddenSlides', '_grid', '_slidesPerGroup', '_slidesPerGroupSkip', '_slidesPerGroupAuto', '_centeredSlides', '_centeredSlidesBounds', '_slidesOffsetBefore', '_slidesOffsetAfter', 'normalizeSlideIndex', '_centerInsufficientSlides', '_watchOverflow', 'roundLengths', 'touchRatio', 'touchAngle', 'simulateTouch', '_shortSwipes', '_longSwipes', 'longSwipesRatio', 'longSwipesMs', '_followFinger', 'allowTouchMove', '_threshold', 'touchMoveStopPropagation', 'touchStartPreventDefault', 'touchStartForcePreventDefault', 'touchReleaseOnEdges', 'uniqueNavElements', '_resistance', '_resistanceRatio', '_watchSlidesProgress', '_grabCursor', 'preventClicks', 'preventClicksPropagation', '_slideToClickedSlide', '_preloadImages', 'updateOnImagesReady', '_loop', '_loopAdditionalSlides', '_loopedSlides', '_loopedSlidesLimit', '_loopFillGroupWithBlank', 'loopPreventsSlide', '_rewind', '_allowSlidePrev', '_allowSlideNext', '_swipeHandler', '_noSwiping', 'noSwipingClass', 'noSwipingSelector', 'passiveListeners', 'containerModifierClass', 'slideClass', 'slideBlankClass', 'slideActiveClass', 'slideDuplicateActiveClass', 'slideVisibleClass', 'slideDuplicateClass', 'slideNextClass', 'slideDuplicateNextClass', 'slidePrevClass', 'slideDuplicatePrevClass', 'wrapperClass', 'runCallbacksOnInit', 'observer', 'observeParents', 'observeSlideChildren',
// modules
'a11y', '_autoplay', '_controller', 'coverflowEffect', 'cubeEffect', 'fadeEffect', 'flipEffect', 'creativeEffect', 'cardsEffect', 'hashNavigation', 'history', 'keyboard', 'lazy', 'mousewheel', '_navigation', '_pagination', 'parallax', '_scrollbar', '_thumbs', 'virtual', 'zoom'];
function getParams() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var splitEvents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var params = {
    on: {}
  };
  var events = {};
  var passedParams = {};
  extend(params, Swiper$1.defaults);
  extend(params, Swiper$1.extendedDefaults);
  params._emitClasses = true;
  params.init = false;
  var rest = {};
  var allowedParams = paramsList.map(function (key) {
    return key.replace(/_/, '');
  });
  var plainObj = Object.assign({}, obj);
  Object.keys(plainObj).forEach(function (key) {
    if (typeof obj[key] === 'undefined') return;
    if (allowedParams.indexOf(key) >= 0) {
      if (isObject(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        extend(params[key], obj[key]);
        extend(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
      if (splitEvents) {
        events["".concat(key[2].toLowerCase()).concat(key.substr(3))] = obj[key];
      } else {
        params.on["".concat(key[2].toLowerCase()).concat(key.substr(3))] = obj[key];
      }
    } else {
      rest[key] = obj[key];
    }
  });
  ['navigation', 'pagination', 'scrollbar'].forEach(function (key) {
    if (params[key] === true) params[key] = {};
    if (params[key] === false) delete params[key];
  });
  return {
    params: params,
    passedParams: passedParams,
    rest: rest,
    events: events
  };
}
function mountSwiper(_ref12, swiperParams) {
  var el = _ref12.el,
    nextEl = _ref12.nextEl,
    prevEl = _ref12.prevEl,
    paginationEl = _ref12.paginationEl,
    scrollbarEl = _ref12.scrollbarEl,
    swiper = _ref12.swiper;
  if (needsNavigation(swiperParams) && nextEl && prevEl) {
    swiper.params.navigation.nextEl = nextEl;
    swiper.originalParams.navigation.nextEl = nextEl;
    swiper.params.navigation.prevEl = prevEl;
    swiper.originalParams.navigation.prevEl = prevEl;
  }
  if (needsPagination(swiperParams) && paginationEl) {
    swiper.params.pagination.el = paginationEl;
    swiper.originalParams.pagination.el = paginationEl;
  }
  if (needsScrollbar(swiperParams) && scrollbarEl) {
    swiper.params.scrollbar.el = scrollbarEl;
    swiper.originalParams.scrollbar.el = scrollbarEl;
  }
  swiper.init(el);
}
var calcLoopedSlides = function calcLoopedSlides(slides, swiperParams) {
  var slidesPerViewParams = swiperParams.slidesPerView;
  if (swiperParams.breakpoints) {
    var breakpoint = Swiper$1.prototype.getBreakpoint(swiperParams.breakpoints);
    var breakpointOnlyParams = breakpoint in swiperParams.breakpoints ? swiperParams.breakpoints[breakpoint] : undefined;
    if (breakpointOnlyParams && breakpointOnlyParams.slidesPerView) {
      slidesPerViewParams = breakpointOnlyParams.slidesPerView;
    }
  }
  var loopedSlides = Math.ceil(parseFloat(swiperParams.loopedSlides || slidesPerViewParams, 10));
  loopedSlides += swiperParams.loopAdditionalSlides;
  if (loopedSlides > slides.length && swiperParams.loopedSlidesLimit) {
    loopedSlides = slides.length;
  }
  return loopedSlides;
};
function renderLoop(swiper, slides, swiperParams) {
  var modifiedSlides = slides.map(function (child, index) {
    return /*#__PURE__*/React.cloneElement(child, {
      swiper: swiper,
      'data-swiper-slide-index': index
    });
  });
  function duplicateSlide(child, index, position) {
    return /*#__PURE__*/React.cloneElement(child, {
      key: "".concat(child.key, "-duplicate-").concat(index, "-").concat(position),
      className: "".concat(child.props.className || '', " ").concat(swiperParams.slideDuplicateClass)
    });
  }
  if (swiperParams.loopFillGroupWithBlank) {
    var blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;
    if (blankSlidesNum !== swiperParams.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankSlide = /*#__PURE__*/React.createElement("div", {
          className: "".concat(swiperParams.slideClass, " ").concat(swiperParams.slideBlankClass)
        });
        modifiedSlides.push(blankSlide);
      }
    }
  }
  if (swiperParams.slidesPerView === 'auto' && !swiperParams.loopedSlides) {
    swiperParams.loopedSlides = modifiedSlides.length;
  }
  var loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams);
  var prependSlides = [];
  var appendSlides = [];
  for (var _i9 = 0; _i9 < loopedSlides; _i9 += 1) {
    var _index3 = _i9 - Math.floor(_i9 / modifiedSlides.length) * modifiedSlides.length;
    appendSlides.push(duplicateSlide(modifiedSlides[_index3], _i9, 'append'));
    prependSlides.unshift(duplicateSlide(modifiedSlides[modifiedSlides.length - _index3 - 1], _i9, 'prepend'));
  }
  if (swiper) {
    swiper.loopedSlides = loopedSlides;
  }
  return [].concat(prependSlides, _toConsumableArray(modifiedSlides), appendSlides);
}
function getChangedParams(swiperParams, oldParams, children, oldChildren, getKey) {
  var keys = [];
  if (!oldParams) return keys;
  var addKey = function addKey(key) {
    if (keys.indexOf(key) < 0) keys.push(key);
  };
  if (children && oldChildren) {
    var oldChildrenKeys = oldChildren.map(getKey);
    var childrenKeys = children.map(getKey);
    if (oldChildrenKeys.join('') !== childrenKeys.join('')) addKey('children');
    if (oldChildren.length !== children.length) addKey('children');
  }
  var watchParams = paramsList.filter(function (key) {
    return key[0] === '_';
  }).map(function (key) {
    return key.replace(/_/, '');
  });
  watchParams.forEach(function (key) {
    if (key in swiperParams && key in oldParams) {
      if (isObject(swiperParams[key]) && isObject(oldParams[key])) {
        var newKeys = Object.keys(swiperParams[key]);
        var oldKeys = Object.keys(oldParams[key]);
        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach(function (newKey) {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach(function (oldKey) {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys;
}
function isChildSwiperSlide(child) {
  return child.type && child.type.displayName && child.type.displayName.includes('SwiperSlide');
}
function processChildren(c) {
  var slides = [];
  React.Children.toArray(c).forEach(function (child) {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach(function (slide) {
        return slides.push(slide);
      });
    }
  });
  return slides;
}
function getChildren(c) {
  var slides = [];
  var slots = {
    'container-start': [],
    'container-end': [],
    'wrapper-start': [],
    'wrapper-end': []
  };
  React.Children.toArray(c).forEach(function (child) {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      var foundSlides = processChildren(child.props.children);
      if (foundSlides.length > 0) {
        foundSlides.forEach(function (slide) {
          return slides.push(slide);
        });
      } else {
        slots['container-end'].push(child);
      }
    } else {
      slots['container-end'].push(child);
    }
  });
  return {
    slides: slides,
    slots: slots
  };
}
function updateSwiper(_ref13) {
  var swiper = _ref13.swiper,
    slides = _ref13.slides,
    passedParams = _ref13.passedParams,
    changedParams = _ref13.changedParams,
    nextEl = _ref13.nextEl,
    prevEl = _ref13.prevEl,
    scrollbarEl = _ref13.scrollbarEl,
    paginationEl = _ref13.paginationEl;
  var updateParams = changedParams.filter(function (key) {
    return key !== 'children' && key !== 'direction';
  });
  var currentParams = swiper.params,
    pagination = swiper.pagination,
    navigation = swiper.navigation,
    scrollbar = swiper.scrollbar,
    virtual = swiper.virtual,
    thumbs = swiper.thumbs;
  var needThumbsInit;
  var needControllerInit;
  var needPaginationInit;
  var needScrollbarInit;
  var needNavigationInit;
  if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) {
    needThumbsInit = true;
  }
  if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }
  if (changedParams.includes('pagination') && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
    needPaginationInit = true;
  }
  if (changedParams.includes('scrollbar') && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }
  if (changedParams.includes('navigation') && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
    needNavigationInit = true;
  }
  var destroyModule = function destroyModule(mod) {
    if (!swiper[mod]) return;
    swiper[mod].destroy();
    if (mod === 'navigation') {
      currentParams[mod].prevEl = undefined;
      currentParams[mod].nextEl = undefined;
      swiper[mod].prevEl = undefined;
      swiper[mod].nextEl = undefined;
    } else {
      currentParams[mod].el = undefined;
      swiper[mod].el = undefined;
    }
  };
  updateParams.forEach(function (key) {
    if (isObject(currentParams[key]) && isObject(passedParams[key])) {
      extend(currentParams[key], passedParams[key]);
    } else {
      var newValue = passedParams[key];
      if ((newValue === true || newValue === false) && (key === 'navigation' || key === 'pagination' || key === 'scrollbar')) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });
  if (updateParams.includes('controller') && !needControllerInit && swiper.controller && swiper.controller.control && currentParams.controller && currentParams.controller.control) {
    swiper.controller.control = currentParams.controller.control;
  }
  if (changedParams.includes('children') && slides && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  } else if (changedParams.includes('children') && swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }
  if (needThumbsInit) {
    var initialized = thumbs.init();
    if (initialized) thumbs.update(true);
  }
  if (needControllerInit) {
    swiper.controller.control = currentParams.controller.control;
  }
  if (needPaginationInit) {
    if (paginationEl) currentParams.pagination.el = paginationEl;
    pagination.init();
    pagination.render();
    pagination.update();
  }
  if (needScrollbarInit) {
    if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }
  if (needNavigationInit) {
    if (nextEl) currentParams.navigation.nextEl = nextEl;
    if (prevEl) currentParams.navigation.prevEl = prevEl;
    navigation.init();
    navigation.update();
  }
  if (changedParams.includes('allowSlideNext')) {
    swiper.allowSlideNext = passedParams.allowSlideNext;
  }
  if (changedParams.includes('allowSlidePrev')) {
    swiper.allowSlidePrev = passedParams.allowSlidePrev;
  }
  if (changedParams.includes('direction')) {
    swiper.changeDirection(passedParams.direction, false);
  }
  swiper.update();
}
function renderVirtual(swiper, slides, virtualData) {
  if (!virtualData) return null;
  var style = swiper.isHorizontal() ? _defineProperty({}, swiper.rtlTranslate ? 'right' : 'left', "".concat(virtualData.offset, "px")) : {
    top: "".concat(virtualData.offset, "px")
  };
  return slides.filter(function (child, index) {
    return index >= virtualData.from && index <= virtualData.to;
  }).map(function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      swiper: swiper,
      style: style
    });
  });
}
var updateOnVirtualData = function updateOnVirtualData(swiper) {
  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();
  if (swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }
  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
    swiper.parallax.setTranslate();
  }
};
function useIsomorphicLayoutEffect(callback, deps) {
  // eslint-disable-next-line
  if (typeof window === 'undefined') return useEffect(callback, deps);
  return useLayoutEffect(callback, deps);
}
var SwiperSlideContext = /*#__PURE__*/createContext(null);
var SwiperContext = /*#__PURE__*/createContext(null);
function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
var Swiper = /*#__PURE__*/forwardRef(function (_temp, externalElRef) {
  var _ref15 = _temp === void 0 ? {} : _temp,
    className = _ref15.className,
    _ref15$tag = _ref15.tag,
    Tag = _ref15$tag === void 0 ? 'div' : _ref15$tag,
    _ref15$wrapperTag = _ref15.wrapperTag,
    WrapperTag = _ref15$wrapperTag === void 0 ? 'div' : _ref15$wrapperTag,
    children = _ref15.children,
    onSwiper = _ref15.onSwiper,
    rest = _objectWithoutProperties(_ref15, _excluded);
  var eventsAssigned = false;
  var _useState = useState('swiper'),
    _useState2 = _slicedToArray(_useState, 2),
    containerClasses = _useState2[0],
    setContainerClasses = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    virtualData = _useState4[0],
    setVirtualData = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    breakpointChanged = _useState6[0],
    setBreakpointChanged = _useState6[1];
  var initializedRef = useRef(false);
  var swiperElRef = useRef(null);
  var swiperRef = useRef(null);
  var oldPassedParamsRef = useRef(null);
  var oldSlides = useRef(null);
  var nextElRef = useRef(null);
  var prevElRef = useRef(null);
  var paginationElRef = useRef(null);
  var scrollbarElRef = useRef(null);
  var _getParams = getParams(rest),
    swiperParams = _getParams.params,
    passedParams = _getParams.passedParams,
    restProps = _getParams.rest,
    events = _getParams.events;
  var _getChildren = getChildren(children),
    slides = _getChildren.slides,
    slots = _getChildren.slots;
  var onBeforeBreakpoint = function onBeforeBreakpoint() {
    setBreakpointChanged(!breakpointChanged);
  };
  Object.assign(swiperParams.on, {
    _containerClasses: function _containerClasses(swiper, classes) {
      setContainerClasses(classes);
    }
  });
  var initSwiper = function initSwiper() {
    // init swiper
    Object.assign(swiperParams.on, events);
    eventsAssigned = true;
    swiperRef.current = new Swiper$1(swiperParams);
    swiperRef.current.loopCreate = function () {};
    swiperRef.current.loopDestroy = function () {};
    if (swiperParams.loop) {
      swiperRef.current.loopedSlides = calcLoopedSlides(slides, swiperParams);
    }
    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      var extendWith = {
        cache: false,
        slides: slides,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      extend(swiperRef.current.params.virtual, extendWith);
      extend(swiperRef.current.originalParams.virtual, extendWith);
    }
  };
  if (!swiperElRef.current) {
    initSwiper();
  } // Listen for breakpoints change

  if (swiperRef.current) {
    swiperRef.current.on('_beforeBreakpoint', onBeforeBreakpoint);
  }
  var attachEvents = function attachEvents() {
    if (eventsAssigned || !events || !swiperRef.current) return;
    Object.keys(events).forEach(function (eventName) {
      swiperRef.current.on(eventName, events[eventName]);
    });
  };
  var detachEvents = function detachEvents() {
    if (!events || !swiperRef.current) return;
    Object.keys(events).forEach(function (eventName) {
      swiperRef.current.off(eventName, events[eventName]);
    });
  };
  useEffect(function () {
    return function () {
      if (swiperRef.current) swiperRef.current.off('_beforeBreakpoint', onBeforeBreakpoint);
    };
  }); // set initialized flag

  useEffect(function () {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  }); // mount swiper

  useIsomorphicLayoutEffect(function () {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }
    if (!swiperElRef.current) return;
    if (swiperRef.current.destroyed) {
      initSwiper();
    }
    mountSwiper({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper) onSwiper(swiperRef.current); // eslint-disable-next-line

    return function () {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []); // watch for params change

  useIsomorphicLayoutEffect(function () {
    attachEvents();
    var changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current, function (c) {
      return c.key;
    });
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;
    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      updateSwiper({
        swiper: swiperRef.current,
        slides: slides,
        passedParams: passedParams,
        changedParams: changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }
    return function () {
      detachEvents();
    };
  }); // update on virtual update

  useIsomorphicLayoutEffect(function () {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]); // bypass swiper instance to slides

  function renderSlides() {
    if (swiperParams.virtual) {
      return renderVirtual(swiperRef.current, slides, virtualData);
    }
    if (!swiperParams.loop || swiperRef.current && swiperRef.current.destroyed) {
      return slides.map(function (child) {
        return /*#__PURE__*/React.cloneElement(child, {
          swiper: swiperRef.current
        });
      });
    }
    return renderLoop(swiperRef.current, slides, swiperParams);
  }
  return /*#__PURE__*/React.createElement(Tag, _extends$2({
    ref: swiperElRef,
    className: uniqueClasses("".concat(containerClasses).concat(className ? " ".concat(className) : ''))
  }, restProps), /*#__PURE__*/React.createElement(SwiperContext.Provider, {
    value: swiperRef.current
  }, slots['container-start'], /*#__PURE__*/React.createElement(WrapperTag, {
    className: "swiper-wrapper"
  }, slots['wrapper-start'], renderSlides(), slots['wrapper-end']), needsNavigation(swiperParams) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /*#__PURE__*/React.createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), needsScrollbar(swiperParams) && /*#__PURE__*/React.createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), needsPagination(swiperParams) && /*#__PURE__*/React.createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), slots['container-end']));
});
Swiper.displayName = 'Swiper';
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
var SwiperSlide = /*#__PURE__*/forwardRef(function (_temp, externalRef) {
  var _ref16 = _temp === void 0 ? {} : _temp,
    _ref16$tag = _ref16.tag,
    Tag = _ref16$tag === void 0 ? 'div' : _ref16$tag,
    children = _ref16.children,
    _ref16$className = _ref16.className,
    className = _ref16$className === void 0 ? '' : _ref16$className,
    swiper = _ref16.swiper,
    zoom = _ref16.zoom,
    virtualIndex = _ref16.virtualIndex,
    rest = _objectWithoutProperties(_ref16, _excluded2);
  var slideElRef = useRef(null);
  var _useState7 = useState('swiper-slide'),
    _useState8 = _slicedToArray(_useState7, 2),
    slideClasses = _useState8[0],
    setSlideClasses = _useState8[1];
  function updateClasses(_s, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }
  useIsomorphicLayoutEffect(function () {
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }
    if (!slideElRef.current || !swiper) {
      return;
    }
    if (swiper.destroyed) {
      if (slideClasses !== 'swiper-slide') {
        setSlideClasses('swiper-slide');
      }
      return;
    }
    swiper.on('_slideClass', updateClasses); // eslint-disable-next-line

    return function () {
      if (!swiper) return;
      swiper.off('_slideClass', updateClasses);
    };
  });
  useIsomorphicLayoutEffect(function () {
    if (swiper && slideElRef.current && !swiper.destroyed) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  var slideData = {
    isActive: slideClasses.indexOf('swiper-slide-active') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-active') >= 0,
    isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
    isDuplicate: slideClasses.indexOf('swiper-slide-duplicate') >= 0,
    isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-prev') >= 0,
    isNext: slideClasses.indexOf('swiper-slide-next') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-next') >= 0
  };
  var renderChildren = function renderChildren() {
    return typeof children === 'function' ? children(slideData) : children;
  };
  return /*#__PURE__*/React.createElement(Tag, _extends$1({
    ref: slideElRef,
    className: uniqueClasses("".concat(slideClasses).concat(className ? " ".concat(className) : '')),
    "data-swiper-slide-index": virtualIndex
  }, rest), /*#__PURE__*/React.createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, zoom ? /*#__PURE__*/React.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
  }, renderChildren()) : renderChildren()));
});
SwiperSlide.displayName = 'SwiperSlide';
var defaultProps$1 = {
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1
    },
    640: {
      slidesPerView: 2
    },
    953: {
      slidesPerView: 3
    },
    1200: {
      slidesPerView: 3
    }
  }
};
var overlapsProps = {
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1.2
    },
    953: {
      slidesPerView: 2.2
    },
    1200: {
      slidesPerView: 3,
      slideToClickedSlide: false
    }
  },
  slideToClickedSlide: true,
  allowTouchMove: true,
  initialSlide: 0,
  spaceBetween: 12,
  height: 200,
  loop: true
};
var PROPS = {
  defaultProps: defaultProps$1,
  overlapsProps: overlapsProps
};
var img$6 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='21' height='21' viewBox='0 0 21 21'%3e%3cdefs%3e%3cstyle%3e.a%7bfill:%23333%3b%7d.b%7bfill:none%3b%7d%3c/style%3e%3c/defs%3e%3cg transform='translate(21 21) rotate(180)'%3e%3cpath class='a' d='M11.441%2c11.76l7.945%2c7.928%2c7.945-7.928L29.772%2c14.2%2c19.386%2c24.587%2c9%2c14.2Z' transform='translate(-9 -7.76)'/%3e%3cpath class='b' d='M0%2c0H21V21H0Z'/%3e%3c/g%3e%3c/svg%3e";
var styles$q = {
  "container": "swiper-module_container__uI5I6",
  "less3Elements": "swiper-module_less3Elements__noCnB",
  "element": "swiper-module_element__DhhVx",
  "progressbar": "swiper-module_progressbar__7K-XX",
  "wrapper": "swiper-module_wrapper__T6S68",
  "leftArrowWrapper": "swiper-module_leftArrowWrapper__O5-vF",
  "rightArrowWrapper": "swiper-module_rightArrowWrapper__GG4N-",
  "arrowLeft": "swiper-module_arrowLeft__OTUV9",
  "arrowRight": "swiper-module_arrowRight__M06RD",
  "swiperFooter": "swiper-module_swiperFooter__odwZI",
  "hideMe": "swiper-module_hideMe__sdZzT",
  "fadeInDown": "swiper-module_fadeInDown__s7QiA",
  "fadeInUp": "swiper-module_fadeInUp__HKStJ",
  "fadeInDropdown": "swiper-module_fadeInDropdown__fsT9R",
  "fadeOutDropdown": "swiper-module_fadeOutDropdown__zSXQx"
};
var SwiperComponent = function SwiperComponent(_a) {
  var children = _a.children,
    _b = _a.overlaps,
    overlaps = _b === void 0 ? false : _b,
    _c = _a.showArrows,
    showArrows = _c === void 0 ? false : _c,
    _d = _a.pagination,
    pagination = _d === void 0 ? true : _d,
    _e = _a.paginationType,
    paginationType = _e === void 0 ? "bullets" : _e,
    slidesPerView = _a.slidesPerView,
    _f = _a.spaceBetween,
    spaceBetween = _f === void 0 ? 16 : _f,
    _g = _a.avoidOnDesktopIfLessThan3Elements,
    avoidOnDesktopIfLessThan3Elements = _g === void 0 ? false : _g,
    onSlideChange = _a.onSlideChange,
    onClick = _a.onClick,
    rest = __rest$1(_a, ["children", "overlaps", "showArrows", "pagination", "paginationType", "slidesPerView", "spaceBetween", "avoidOnDesktopIfLessThan3Elements", "onSlideChange", "onClick"]);
  var _h = useState(),
    swiperInstance = _h[0],
    setSwiperInstance = _h[1];
  var paginationRef = useRef(null);
  var props = overlaps ? PROPS.overlapsProps : slidesPerView ? _assign$(_assign$({}, PROPS.defaultProps), {
    breakpoints: {},
    slidesPerView: slidesPerView
  }) : PROPS.defaultProps;
  var swiperElementsLength = Children.count(children);
  var isDesktop = reactResponsiveExports.useMediaQuery({
    query: "(min-width: 953px)"
  });
  var paginationParameters = pagination ? {
    clickable: true,
    el: paginationRef.current,
    type: paginationType
  } : false;
  var ArrowPrev = function ArrowPrev() {
    return React.createElement("div", {
      className: styles$q.leftArrowWrapper,
      onClick: function onClick() {
        return swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.slidePrev();
      }
    }, React.createElement("img", {
      alt: "swiper arrow left",
      src: img$6,
      width: 20,
      className: styles$q.arrowLeft
    }));
  };
  var ArrowNext = function ArrowNext() {
    return React.createElement("div", {
      className: styles$q.rightArrowWrapper,
      onClick: function onClick() {
        return swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.slideNext();
      }
    }, React.createElement("img", {
      alt: "swiper arrow right",
      src: img$6,
      width: 20,
      className: styles$q.arrowRight
    }));
  };
  if (avoidOnDesktopIfLessThan3Elements && overlaps && isDesktop && swiperElementsLength <= 3) {
    return React.createElement("div", {
      className: "".concat(styles$q.container, " ").concat(styles$q.less3Elements)
    }, children === null || children === void 0 ? void 0 : children.map(function (element, index) {
      return React.createElement("div", {
        className: styles$q.element,
        key: index
      }, element);
    }));
  }
  return React.createElement("div", {
    className: "".concat(styles$q.container, " ").concat(styles$q[paginationType])
  }, paginationType === "bullets" ? React.createElement(React.Fragment, null, React.createElement(Swiper, _assign$({
    onInit: function onInit(swiper) {
      return setSwiperInstance(swiper);
    },
    modules: [Pagination]
  }, _assign$(_assign$(_assign$({}, props), rest), {
    spaceBetween: spaceBetween,
    pagination: paginationParameters,
    showsPagination: pagination,
    onSlideChange: onSlideChange,
    onClick: onClick
  })), children === null || children === void 0 ? void 0 : children.map(function (element, index) {
    return React.createElement(SwiperSlide, {
      key: index
    }, element);
  })), React.createElement("div", {
    className: styles$q.swiperFooter
  }, showArrows && React.createElement(ArrowPrev, null), React.createElement("div", {
    className: !pagination ? styles$q.hideMe : "",
    ref: paginationRef
  }), showArrows && React.createElement(ArrowNext, null))) : null, paginationType === "progressbar" ? React.createElement(React.Fragment, null, showArrows && paginationType === "progressbar" && React.createElement(ArrowPrev, null), React.createElement("div", {
    className: styles$q.wrapper
  }, React.createElement(Swiper, _assign$({
    onInit: function onInit(swiper) {
      return setSwiperInstance(swiper);
    },
    modules: [Pagination]
  }, _assign$(_assign$(_assign$({}, props), rest), {
    spaceBetween: spaceBetween,
    pagination: paginationParameters,
    onSlideChange: onSlideChange,
    onClick: onClick
  })), children === null || children === void 0 ? void 0 : children.map(function (element, index) {
    return React.createElement(SwiperSlide, {
      key: index
    }, element);
  })), React.createElement("div", {
    className: styles$q.swiperFooter
  }, React.createElement("div", {
    className: !pagination ? styles$q.hideMe : "",
    ref: paginationRef
  }))), showArrows && paginationType === "progressbar" && React.createElement(ArrowNext, null)) : null);
};
var img$5 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='21' height='21' viewBox='0 0 21 21'%3e %3cdefs%3e %3cstyle%3e.a%7bfill:%23DBDBDB%3b%7d.b%7bfill:none%3b%7d%3c/style%3e %3c/defs%3e %3cg transform='translate(21 21) rotate(180)'%3e %3cpath class='a' d='M11.441%2c11.76l7.945%2c7.928%2c7.945-7.928L29.772%2c14.2%2c19.386%2c24.587%2c9%2c14.2Z' transform='translate(-9 -7.76)'/%3e %3cpath class='b' d='M0%2c0H21V21H0Z'/%3e %3c/g%3e%3c/svg%3e";
var styles$p = {
  "whiteSection": "join-the-community-module_whiteSection__XKKa0",
  "sectionTitle": "join-the-community-module_sectionTitle__QuGDv",
  "swiperWrapper": "join-the-community-module_swiperWrapper__xat8n",
  "swiperItem": "join-the-community-module_swiperItem__QFQxz",
  "leftArrowWrapper": "join-the-community-module_leftArrowWrapper__cy0lQ",
  "rightArrowWrapper": "join-the-community-module_rightArrowWrapper__25I2J",
  "bottomText": "join-the-community-module_bottomText__vCKW6",
  "fadeInDown": "join-the-community-module_fadeInDown__XohnQ",
  "fadeInUp": "join-the-community-module_fadeInUp__wj9Ck",
  "fadeInDropdown": "join-the-community-module_fadeInDropdown__-Ce8r",
  "fadeOutDropdown": "join-the-community-module_fadeOutDropdown__5WTAD"
};
var JoinTheCommunityUI = function JoinTheCommunityUI(_a) {
  var landing = _a.landing,
    _b = _a.className,
    className = _b === void 0 ? "" : _b;
  var _c = useState(),
    swiperInstance = _c[0],
    setSwiperInstance = _c[1];
  var isSmallDesktop = reactResponsiveExports.useMediaQuery({
    query: "(min-width: 1024px)"
  });
  var isMediumDesktop = reactResponsiveExports.useMediaQuery({
    query: "(min-width: 1366px)"
  });
  var showArrows = isSmallDesktop && !isMediumDesktop;
  var ArrowPrev = function ArrowPrev() {
    return React.createElement("div", {
      className: styles$p.leftArrowWrapper,
      onClick: function onClick() {
        return swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.slidePrev();
      }
    }, React.createElement("img", {
      alt: "swiper arrow left",
      src: img$5,
      width: 20,
      className: styles$p.arrowLeft
    }));
  };
  var ArrowNext = function ArrowNext() {
    return React.createElement("div", {
      className: styles$p.rightArrowWrapper,
      onClick: function onClick() {
        return swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.slideNext();
      }
    }, React.createElement("img", {
      alt: "swiper arrow right",
      src: img$5,
      width: 20,
      className: styles$p.arrowRight
    }));
  };
  return React.createElement("section", {
    className: "".concat(styles$p.whiteSection, " ").concat(className)
  }, React.createElement("h2", {
    className: styles$p.sectionTitle
  }, landing.join_us_header), React.createElement("div", {
    className: styles$p.swiperWrapper
  }, showArrows && React.createElement(ArrowPrev, null), React.createElement(SwiperComponent, {
    onInit: function onInit(swiper) {
      return setSwiperInstance(swiper);
    },
    pagination: false,
    allowTouchMove: !isMediumDesktop,
    slideToClickedSlide: !isMediumDesktop,
    breakpoints: {
      320: {
        slidesPerView: 1.15,
        slidesOffsetBefore: 8,
        slidesOffsetAfter: 8
      },
      375: {
        slidesPerView: 1.35,
        slidesOffsetBefore: 15,
        slidesOffsetAfter: 15
      },
      414: {
        slidesPerView: 1.4,
        slidesOffsetBefore: 30,
        slidesOffsetAfter: 30
      },
      768: {
        slidesPerView: 2.4,
        slidesOffsetBefore: 68,
        slidesOffsetAfter: 68
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0
      },
      1366: {
        slidesPerView: 4,
        spaceBetween: 16
      }
    }
  }, React.createElement("div", {
    className: styles$p.swiperItem
  }, React.createElement("a", {
    href: landing.join_us_link_1,
    target: "_blank"
  }, React.createElement(Image, {
    width: 400,
    filename: landing.join_us_image_1.filename_disk
  }), landing.join_us_text_1 && React.createElement("p", null, landing.join_us_text_1))), React.createElement("div", {
    className: styles$p.swiperItem
  }, React.createElement("a", {
    href: landing.join_us_link_2,
    target: "_blank"
  }, React.createElement(Image, {
    width: 400,
    filename: landing.join_us_image_2.filename_disk
  }), landing.join_us_text_2 && React.createElement("p", null, landing.join_us_text_2))), React.createElement("div", {
    className: styles$p.swiperItem
  }, React.createElement("a", {
    href: landing.join_us_link_3,
    target: "_blank"
  }, React.createElement(Image, {
    width: 400,
    filename: landing.join_us_image_3.filename_disk
  }), landing.join_us_text_3 && React.createElement("p", null, landing.join_us_text_3))), React.createElement("div", {
    className: styles$p.swiperItem
  }, React.createElement("a", {
    href: landing.join_us_link_4,
    target: "_blank"
  }, React.createElement(Image, {
    width: 400,
    filename: landing.join_us_image_4.filename_disk
  }), landing.join_us_text_4 && React.createElement("p", null, landing.join_us_text_4)))), showArrows && !isMediumDesktop && React.createElement(ArrowNext, null)), React.createElement("div", {
    className: styles$p.bottomText
  }, React.createElement("a", {
    href: "https://www.instagram.com/vitlhealth/",
    target: "_blank"
  }, landing.join_us_text)));
};
var styles$o = {
  "reviews": "review-new-module_reviews__bYxwH",
  "container": "review-new-module_container__8XL-y",
  "reviewsWrap": "review-new-module_reviewsWrap__s3Qmq",
  "review": "review-new-module_review__yuO92",
  "rating": "review-new-module_rating__wiqua",
  "star": "review-new-module_star__2IKXr",
  "fadeInDown": "review-new-module_fadeInDown__3agiH",
  "fadeInUp": "review-new-module_fadeInUp__TiYPX",
  "fadeInDropdown": "review-new-module_fadeInDropdown__5T7IW",
  "fadeOutDropdown": "review-new-module_fadeOutDropdown__69cnu"
};
var ReviewNewUI = function ReviewNewUI(_a) {
  var title = _a.title,
    items = _a.items,
    _b = _a.className,
    className = _b === void 0 ? "" : _b;
  return React.createElement("div", {
    className: "".concat(styles$o.reviews, " ").concat(className)
  }, React.createElement("div", {
    className: styles$o.container
  }, React.createElement("h2", null, title), React.createElement("div", {
    className: styles$o.reviewsWrap
  }, React.createElement(SwiperComponent, {
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 8
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 16
      }
    }
  }, items.map(function (item, index) {
    return React.createElement("div", {
      key: index,
      className: styles$o.review
    }, React.createElement("p", null, item.review), React.createElement("div", {
      className: styles$o.rating
    }, Array(item.rating).fill(1).map(function () {
      return React.createElement("span", {
        className: styles$o.star
      }, "\u2605");
    })));
  })))));
};
var styles$n = {
  "section": "reviews-module_section__2IAk4",
  "container": "reviews-module_container__hUZNq",
  "yellow": "reviews-module_yellow__XAgrE",
  "lightYellow": "reviews-module_lightYellow__TO7v3",
  "sectionTitle": "reviews-module_sectionTitle__aaVy-",
  "withTrustpilot": "reviews-module_withTrustpilot__1RMBM",
  "swiperContainer": "reviews-module_swiperContainer__PGTBt",
  "item": "reviews-module_item__gdljT",
  "icon": "reviews-module_icon__wptgE",
  "review": "reviews-module_review__OVSg-",
  "reviewerName": "reviews-module_reviewerName__aJaMv",
  "trustPilotWrapper": "reviews-module_trustPilotWrapper__SpOIa",
  "fadeInDown": "reviews-module_fadeInDown__ilzM1",
  "fadeInUp": "reviews-module_fadeInUp__kb7NN",
  "fadeInDropdown": "reviews-module_fadeInDropdown__CevFU",
  "fadeOutDropdown": "reviews-module_fadeOutDropdown__WbCnB"
};
var ReviewsUI = function ReviewsUI(_a) {
  var title = _a.title,
    items = _a.items,
    hideTrustPilot = _a.hideTrustPilot,
    _b = _a.showReview,
    showReview = _b === void 0 ? false : _b,
    _c = _a.trustpilotIframe,
    trustpilotIframe = _c === void 0 ? false : _c,
    variationYellow = _a.variationYellow,
    variationLightYellow = _a.variationLightYellow,
    _d = _a.className,
    className = _d === void 0 ? "" : _d,
    _e = _a.image,
    image = _e === void 0 ? "" : _e,
    _f = _a.backgroundColor,
    backgroundColor = _f === void 0 ? "" : _f;
  if (!showReview) return null;
  var hasTrustpilot = !hideTrustPilot && trustpilotIframe;
  var getVariation = function getVariation() {
    if (variationYellow) return styles$n.yellow;
    if (variationLightYellow) return styles$n.lightYellow;
    return "";
  };
  return React.createElement("section", {
    className: "".concat(styles$n.section, " ").concat(getVariation(), " ").concat(className),
    style: {
      backgroundImage: "url(".concat(image, ")"),
      backgroundColor: backgroundColor
    }
  }, React.createElement("div", {
    className: styles$n.container
  }, React.createElement(React.Fragment, null, React.createElement("h2", {
    className: "".concat(styles$n.sectionTitle, " ").concat(hasTrustpilot ? styles$n.withTrustpilot : "")
  }, title), hasTrustpilot ? React.createElement("div", {
    className: styles$n.trustPilotWrapper
  }, trustpilotIframe) : null, React.createElement("div", {
    className: "".concat(styles$n.swiperContainer, " ").concat(hasTrustpilot ? styles$n.withTrustpilot : "")
  }, React.createElement(SwiperComponent, {
    pagination: {
      clickable: true
    },
    spaceBetween: 16,
    breakpoints: {
      1024: {
        slidesPerView: 3
      },
      1280: {
        slidesPerView: 3
      }
    }
  }, items.map(function (item, index) {
    return React.createElement("div", {
      key: index,
      className: styles$n.item
    }, React.createElement("div", {
      className: styles$n.itemContainer
    }, item.review && React.createElement("p", {
      className: styles$n.review
    }, item.review), item.reviewerName && React.createElement("p", {
      className: styles$n.reviewerName
    }, item.reviewerName)));
  }))))));
};
var styles$m = {
  "sectionPrimaryLighter": "still-have-question-module_sectionPrimaryLighter__OeiNb",
  "container": "still-have-question-module_container__xh-T-",
  "fadeInDown": "still-have-question-module_fadeInDown__U9nN1",
  "faqDescription": "still-have-question-module_faqDescription__Il9Hg",
  "sectionTitle": "still-have-question-module_sectionTitle__U1Jhm",
  "hr": "still-have-question-module_hr__KSw7c",
  "fadeInUp": "still-have-question-module_fadeInUp__7OYru",
  "fadeInDropdown": "still-have-question-module_fadeInDropdown__iVgDf",
  "fadeOutDropdown": "still-have-question-module_fadeOutDropdown__K7s7K"
};
var StillHaveQuestionUI = function StillHaveQuestionUI(_a) {
  var _b = _a.title,
    title = _b === void 0 ? "Still have questions?" : _b,
    accordion = _a.accordion,
    description = _a.description,
    _c = _a.className,
    className = _c === void 0 ? "" : _c;
  return React.createElement("section", {
    className: "".concat(styles$m.sectionPrimaryLighter, " ").concat(className)
  }, React.createElement("div", {
    className: styles$m.container
  }, React.createElement("h2", {
    className: styles$m.sectionTitle
  }, title), React.createElement("hr", {
    className: styles$m.hr
  }), React.createElement(Accordion, {
    isHtmlContent: true,
    items: accordion
  }), React.createElement("div", {
    className: styles$m.faqDescription,
    dangerouslySetInnerHTML: {
      __html: description
    }
  })));
};
var getDirectusImageUrl = function getDirectusImageUrl(filename) {
  return "".concat(projectConfig.mediaUrl).concat(filename);
};
var styles$l = {
  "section": "expert-approval-module_section__PXc87",
  "sectionPrimaryLighter": "expert-approval-module_sectionPrimaryLighter__L8uW0",
  "container": "expert-approval-module_container__XAPU9",
  "items": "expert-approval-module_items__7L7Bj",
  "grid-column": "expert-approval-module_grid-column__9CDve",
  "col-xl": "expert-approval-module_col-xl__KIKni",
  "col-xl-auto": "expert-approval-module_col-xl-auto__21Z0P",
  "col-xl-12": "expert-approval-module_col-xl-12__c2tl4",
  "col-xl-11": "expert-approval-module_col-xl-11__K01qS",
  "col-xl-10": "expert-approval-module_col-xl-10__bDKB1",
  "col-xl-9": "expert-approval-module_col-xl-9__kVqkG",
  "col-xl-8": "expert-approval-module_col-xl-8__eddn8",
  "col-xl-7": "expert-approval-module_col-xl-7__McQub",
  "col-xl-6": "expert-approval-module_col-xl-6__VqNGT",
  "col-xl-5": "expert-approval-module_col-xl-5__nR00-",
  "col-xl-4": "expert-approval-module_col-xl-4__0cRzd",
  "col-xl-3": "expert-approval-module_col-xl-3__HOox5",
  "col-xl-2": "expert-approval-module_col-xl-2__e9OB2",
  "col-xl-1": "expert-approval-module_col-xl-1__3JkhY",
  "col-lg": "expert-approval-module_col-lg__te37g",
  "col-lg-auto": "expert-approval-module_col-lg-auto__AdZ6f",
  "col-lg-12": "expert-approval-module_col-lg-12__XjRsy",
  "col-lg-11": "expert-approval-module_col-lg-11__IWfT0",
  "col-lg-10": "expert-approval-module_col-lg-10__TIGPC",
  "col-lg-9": "expert-approval-module_col-lg-9__Iyw2q",
  "col-lg-8": "expert-approval-module_col-lg-8__gDaxy",
  "col-lg-7": "expert-approval-module_col-lg-7__BGzyy",
  "col-lg-6": "expert-approval-module_col-lg-6__q2ei8",
  "col-lg-5": "expert-approval-module_col-lg-5__sOCUg",
  "col-lg-4": "expert-approval-module_col-lg-4__TpcEh",
  "col-lg-3": "expert-approval-module_col-lg-3__x-X8i",
  "item": "expert-approval-module_item__--GFb",
  "col-lg-2": "expert-approval-module_col-lg-2__2pQ0f",
  "col-lg-1": "expert-approval-module_col-lg-1__DxvlN",
  "col-md": "expert-approval-module_col-md__6N0bR",
  "col-md-auto": "expert-approval-module_col-md-auto__eWNcu",
  "col-md-12": "expert-approval-module_col-md-12__yvqGF",
  "col-md-11": "expert-approval-module_col-md-11__0dMak",
  "col-md-10": "expert-approval-module_col-md-10__MUT6o",
  "col-md-9": "expert-approval-module_col-md-9__Vo-T7",
  "col-md-8": "expert-approval-module_col-md-8__Ev52n",
  "description": "expert-approval-module_description__dzi5G",
  "col-md-7": "expert-approval-module_col-md-7__Pjuj8",
  "col-md-6": "expert-approval-module_col-md-6__jo81p",
  "col-md-5": "expert-approval-module_col-md-5__HPnRg",
  "col-md-4": "expert-approval-module_col-md-4__TzZN-",
  "col-md-3": "expert-approval-module_col-md-3__h4qw1",
  "col-md-2": "expert-approval-module_col-md-2__lzO-t",
  "col-md-1": "expert-approval-module_col-md-1__DUM0K",
  "col-xs": "expert-approval-module_col-xs__s7AuH",
  "col-xs-auto": "expert-approval-module_col-xs-auto__YMqga",
  "col-xs-12": "expert-approval-module_col-xs-12__LupUL",
  "col-xs-11": "expert-approval-module_col-xs-11__btx3o",
  "col-xs-10": "expert-approval-module_col-xs-10__JeGMU",
  "col-xs-9": "expert-approval-module_col-xs-9__BsVQH",
  "col-xs-8": "expert-approval-module_col-xs-8__rOIkh",
  "col-xs-7": "expert-approval-module_col-xs-7__McyCJ",
  "col-xs-6": "expert-approval-module_col-xs-6__kzHBm",
  "col-xs-5": "expert-approval-module_col-xs-5__rdAxn",
  "col-xs-4": "expert-approval-module_col-xs-4__3wK4H",
  "col-xs-3": "expert-approval-module_col-xs-3__DxVqY",
  "col-xs-2": "expert-approval-module_col-xs-2__BtGIB",
  "col-xs-1": "expert-approval-module_col-xs-1__u7bhd",
  "order-xs-first": "expert-approval-module_order-xs-first__zBAZJ",
  "order-xs-last": "expert-approval-module_order-xs-last__YyULZ",
  "order-xs-0": "expert-approval-module_order-xs-0__fwAWJ",
  "order-xs-1": "expert-approval-module_order-xs-1__Lbnqs",
  "order-xs-2": "expert-approval-module_order-xs-2__eiLHz",
  "order-xs-3": "expert-approval-module_order-xs-3__J1zvz",
  "order-xs-4": "expert-approval-module_order-xs-4__HcSNz",
  "order-xs-5": "expert-approval-module_order-xs-5__kF8Vi",
  "order-xs-6": "expert-approval-module_order-xs-6__X3KJi",
  "order-xs-7": "expert-approval-module_order-xs-7__kp3oa",
  "order-xs-8": "expert-approval-module_order-xs-8__1LUFr",
  "order-xs-9": "expert-approval-module_order-xs-9__RvAR3",
  "order-xs-10": "expert-approval-module_order-xs-10__9m47b",
  "order-xs-11": "expert-approval-module_order-xs-11__wtQhn",
  "order-xs-12": "expert-approval-module_order-xs-12__7ikOd",
  "offset-xs-0": "expert-approval-module_offset-xs-0__YlnBU",
  "offset-xs-1": "expert-approval-module_offset-xs-1__V1FqZ",
  "offset-xs-2": "expert-approval-module_offset-xs-2__4ID4s",
  "offset-xs-3": "expert-approval-module_offset-xs-3__8UKjx",
  "offset-xs-4": "expert-approval-module_offset-xs-4__lW8i-",
  "offset-xs-5": "expert-approval-module_offset-xs-5__uufbo",
  "offset-xs-6": "expert-approval-module_offset-xs-6__7PZqQ",
  "offset-xs-7": "expert-approval-module_offset-xs-7__cVLhV",
  "offset-xs-8": "expert-approval-module_offset-xs-8__1sq3w",
  "offset-xs-9": "expert-approval-module_offset-xs-9__5q3Za",
  "offset-xs-10": "expert-approval-module_offset-xs-10__pgB8g",
  "offset-xs-11": "expert-approval-module_offset-xs-11__rE2Xz",
  "order-md-first": "expert-approval-module_order-md-first__U9Ffu",
  "order-md-last": "expert-approval-module_order-md-last__BUEC6",
  "order-md-0": "expert-approval-module_order-md-0__A-9A9",
  "order-md-1": "expert-approval-module_order-md-1__NvmK9",
  "order-md-2": "expert-approval-module_order-md-2__MYyrV",
  "order-md-3": "expert-approval-module_order-md-3__Tjt4C",
  "order-md-4": "expert-approval-module_order-md-4__T-mL-",
  "order-md-5": "expert-approval-module_order-md-5__qK3-8",
  "order-md-6": "expert-approval-module_order-md-6__atLgd",
  "order-md-7": "expert-approval-module_order-md-7__uj9aI",
  "order-md-8": "expert-approval-module_order-md-8__fx9df",
  "order-md-9": "expert-approval-module_order-md-9__zugTo",
  "order-md-10": "expert-approval-module_order-md-10__-F0wz",
  "order-md-11": "expert-approval-module_order-md-11__9-EzV",
  "order-md-12": "expert-approval-module_order-md-12__W14qz",
  "offset-md-0": "expert-approval-module_offset-md-0__vT8h-",
  "offset-md-1": "expert-approval-module_offset-md-1__UnWF0",
  "offset-md-2": "expert-approval-module_offset-md-2__A-ZlW",
  "offset-md-3": "expert-approval-module_offset-md-3__JfWsP",
  "offset-md-4": "expert-approval-module_offset-md-4__B5Cfh",
  "offset-md-5": "expert-approval-module_offset-md-5__KF3il",
  "offset-md-6": "expert-approval-module_offset-md-6__pL6rU",
  "offset-md-7": "expert-approval-module_offset-md-7__DhlUj",
  "offset-md-8": "expert-approval-module_offset-md-8__H8MCA",
  "offset-md-9": "expert-approval-module_offset-md-9__QFoBF",
  "offset-md-10": "expert-approval-module_offset-md-10__rZm5p",
  "offset-md-11": "expert-approval-module_offset-md-11__Vto1L",
  "order-lg-first": "expert-approval-module_order-lg-first__BJsHs",
  "order-lg-last": "expert-approval-module_order-lg-last__8Kf5i",
  "order-lg-0": "expert-approval-module_order-lg-0__qRD8X",
  "order-lg-1": "expert-approval-module_order-lg-1__r-FdE",
  "order-lg-2": "expert-approval-module_order-lg-2__Yavtq",
  "order-lg-3": "expert-approval-module_order-lg-3__ZbHMu",
  "order-lg-4": "expert-approval-module_order-lg-4__6aF9u",
  "order-lg-5": "expert-approval-module_order-lg-5__7-6pA",
  "order-lg-6": "expert-approval-module_order-lg-6__5482Q",
  "order-lg-7": "expert-approval-module_order-lg-7__OzOTL",
  "order-lg-8": "expert-approval-module_order-lg-8__ZgEix",
  "order-lg-9": "expert-approval-module_order-lg-9__MuuCs",
  "order-lg-10": "expert-approval-module_order-lg-10__Toj-4",
  "order-lg-11": "expert-approval-module_order-lg-11__87F9-",
  "order-lg-12": "expert-approval-module_order-lg-12__OED19",
  "offset-lg-0": "expert-approval-module_offset-lg-0__U3XPi",
  "offset-lg-1": "expert-approval-module_offset-lg-1__-jR60",
  "offset-lg-2": "expert-approval-module_offset-lg-2__e8pdr",
  "offset-lg-3": "expert-approval-module_offset-lg-3__zvQ9N",
  "offset-lg-4": "expert-approval-module_offset-lg-4__46Atf",
  "offset-lg-5": "expert-approval-module_offset-lg-5__BMj08",
  "offset-lg-6": "expert-approval-module_offset-lg-6__lwr5W",
  "offset-lg-7": "expert-approval-module_offset-lg-7__19MEL",
  "offset-lg-8": "expert-approval-module_offset-lg-8__Lsmxe",
  "offset-lg-9": "expert-approval-module_offset-lg-9__7imos",
  "offset-lg-10": "expert-approval-module_offset-lg-10__ISpRz",
  "offset-lg-11": "expert-approval-module_offset-lg-11__h6zUs",
  "order-xl-first": "expert-approval-module_order-xl-first__kxK8x",
  "order-xl-last": "expert-approval-module_order-xl-last__omDZA",
  "order-xl-0": "expert-approval-module_order-xl-0__ZGAn8",
  "order-xl-1": "expert-approval-module_order-xl-1__EZ4p2",
  "order-xl-2": "expert-approval-module_order-xl-2__HOtQP",
  "order-xl-3": "expert-approval-module_order-xl-3__rAPsP",
  "order-xl-4": "expert-approval-module_order-xl-4__Fh9nf",
  "order-xl-5": "expert-approval-module_order-xl-5__HL4ei",
  "order-xl-6": "expert-approval-module_order-xl-6__kEiaX",
  "order-xl-7": "expert-approval-module_order-xl-7__yReZK",
  "order-xl-8": "expert-approval-module_order-xl-8__IJNrk",
  "order-xl-9": "expert-approval-module_order-xl-9__eMefG",
  "order-xl-10": "expert-approval-module_order-xl-10__gWIwu",
  "order-xl-11": "expert-approval-module_order-xl-11__g4CA3",
  "order-xl-12": "expert-approval-module_order-xl-12__IqY38",
  "offset-xl-0": "expert-approval-module_offset-xl-0__QSld3",
  "offset-xl-1": "expert-approval-module_offset-xl-1__8mnYR",
  "offset-xl-2": "expert-approval-module_offset-xl-2__QFhRP",
  "offset-xl-3": "expert-approval-module_offset-xl-3__PEty-",
  "offset-xl-4": "expert-approval-module_offset-xl-4__O5bIe",
  "offset-xl-5": "expert-approval-module_offset-xl-5__tNuSn",
  "offset-xl-6": "expert-approval-module_offset-xl-6__FL9uQ",
  "offset-xl-7": "expert-approval-module_offset-xl-7__Cbfvz",
  "offset-xl-8": "expert-approval-module_offset-xl-8__ksXi4",
  "offset-xl-9": "expert-approval-module_offset-xl-9__AjNpp",
  "offset-xl-10": "expert-approval-module_offset-xl-10__18h1O",
  "offset-xl-11": "expert-approval-module_offset-xl-11__hCcQQ",
  "image": "expert-approval-module_image__ijgHB",
  "nextImage": "expert-approval-module_nextImage__iAFpW",
  "details": "expert-approval-module_details__NFORl",
  "name": "expert-approval-module_name__MEZ6C",
  "fadeInDown": "expert-approval-module_fadeInDown__g-kQl",
  "fadeInUp": "expert-approval-module_fadeInUp__mQ1Rr",
  "fadeInDropdown": "expert-approval-module_fadeInDropdown__m7msf",
  "fadeOutDropdown": "expert-approval-module_fadeOutDropdown__CHfpd"
};
var ExpertApproval = function ExpertApproval(_a) {
  var title = _a.title,
    description = _a.description,
    experts = _a.experts,
    backgroundColor = _a.backgroundColor,
    renderImage = _a.renderImage;
  return React.createElement("section", {
    className: backgroundColor ? styles$l["section".concat(backgroundColor)] : styles$l.section
  }, React.createElement("div", {
    className: styles$l.container
  }, React.createElement("h2", null, title), React.createElement("hr", null), React.createElement("div", {
    className: styles$l.description,
    dangerouslySetInnerHTML: {
      __html: description
    }
  }), React.createElement("ul", {
    className: styles$l.items,
    "aria-label": "Experts"
  }, experts.map(function (expert) {
    var _a, _b;
    return React.createElement("li", {
      key: expert.name,
      className: styles$l.item
    }, renderImage ? React.createElement("div", {
      className: styles$l.nextImage
    }, renderImage({
      fill: true,
      alt: expert.name,
      src: getDirectusImageUrl(expert.filename_disk || ((_a = expert.image) === null || _a === void 0 ? void 0 : _a.filename_disk) || ""),
      quality: 100
    })) : React.createElement("div", {
      className: styles$l.image
    }, React.createElement(Image, {
      filename: expert.filename_disk || ((_b = expert.image) === null || _b === void 0 ? void 0 : _b.filename_disk),
      width: 150,
      alt: expert.name
    })), React.createElement("div", {
      className: styles$l.details
    }, React.createElement("p", {
      className: styles$l.name
    }, React.createElement("strong", null, expert.name)), React.createElement("p", null, React.createElement("strong", null, expert.role)), React.createElement("p", {
      className: styles$l.qualification
    }, expert.qualification)));
  }))));
};
var img$4 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3e%3cpath fill='%2346bc8f' d='M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 17.292l-4.5-4.364 1.857-1.858 2.643 2.506 5.643-5.784 1.857 1.857-7.5 7.643z'/%3e%3c/svg%3e";
var styles$k = {
  "section": "how-it-works-module_section__Nhs8Q",
  "sectionPrimaryLighter": "how-it-works-module_sectionPrimaryLighter__RD9Bt",
  "sectionPrimary": "how-it-works-module_sectionPrimary__-vmfe",
  "container": "how-it-works-module_container__wd5yb",
  "hr": "how-it-works-module_hr__p7UB2",
  "hrDark": "how-it-works-module_hrDark__VLgJt",
  "grid-column": "how-it-works-module_grid-column__4Ne40",
  "col-xl": "how-it-works-module_col-xl__U1MN4",
  "col-xl-auto": "how-it-works-module_col-xl-auto__IQ6Wu",
  "col-xl-12": "how-it-works-module_col-xl-12__B2NxH",
  "col-xl-11": "how-it-works-module_col-xl-11__EGrBO",
  "col-xl-10": "how-it-works-module_col-xl-10__oxuWJ",
  "col-xl-9": "how-it-works-module_col-xl-9__8LVSx",
  "col-xl-8": "how-it-works-module_col-xl-8__JB-fF",
  "col-xl-7": "how-it-works-module_col-xl-7__hb3RF",
  "col-xl-6": "how-it-works-module_col-xl-6__ez7xu",
  "col-xl-5": "how-it-works-module_col-xl-5__0sQz5",
  "col-xl-4": "how-it-works-module_col-xl-4__etK-2",
  "col-xl-3": "how-it-works-module_col-xl-3__vNmvP",
  "col-xl-2": "how-it-works-module_col-xl-2__afdvn",
  "col-xl-1": "how-it-works-module_col-xl-1__C9QNu",
  "col-lg": "how-it-works-module_col-lg__yXTKQ",
  "item": "how-it-works-module_item__GZZpT",
  "col-lg-auto": "how-it-works-module_col-lg-auto__BKE9l",
  "col-lg-12": "how-it-works-module_col-lg-12__s-57d",
  "col-lg-11": "how-it-works-module_col-lg-11__4EsSh",
  "col-lg-10": "how-it-works-module_col-lg-10__FHXZ-",
  "col-lg-9": "how-it-works-module_col-lg-9__h7hO0",
  "col-lg-8": "how-it-works-module_col-lg-8__jG0kZ",
  "col-lg-7": "how-it-works-module_col-lg-7__YXowJ",
  "col-lg-6": "how-it-works-module_col-lg-6__7DK7u",
  "content": "how-it-works-module_content__LI-HT",
  "col-lg-5": "how-it-works-module_col-lg-5__tNb70",
  "col-lg-4": "how-it-works-module_col-lg-4__ytvyb",
  "col-lg-3": "how-it-works-module_col-lg-3__zqcHq",
  "col-lg-2": "how-it-works-module_col-lg-2__kgsSj",
  "col-lg-1": "how-it-works-module_col-lg-1__2zsQI",
  "col-md": "how-it-works-module_col-md__kT3CS",
  "col-md-auto": "how-it-works-module_col-md-auto__W-x7q",
  "col-md-12": "how-it-works-module_col-md-12__L5kSv",
  "col-md-11": "how-it-works-module_col-md-11__mgNo1",
  "col-md-10": "how-it-works-module_col-md-10__dUxP6",
  "col-md-9": "how-it-works-module_col-md-9__R-WY6",
  "col-md-8": "how-it-works-module_col-md-8__Q7WnL",
  "col-md-7": "how-it-works-module_col-md-7__baZw2",
  "col-md-6": "how-it-works-module_col-md-6__H7eSF",
  "col-md-5": "how-it-works-module_col-md-5__XuZ2F",
  "col-md-4": "how-it-works-module_col-md-4__-BG9c",
  "col-md-3": "how-it-works-module_col-md-3__CRUVG",
  "col-md-2": "how-it-works-module_col-md-2__6mS-D",
  "col-md-1": "how-it-works-module_col-md-1__bg8uo",
  "col-xs": "how-it-works-module_col-xs__0l8Qw",
  "col-xs-auto": "how-it-works-module_col-xs-auto__ipnHt",
  "col-xs-12": "how-it-works-module_col-xs-12__zyXAL",
  "col-xs-11": "how-it-works-module_col-xs-11__ZFOth",
  "col-xs-10": "how-it-works-module_col-xs-10__V2jIR",
  "col-xs-9": "how-it-works-module_col-xs-9__8qF-c",
  "col-xs-8": "how-it-works-module_col-xs-8__gboJX",
  "col-xs-7": "how-it-works-module_col-xs-7__TKhAe",
  "col-xs-6": "how-it-works-module_col-xs-6__I4Fx3",
  "col-xs-5": "how-it-works-module_col-xs-5__6SLmH",
  "col-xs-4": "how-it-works-module_col-xs-4__eZzHf",
  "col-xs-3": "how-it-works-module_col-xs-3__qe08e",
  "col-xs-2": "how-it-works-module_col-xs-2__3aNkU",
  "col-xs-1": "how-it-works-module_col-xs-1__qKpZW",
  "order-xs-first": "how-it-works-module_order-xs-first__LaOa6",
  "order-xs-last": "how-it-works-module_order-xs-last__3jZcO",
  "order-xs-0": "how-it-works-module_order-xs-0__Ir8dX",
  "order-xs-1": "how-it-works-module_order-xs-1__k4WRe",
  "order-xs-2": "how-it-works-module_order-xs-2__agbrJ",
  "order-xs-3": "how-it-works-module_order-xs-3__KUNsv",
  "order-xs-4": "how-it-works-module_order-xs-4__7lVPr",
  "order-xs-5": "how-it-works-module_order-xs-5__YN3q6",
  "order-xs-6": "how-it-works-module_order-xs-6__Qxacm",
  "order-xs-7": "how-it-works-module_order-xs-7__KhHzQ",
  "order-xs-8": "how-it-works-module_order-xs-8__G2pzJ",
  "order-xs-9": "how-it-works-module_order-xs-9__6pkXG",
  "order-xs-10": "how-it-works-module_order-xs-10__VHyEs",
  "order-xs-11": "how-it-works-module_order-xs-11__2fhOE",
  "order-xs-12": "how-it-works-module_order-xs-12__u-Mgm",
  "offset-xs-0": "how-it-works-module_offset-xs-0__4SnHx",
  "offset-xs-1": "how-it-works-module_offset-xs-1__BJZ1e",
  "offset-xs-2": "how-it-works-module_offset-xs-2__n3pMj",
  "offset-xs-3": "how-it-works-module_offset-xs-3__A7upA",
  "offset-xs-4": "how-it-works-module_offset-xs-4__q0MJ2",
  "offset-xs-5": "how-it-works-module_offset-xs-5__C3hUq",
  "offset-xs-6": "how-it-works-module_offset-xs-6__Y7r2P",
  "offset-xs-7": "how-it-works-module_offset-xs-7__qKjka",
  "offset-xs-8": "how-it-works-module_offset-xs-8__fcyWE",
  "offset-xs-9": "how-it-works-module_offset-xs-9__jvncg",
  "offset-xs-10": "how-it-works-module_offset-xs-10__WqU02",
  "offset-xs-11": "how-it-works-module_offset-xs-11__A18zu",
  "order-md-first": "how-it-works-module_order-md-first__HAq6O",
  "order-md-last": "how-it-works-module_order-md-last__KoGo4",
  "order-md-0": "how-it-works-module_order-md-0__wwyPH",
  "order-md-1": "how-it-works-module_order-md-1__C0wfL",
  "order-md-2": "how-it-works-module_order-md-2__6RAL7",
  "order-md-3": "how-it-works-module_order-md-3__NzqB3",
  "order-md-4": "how-it-works-module_order-md-4__Ob8vs",
  "order-md-5": "how-it-works-module_order-md-5__PBqGa",
  "order-md-6": "how-it-works-module_order-md-6__W8u0q",
  "order-md-7": "how-it-works-module_order-md-7__bXZDH",
  "order-md-8": "how-it-works-module_order-md-8__mphue",
  "order-md-9": "how-it-works-module_order-md-9__X7X5B",
  "order-md-10": "how-it-works-module_order-md-10__liqaP",
  "order-md-11": "how-it-works-module_order-md-11__Ym-PW",
  "order-md-12": "how-it-works-module_order-md-12__9GFNz",
  "offset-md-0": "how-it-works-module_offset-md-0__S0ze5",
  "offset-md-1": "how-it-works-module_offset-md-1__3EBjl",
  "offset-md-2": "how-it-works-module_offset-md-2__yiM3Q",
  "offset-md-3": "how-it-works-module_offset-md-3__QcW8a",
  "offset-md-4": "how-it-works-module_offset-md-4__VST80",
  "offset-md-5": "how-it-works-module_offset-md-5__aGJie",
  "offset-md-6": "how-it-works-module_offset-md-6__7vEcP",
  "offset-md-7": "how-it-works-module_offset-md-7__96MFZ",
  "offset-md-8": "how-it-works-module_offset-md-8__9KstY",
  "offset-md-9": "how-it-works-module_offset-md-9__oHrNT",
  "offset-md-10": "how-it-works-module_offset-md-10__dCI8c",
  "offset-md-11": "how-it-works-module_offset-md-11__s3Q2b",
  "order-lg-first": "how-it-works-module_order-lg-first__xWPjT",
  "order-lg-last": "how-it-works-module_order-lg-last__jec8g",
  "order-lg-0": "how-it-works-module_order-lg-0__8S76W",
  "order-lg-1": "how-it-works-module_order-lg-1__UnKsY",
  "order-lg-2": "how-it-works-module_order-lg-2__MZiNE",
  "order-lg-3": "how-it-works-module_order-lg-3__MImq1",
  "order-lg-4": "how-it-works-module_order-lg-4__-nAh-",
  "order-lg-5": "how-it-works-module_order-lg-5__FVRVj",
  "order-lg-6": "how-it-works-module_order-lg-6__aKVip",
  "order-lg-7": "how-it-works-module_order-lg-7__DpGTi",
  "order-lg-8": "how-it-works-module_order-lg-8__btR6W",
  "order-lg-9": "how-it-works-module_order-lg-9__kfilO",
  "order-lg-10": "how-it-works-module_order-lg-10__0vVGK",
  "order-lg-11": "how-it-works-module_order-lg-11__mYcrM",
  "order-lg-12": "how-it-works-module_order-lg-12__zGwJC",
  "offset-lg-0": "how-it-works-module_offset-lg-0__lA2NW",
  "offset-lg-1": "how-it-works-module_offset-lg-1__66oSB",
  "offset-lg-2": "how-it-works-module_offset-lg-2__OK1nb",
  "offset-lg-3": "how-it-works-module_offset-lg-3__NOiNq",
  "offset-lg-4": "how-it-works-module_offset-lg-4__5i76B",
  "offset-lg-5": "how-it-works-module_offset-lg-5__blq09",
  "offset-lg-6": "how-it-works-module_offset-lg-6__tM4Ce",
  "offset-lg-7": "how-it-works-module_offset-lg-7__v-gVR",
  "offset-lg-8": "how-it-works-module_offset-lg-8__I-P-9",
  "offset-lg-9": "how-it-works-module_offset-lg-9__6L7jK",
  "offset-lg-10": "how-it-works-module_offset-lg-10__znFED",
  "offset-lg-11": "how-it-works-module_offset-lg-11__fff-s",
  "order-xl-first": "how-it-works-module_order-xl-first__apX18",
  "order-xl-last": "how-it-works-module_order-xl-last__BAZI1",
  "order-xl-0": "how-it-works-module_order-xl-0__Z03H9",
  "order-xl-1": "how-it-works-module_order-xl-1__M-nRo",
  "order-xl-2": "how-it-works-module_order-xl-2__Ydm84",
  "order-xl-3": "how-it-works-module_order-xl-3__PNHXo",
  "order-xl-4": "how-it-works-module_order-xl-4__dXDRz",
  "order-xl-5": "how-it-works-module_order-xl-5__paes1",
  "order-xl-6": "how-it-works-module_order-xl-6__fYy33",
  "order-xl-7": "how-it-works-module_order-xl-7__LyvNl",
  "order-xl-8": "how-it-works-module_order-xl-8__CyeA1",
  "order-xl-9": "how-it-works-module_order-xl-9__cxoAr",
  "order-xl-10": "how-it-works-module_order-xl-10__7SLe7",
  "order-xl-11": "how-it-works-module_order-xl-11__vowT3",
  "order-xl-12": "how-it-works-module_order-xl-12__8bfom",
  "offset-xl-0": "how-it-works-module_offset-xl-0__HXb8y",
  "offset-xl-1": "how-it-works-module_offset-xl-1__lq752",
  "offset-xl-2": "how-it-works-module_offset-xl-2__EcCOI",
  "offset-xl-3": "how-it-works-module_offset-xl-3__Z-trH",
  "offset-xl-4": "how-it-works-module_offset-xl-4__MrYdI",
  "offset-xl-5": "how-it-works-module_offset-xl-5__qoENB",
  "offset-xl-6": "how-it-works-module_offset-xl-6__DEBaI",
  "offset-xl-7": "how-it-works-module_offset-xl-7__IbjqS",
  "offset-xl-8": "how-it-works-module_offset-xl-8__q-yzZ",
  "offset-xl-9": "how-it-works-module_offset-xl-9__apG72",
  "offset-xl-10": "how-it-works-module_offset-xl-10__0Csk0",
  "offset-xl-11": "how-it-works-module_offset-xl-11__2xU19",
  "title": "how-it-works-module_title__NdflI",
  "itemDescription": "how-it-works-module_itemDescription__KKGVu",
  "icon": "how-it-works-module_icon__lDCvh",
  "footnote": "how-it-works-module_footnote__c1TMO",
  "fadeInDown": "how-it-works-module_fadeInDown__SivWd",
  "fadeInUp": "how-it-works-module_fadeInUp__1nLDg",
  "fadeInDropdown": "how-it-works-module_fadeInDropdown__BkUIs",
  "fadeOutDropdown": "how-it-works-module_fadeOutDropdown__i9DUr"
};
var HowItWorks = function HowItWorks(_a) {
  var title = _a.title,
    description = _a.description,
    items = _a.items,
    _b = _a.background,
    background = _b === void 0 ? "" : _b,
    _c = _a.footnote,
    footnote = _c === void 0 ? "" : _c,
    _d = _a.isWithCheckmarks,
    isWithCheckmarks = _d === void 0 ? false : _d,
    renderImage = _a.renderImage;
  return React.createElement("section", {
    className: styles$k["section" + background]
  }, React.createElement("div", {
    className: styles$k.container
  }, React.createElement("h2", null, title), React.createElement("hr", {
    className: styles$k.hr
  }), description && React.createElement("p", {
    className: styles$k.content
  }, description), React.createElement(SwiperComponent, {
    spaceBetween: 20
  }, items.map(function (item, index) {
    var imageSrc = isWithCheckmarks ? img$4 : item.src ? item.src : getDirectusImageUrl(item.filename_disk || item.icon_filename_disk || "");
    return React.createElement("div", {
      key: index,
      className: styles$k.item
    }, renderImage ? renderImage({
      src: imageSrc,
      alt: item.title,
      width: !isWithCheckmarks ? 130 : 62,
      height: !isWithCheckmarks ? 130 : 62,
      quality: 100,
      className: styles$k.icon
    }) : React.createElement(Image, {
      width: !isWithCheckmarks ? 130 : 62,
      height: !isWithCheckmarks ? 130 : 62,
      className: styles$k.icon,
      filename: item.filename_disk || item.icon_filename_disk,
      url: !isWithCheckmarks ? item.src : img$4,
      alt: item.title
    }), item.title && React.createElement("h3", {
      className: styles$k.title
    }, item.title), item.title && React.createElement("hr", {
      className: background === "Primary" ? styles$k.hr : ""
    }), item.description && React.createElement("div", {
      className: styles$k.itemDescription,
      dangerouslySetInnerHTML: {
        __html: item.description
      }
    }));
  })), footnote && React.createElement("div", {
    className: styles$k.footnote,
    dangerouslySetInnerHTML: {
      __html: footnote
    }
  })));
};
var styles$j = {
  "asSeenInImageWrapper": "as-seen-in-module_asSeenInImageWrapper__vlUQn",
  "asSeenIn": "as-seen-in-module_asSeenIn__DBxSP",
  "fadeInDown": "as-seen-in-module_fadeInDown__znVzT",
  "fadeInUp": "as-seen-in-module_fadeInUp__Iq37k",
  "fadeInDropdown": "as-seen-in-module_fadeInDropdown__oKuux",
  "fadeOutDropdown": "as-seen-in-module_fadeOutDropdown__avRq5"
};
var AsSeenInUI = function AsSeenInUI(_a) {
  var images = _a.images;
  return React.createElement("section", {
    className: styles$j.asSeenIn
  }, React.createElement("h4", null, "AS SEEN IN"), React.createElement("div", {
    className: styles$j.asSeenInImageWrapper
  }, images.map(function (_a, index) {
    var width = _a.width,
      url = _a.url,
      alt = _a.alt;
    return React.createElement(Image, {
      key: index,
      url: url,
      width: width,
      alt: alt
    });
  })));
};
var styles$i = {
  "cardContainer": "nutritional-information-module_cardContainer__WobBU",
  "header": "nutritional-information-module_header__BAugJ",
  "rowsContent": "nutritional-information-module_rowsContent__I7ASX",
  "rowsContentExpanded": "nutritional-information-module_rowsContentExpanded__KfRTH",
  "columnTitles": "nutritional-information-module_columnTitles__xzsk3",
  "rowItemHeader": "nutritional-information-module_rowItemHeader__8tNaZ",
  "nutrientRowsExpanded": "nutritional-information-module_nutrientRowsExpanded__-3mrh",
  "nutrientRows": "nutritional-information-module_nutrientRows__jXwZn",
  "rowItemExpanded": "nutritional-information-module_rowItemExpanded__KKRMN",
  "rowItem": "nutritional-information-module_rowItem__Di93x",
  "rowItemBody": "nutritional-information-module_rowItemBody__ujjKU",
  "itemNrv": "nutritional-information-module_itemNrv__QRhIc",
  "itemDescription": "nutritional-information-module_itemDescription__-I-me",
  "iconChevronDown": "nutritional-information-module_iconChevronDown__Pqheh",
  "iconChevronFlipped": "nutritional-information-module_iconChevronFlipped__KxGol",
  "rowCollapseToggle": "nutritional-information-module_rowCollapseToggle__DOD2H",
  "showMore": "nutritional-information-module_showMore__Ki28I",
  "chevronIconFlipped": "nutritional-information-module_chevronIconFlipped__SpzQZ",
  "fadeInDown": "nutritional-information-module_fadeInDown__zyS0f",
  "fadeInUp": "nutritional-information-module_fadeInUp__Q9EbJ",
  "fadeInDropdown": "nutritional-information-module_fadeInDropdown__fs-Xe",
  "fadeOutDropdown": "nutritional-information-module_fadeOutDropdown__KdqdR"
};
var img$3 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='21' height='21' viewBox='0 0 21 21'%3e %3cdefs%3e %3cstyle%3e.a%7bfill:darkgrey%3b%7d.b%7bfill:none%3b%7d%3c/style%3e %3c/defs%3e %3cg transform='translate(0) rotate(0)'%3e %3cpath class='a' d='M11.441%2c11.76l7.945%2c7.928%2c7.945-7.928L29.772%2c14.2%2c19.386%2c24.587%2c9%2c14.2Z' transform='translate(-9 -7.76)'/%3e %3cpath class='b' d='M0%2c0H21V21H0Z'/%3e %3c/g%3e%3c/svg%3e";
var img$2 = "data:image/svg+xml,%3csvg data-name='Icon - drop down arrow R' height='25' id='Icon_-_drop_down_arrow_R0' viewBox='0 0 25 25' width='25' xmlns='http://www.w3.org/2000/svg'%3e %3cg data-name='Icon %e2%80%93 Drop down R' id='Icon_Drop_down_R'%3e %3cg data-name='Ellipse 1' fill='none' id='Ellipse_1' stroke='%236F6F6F' strokeWidth='2'%3e %3ccircle cx='12.5' cy='12.5' r='12.5' stroke='none'%3e%3c/circle%3e %3ccircle cx='12.5' cy='12.5' fill='none' r='11.5'%3e%3c/circle%3e %3c/g%3e %3c/g%3e %3cpath d='M0%2c0%2c4.016%2c4.528%2c8.273%2c0' data-name='Path 3034' fill='none' id='Path_3034' stroke='%236F6F6F' strokeWidth='2' transform='translate(8.2 11.2) rotate(0)'%3e%3c/path%3e%3c/svg%3e";
var NutritionalInformationUI = function NutritionalInformationUI(_a) {
  var title = _a.title,
    description = _a.description,
    items = _a.items,
    _b = _a.tableColumnNames,
    tableColumnNames = _b === void 0 ? ["Per capsule", "Quantity", "NRV %"] : _b;
  var _c = useState(false),
    showMore = _c[0],
    setShowMore = _c[1];
  var _d = useState([]),
    expandedRows = _d[0],
    setExpandedRows = _d[1];
  var isRowExpanded = function isRowExpanded(id) {
    return expandedRows.find(function (i) {
      return i === id;
    });
  };
  var handleClickOnRow = function handleClickOnRow(id) {
    if (isRowExpanded(id)) {
      setExpandedRows(__spreadArray([], expandedRows.filter(function (i) {
        return i !== id;
      }), true));
    } else {
      setExpandedRows(__spreadArray(__spreadArray([], expandedRows, true), [id], false));
    }
  };
  var handleShowMore = function handleShowMore() {
    if (showMore) {
      setExpandedRows([]);
    }
    setShowMore(!showMore);
  };
  useEffect(function () {
    if (expandedRows.length === 0) {
      setShowMore(false);
    } else {
      setShowMore(true);
    }
  }, [expandedRows]);
  return React.createElement("div", {
    className: styles$i.cardContainer
  }, React.createElement("div", {
    className: styles$i.header
  }, React.createElement("h5", null, title), React.createElement("p", null, description)), React.createElement("div", {
    className: showMore ? styles$i.rowsContentExpanded : styles$i.rowsContent
  }, React.createElement("div", {
    className: styles$i.columnTitles
  }, React.createElement("div", null, tableColumnNames[0]), React.createElement("div", null, tableColumnNames[1]), React.createElement("div", null, tableColumnNames[2])), React.createElement("ul", {
    className: showMore ? styles$i.nutrientRowsExpanded : styles$i.nutrientRows
  }, items && items.length > 0 && items.map(function (item) {
    return React.createElement("li", {
      className: isRowExpanded(item.id) ? styles$i.rowItemExpanded : styles$i.rowItem,
      key: item.id
    }, React.createElement("div", {
      className: styles$i.rowItemHeader,
      onClick: function onClick() {
        return handleClickOnRow(item.id);
      }
    }, React.createElement("div", null, item.name), React.createElement("div", null, item.quantity), React.createElement("div", null, item.nrv), React.createElement("div", {
      className: styles$i.rowCollapseToggle
    }, React.createElement("img", {
      src: img$3,
      className: isRowExpanded(item.id) ? styles$i.iconChevronFlipped : styles$i.iconChevronDown
    }))), React.createElement("div", {
      className: styles$i.rowItemBody
    }, React.createElement("div", {
      className: styles$i.itemNrv
    }, "NRV %: ", item.nrv), React.createElement("div", {
      className: styles$i.itemDescription,
      dangerouslySetInnerHTML: {
        __html: item.description
      }
    })));
  }))), items.length > 6 && React.createElement("div", {
    className: styles$i.showMore,
    onClick: function onClick() {
      return handleShowMore();
    }
  }, showMore ? "Show less" : "Show more (".concat(items.length - 6, ")"), React.createElement("img", {
    src: img$2,
    className: showMore ? styles$i.chevronIconFlipped : styles$i.chevronIcon
  })));
};
var styles$h = {
  "card": "card-module_card__HG0v6",
  "radius": "card-module_radius__Y-xFK",
  "shadow": "card-module_shadow__QDUei",
  "fadeInDown": "card-module_fadeInDown__PGc98",
  "fadeInUp": "card-module_fadeInUp__fTFsE",
  "fadeInDropdown": "card-module_fadeInDropdown__sw8ed",
  "fadeOutDropdown": "card-module_fadeOutDropdown__-62us"
};
var Card = function Card(_a) {
  var borderRadius = _a.borderRadius,
    shadow = _a.shadow,
    className = _a.className,
    children = _a.children;
  return React.createElement("div", {
    className: "".concat(styles$h.card, " ").concat(borderRadius ? styles$h.radius : "", " ").concat(shadow ? styles$h.shadow : "", " ").concat(className ? className : "")
  }, children);
};
var dist = {};
var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = commonjsGlobal && commonjsGlobal.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(dist, "__esModule", {
  value: true
});
dist.iconList = void 0;
var react_1 = React;
var IcoMoon = function IcoMoon(_a) {
  var iconSet = _a.iconSet,
    icon = _a.icon,
    size = _a.size,
    title = _a.title,
    disableFill = _a.disableFill,
    removeInlineStyle = _a.removeInlineStyle,
    native = _a.native,
    SvgComponent = _a.SvgComponent,
    PathComponent = _a.PathComponent,
    props = __rest(_a, ["iconSet", "icon", "size", "title", "disableFill", "removeInlineStyle", "native", "SvgComponent", "PathComponent"]);
  if (!iconSet || !icon) return null;
  var currentIcon = iconSet.icons.find(function (item) {
    return item.properties.name === icon;
  });
  if (!currentIcon) return null;
  var initialStyle = {
    display: "inline-block",
    stroke: "currentColor",
    fill: "currentColor"
  };
  if (native) {
    initialStyle.display = "flex";
    initialStyle.flexDirection = "row";
    initialStyle.flexWrap = "wrap";
  }
  var comptuedStyle = __assign(__assign(__assign({}, removeInlineStyle ? {} : initialStyle), size ? {
    width: size,
    height: size
  } : {}), props.style || {});
  var _b = currentIcon.icon.width,
    width = _b === void 0 ? "1024" : _b;
  var viewBox = "0 0 ".concat(width, " 1024");
  var children = currentIcon.icon.paths.map(function (path, index) {
    var _a;
    var attrs = (_a = currentIcon.icon.attrs) === null || _a === void 0 ? void 0 : _a[index];
    var pathProps = __assign({
      d: path,
      key: icon + index
    }, !disableFill && attrs ? attrs : {});
    return (0, react_1.createElement)(PathComponent || "path", pathProps);
  });
  if (title && !native) {
    children.push((0, react_1.createElement)("title", {
      key: title
    }, title));
  }
  return (0, react_1.createElement)(SvgComponent || "svg", __assign(__assign({}, props), {
    viewBox: viewBox,
    style: comptuedStyle
  }), children);
};
var iconList = function iconList(iconSet) {
  if (!iconSet || !Array.isArray(iconSet.icons)) return null;
  return iconSet.icons.map(function (icon) {
    return icon.properties.name;
  });
};
dist.iconList = iconList;
var _default = dist.default = IcoMoon;
var IcoMoonType = "selection";
var icons = [{
  icon: {
    paths: ["M1010.799 950.252l-253.641-253.85c60.012-73.604 96.187-167.282 96.187-269.533 0-235.24-191.328-426.777-426.777-426.777s-426.568 191.537-426.568 426.777 191.328 426.568 426.777 426.568c102.042 0 195.929-36.175 269.533-96.187l253.641 253.641c17.355 17.355 43.702 17.355 61.058 0s17.355-43.284-0.209-60.64zM85.105 426.869c0-188.401 153.063-341.464 341.464-341.464s341.673 153.272 341.673 341.673-153.272 341.673-341.673 341.673-341.464-153.481-341.464-341.882z"],
    attrs: [{}],
    isMulticolor: false,
    isMulticolor2: false,
    grid: 16,
    tags: ["icon-search"],
    colorPermutations: {
      "12016911969124123628461249165511251178491255255255157871671": [{}]
    }
  },
  attrs: [{}],
  properties: {
    order: 251,
    id: 18,
    name: "search",
    prevSize: 32,
    code: 59735
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 0
}, {
  icon: {
    paths: ["M560 992c-265.097 0-480-214.903-480-480s214.903-480 480-480c265.097 0 480 214.903 480 480s-214.903 480-480 480z", "M560 327.68v368.64", "M375.68 512h368.64", "M560 992c-265.097 0-480-214.903-480-480s214.903-480 480-480c265.097 0 480 214.903 480 480s-214.903 480-480 480z"],
    attrs: [{
      fill: "none",
      strokeLinejoin: "miter",
      strokeLinecap: "butt",
      strokeMiterlimit: "4",
      strokeWidth: 40.96
    }, {
      fill: "none",
      strokeLinejoin: "miter",
      strokeLinecap: "round",
      strokeMiterlimit: "4",
      strokeWidth: 40.96
    }, {
      fill: "none",
      strokeLinejoin: "miter",
      strokeLinecap: "round",
      strokeMiterlimit: "4",
      strokeWidth: 40.96
    }, {
      fill: "none",
      strokeLinejoin: "miter",
      strokeLinecap: "butt",
      strokeMiterlimit: "4",
      strokeWidth: 40.96
    }],
    isMulticolor: false,
    isMulticolor2: true,
    grid: 16,
    tags: ["icon-plus-circle"],
    colorPermutations: {
      "111111111111211211212110119212551937125525525512556101323333148111197163811811": [{}, {}, {}, {}],
      "1201691211011921255193712552552551255610163811811": [{}, {}, {}, {}],
      "120169124916551125519371255255255125561015787167163811811": [{}, {}, {}, {}],
      "12016911969124123628461249165511251178491255255255157871671": [{}, {}, {}, {}]
    },
    width: 1120
  },
  attrs: [{
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: "4",
    strokeWidth: 40.96
  }, {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: "4",
    strokeWidth: 40.96
  }, {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: "4",
    strokeWidth: 40.96
  }, {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: "4",
    strokeWidth: 40.96
  }],
  properties: {
    order: 247,
    id: 17,
    name: "icon-plus-circle",
    prevSize: 32,
    code: 59728
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 1
}, {
  icon: {
    paths: ["M1638.478 969.397c0 30.175-24.428 54.603-54.603 54.603h-1529.273c-30.175 0-54.603-24.428-54.603-54.603v-914.794c0-30.175 24.428-54.603 54.603-54.603h1529.273c30.175 0 54.603 24.428 54.603 54.603v914.794z", "M508.408 488.16v-16.329l-7.838 16.329h-67.796l-8.491-17.635v17.635h-126.841l-15.022-35.4h-25.473l-15.806 35.4h-65.706v-107.116l48.202-109.075h92.224l12.932 30.959v-30.698h112.863l24.819 51.99 24.297-52.252h356.225c0 0 18.68-0.261 30.959 8.36l-0.131-8.36h89.742v11.757c0 0 16.198-11.757 39.972-11.757 23.905 0 158.322 0 158.322 0l13.847 31.351v-31.351h101.499l18.419 31.351v-31.351h97.057v216.321h-99.67l-23.383-37.752v37.49h-123.836l-17.374-38.666h-24.297l-16.329 38.666h-74.981c0 0-27.955-0.392-48.986-15.414 0 7.838 0 15.414 0 15.414h-149.178c0 0 0-43.108 0-50.423s-5.617-6.793-5.617-6.793h-5.486v57.215h-299.14z", "M433.819 535.056h196.205l28.346 32.004 29-32.004h150.746c0 0 14.108 0.392 27.563 7.576v-7.576c0 0 117.305 0 134.287 0s31.351 8.491 31.351 8.491v-8.491h172.561v7.838c0 0 12.279-7.838 28.869-7.838 16.459 0 112.471 0 112.471 0v7.838c0 0 14.108-7.838 29.13-7.838s88.305 0 88.305 0v203.781c0 0-11.626 13.194-35.662 13.194h-116.39v-6.531c0 0-11.103 6.531-27.955 6.531s-309.199 0-309.199 0 0-47.418 0-52.643c0-5.225-2.221-6.14-6.923-6.14h-4.311v58.783h-96.665v-58.391c0 0-10.712 5.748-28.608 5.748s-34.747 0-34.747 0v52.643h-119.003l-27.040-33.049-29 33.049h-193.331v-216.975z", "M1052.085 567.583h123.052v32.918h-85.431v28.869h83.080v29h-83.080v30.306h85.431v32.265h-123.052z", "M1413.013 627.28c46.243 2.351 50.162 25.473 50.162 50.162 0 28.738-23.644 44.153-48.333 44.153h-79.030v-32.918h61.657c10.45 0 25.995 0 25.995-14.761 0-7.054-2.743-11.495-13.847-12.671-4.964-0.653-23.252-1.698-25.995-1.829-41.801-1.045-51.598-21.946-51.598-47.157 0-28.738 20.247-44.414 44.936-44.414h79.030v32.918h-57.869c-13.194 0.131-27.432-1.568-27.432 13.324 0 9.405 7.054 11.365 15.937 12.148 3.004-0 23.644 1.045 26.387 1.045z", "M1271.15 627.28c46.243 2.351 50.162 25.473 50.162 50.162 0 28.738-23.644 44.153-48.333 44.153h-79.030v-32.918h61.657c10.45 0 25.995 0 25.995-14.761 0-7.054-2.743-11.495-13.847-12.671-4.964-0.653-23.252-1.698-25.995-1.829-41.801-1.045-51.468-21.946-51.468-47.157 0-28.738 20.117-44.414 44.806-44.414h79.030v32.918h-57.869c-13.194 0.131-27.432-1.568-27.432 13.324 0 9.405 7.054 11.365 15.937 12.148 3.135-0 23.774 1.045 26.387 1.045z", "M824.791 567.844h-132.196l-43.108 47.549-41.801-47.941h-148.394v153.358h143.561l45.198-50.684 44.283 51.076h72.238v-52.121h50.684c19.464 0 55.125-0.653 55.125-54.472-0.131-38.144-27.171-46.765-45.589-46.765zM583.258 688.676h-86.868v-30.306h83.080v-29.13h-83.080v-28.738l91.571 0.261 36.707 41.801-41.409 46.112zM727.211 706.572l-54.080-64.008 54.080-59.959v123.967zM812.12 637.6h-46.896v-36.837h47.026c15.806 0 20.77 10.058 20.77 17.635 0 10.32-5.486 19.202-20.901 19.202z", "M1006.626 651.446c20.509-10.32 25.995-23.905 25.995-42.454 0-32.788-26.648-41.017-45.198-41.017h-97.841v153.358h37.621v-54.080h49.247c13.063 0 18.157 13.063 18.419 25.995l1.045 28.085h36.707l-1.437-31.482c0.131-24.819-6.662-36.445-24.558-38.405zM974.1 635.51h-46.896v-34.747h47.026c15.806 0 20.77 10.058 20.77 17.635 0 10.32-5.486 17.112-20.901 17.112z", "M904.736 302.798h37.621v153.489h-37.621v-153.489z", "M596.452 302.928h123.052v33.049h-85.431v28.738h83.080v29.13h-83.080v30.306h85.431v32.135h-123.052z", "M858.885 386.531c20.509-10.189 25.995-23.905 25.995-42.454 0-32.918-26.648-41.017-45.198-41.017h-97.972v153.358h37.621v-54.080h49.247c13.063 0 18.157 12.932 18.549 25.995l1.045 28.085h36.576l-1.306-31.482c0.131-24.819-6.662-36.445-24.558-38.405zM826.358 370.594h-46.896v-34.747h47.026c15.675 0 20.77 10.058 20.77 17.635 0 10.32-5.486 17.112-20.901 17.112z", "M509.583 302.928l-46.243 102.936-46.112-102.936h-59.044v147.741l-65.576-147.741h-49.77l-67.143 153.358h39.711l14.63-34.225h75.112l14.892 34.225h75.765v-113.778l50.292 113.778h34.225l51.468-111.949v111.949h37.621v-153.358h-59.828zM244.276 389.013l22.468-53.558 23.383 53.558h-45.851z", "M1330.847 302.928v106.201l-63.486-106.201h-55.648v144.084l-64.139-143.953h-49.77l-51.86 118.742c0 0-21.946 0-24.166-0.523-9.013-1.829-23.252-8.23-23.383-35.27v-11.103c0-35.923 19.464-38.536 44.544-38.536h23.252v-33.31h-49.116c-17.112 0-54.342 13.063-55.648 76.026-0.914 42.454 17.635 77.463 59.436 77.463h49.639l14.63-34.225h75.112l14.892 34.225h74.328v-112.341l67.796 112.341h51.337v-153.62h-37.752zM1099.634 389.144l22.468-53.558 23.644 53.558h-46.112z"],
    attrs: [{
      fill: "rgb(0, 120, 169)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(0, 120, 169)"
    }, {
      fill: "rgb(0, 120, 169)"
    }, {
      fill: "rgb(0, 120, 169)"
    }, {
      fill: "rgb(0, 120, 169)"
    }, {
      fill: "rgb(0, 120, 169)"
    }, {
      fill: "rgb(0, 120, 169)"
    }, {
      fill: "rgb(0, 120, 169)"
    }, {
      fill: "rgb(0, 120, 169)"
    }, {
      fill: "rgb(0, 120, 169)"
    }, {
      fill: "rgb(0, 120, 169)"
    }],
    grid: 16,
    tags: ["american-express-svgrepo-com"],
    isMulticolor: true,
    isMulticolor2: false,
    colorPermutations: {
      "111111111111211211212110119212551937125525525512556101323333148111197163811811": [{
        f: 0
      }, {
        f: 8
      }, {
        f: 8
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }],
      "1201691211011921255193712552552551255610163811811": [{
        f: 0
      }, {
        f: 5
      }, {
        f: 5
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }],
      "120169124916551125519371255255255125561015787167163811811": [{
        f: 0
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }],
      "12016911969124123628461249165511251178491255255255157871671": [{
        f: 1
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 1
      }, {
        f: 1
      }, {
        f: 1
      }, {
        f: 1
      }, {
        f: 1
      }, {
        f: 1
      }, {
        f: 1
      }, {
        f: 1
      }, {
        f: 1
      }, {
        f: 1
      }]
    },
    width: 1632
  },
  attrs: [{
    fill: "rgb(0, 120, 169)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(0, 120, 169)"
  }, {
    fill: "rgb(0, 120, 169)"
  }, {
    fill: "rgb(0, 120, 169)"
  }, {
    fill: "rgb(0, 120, 169)"
  }, {
    fill: "rgb(0, 120, 169)"
  }, {
    fill: "rgb(0, 120, 169)"
  }, {
    fill: "rgb(0, 120, 169)"
  }, {
    fill: "rgb(0, 120, 169)"
  }, {
    fill: "rgb(0, 120, 169)"
  }, {
    fill: "rgb(0, 120, 169)"
  }],
  properties: {
    order: 232,
    id: 16,
    name: "american-express",
    prevSize: 32,
    code: 59654,
    codes: [59654, 59655, 59656, 59657, 59658, 59659, 59660, 59661, 59662, 59663, 59664, 59650, 59665]
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 2
}, {
  icon: {
    paths: ["M512 906.24c0 0 0 0 0 0-76.8 0-151.040-30.72-204.8-84.48s-84.48-128-84.48-204.8c0-66.56 40.96-140.8 58.88-171.52l186.88-302.080c5.12-7.68 10.24-12.8 17.92-17.92 12.8-7.68 25.6-10.24 38.4-5.12 12.8 2.56 25.6 12.8 30.72 23.040l186.88 299.52c7.68 12.8 58.88 97.28 58.88 171.52 0 161.28-130.56 291.84-289.28 291.84zM512 176.64l-184.32 294.4c-25.6 40.96-51.2 99.84-51.2 143.36 0 61.44 25.6 120.32 69.12 166.4s102.4 69.12 166.4 69.12c0 0 0 0 0 0 130.56 0 235.52-104.96 235.52-235.52 0-53.76-40.96-128-51.2-143.36v0l-184.32-294.4zM509.44 171.52c0 0 0 0 0 0v0z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    grid: 16,
    tags: ["HG icons in square_HG-icon-DETOX"],
    colorPermutations: {
      "111111111111211211212110119212551937125525525512556101323333148111197163811811": [],
      "1201691211011921255193712552552551255610163811811": [],
      "120169124916551125519371255255255125561015787167163811811": [],
      "12016911969124123628461249165511251178491255255255157871671": []
    }
  },
  attrs: [],
  properties: {
    order: 233,
    id: 15,
    name: "detox",
    prevSize: 32,
    code: 59666
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 3
}, {
  icon: {
    paths: ["M593.152 899.072c146.688 0 265.728-140.288 265.728-313.088s-119.040-302.336-265.728-302.336c-31.202 1.971-60.145 9.693-86.432 22.116l1.44-0.612", "M515.84 305.152c-24.847-11.811-53.79-19.533-84.306-21.469l-0.686-0.035c-146.688 0-265.728 129.536-265.728 302.336s119.040 313.088 265.728 313.088", "M440.32 896c21.313-8.365 45.994-13.213 71.808-13.213s50.494 4.848 73.182 13.684l-1.374-0.471", "M298.24 507.136s5.632-73.472 100.096-99.328", "M503.296 177.664l-118.272-52.736"],
    attrs: [{
      fill: "none",
      strokeLinejoin: "miter",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      strokeWidth: 58.624
    }, {
      fill: "none",
      strokeLinejoin: "miter",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      strokeWidth: 58.624
    }, {
      fill: "none",
      strokeLinejoin: "miter",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      strokeWidth: 58.624
    }, {
      fill: "none",
      strokeLinejoin: "miter",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      strokeWidth: 58.624
    }, {
      fill: "none",
      strokeLinejoin: "miter",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      strokeWidth: 58.624
    }],
    isMulticolor: false,
    isMulticolor2: false,
    grid: 16,
    tags: ["HG icons in square_HG-icon-DIGESTION"],
    colorPermutations: {
      "111111111111211211212110119212551937125525525512556101323333148111197163811811": [{}, {}, {}, {}, {}],
      "1201691211011921255193712552552551255610163811811": [{}, {}, {}, {}, {}],
      "120169124916551125519371255255255125561015787167163811811": [{}, {}, {}, {}, {}],
      "12016911969124123628461249165511251178491255255255157871671": [{}, {}, {}, {}, {}]
    }
  },
  attrs: [{
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: 58.624
  }, {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: 58.624
  }, {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: 58.624
  }, {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: 58.624
  }, {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: 58.624
  }],
  properties: {
    order: 245,
    id: 14,
    name: "digestion",
    prevSize: 32,
    code: 59726
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 4
}, {
  icon: {
    paths: ["M629.76 573.44l-94.72-158.72-225.28 71.68c-15.36 5.12-30.72-2.56-35.84-17.92s2.56-30.72 17.92-35.84l268.8-87.040 87.040 143.36 74.24-53.76c12.8-10.24 30.72-5.12 38.4 5.12 7.68 12.8 5.12 30.72-5.12 38.4l-125.44 94.72z", "M445.44 729.6h-238.080c-15.36 0-28.16-12.8-28.16-25.6s12.8-28.16 28.16-28.16h199.68l115.2-302.080c5.12-15.36 20.48-20.48 35.84-15.36s20.48 20.48 15.36 35.84l-128 335.36z", "M688.64 919.040c-12.8 0-25.6-10.24-28.16-23.040l-46.080-225.28-133.12-107.52c-12.8-10.24-12.8-28.16-5.12-38.4 10.24-12.8 28.16-12.8 38.4-5.12l148.48 117.76 51.2 248.32c2.56 15.36-7.68 30.72-20.48 33.28 0 0-2.56 0-5.12 0z", "M634.88 348.16c-66.56 0-122.88-53.76-122.88-122.88s53.76-122.88 122.88-122.88 122.88 53.76 122.88 122.88-53.76 122.88-122.88 122.88zM634.88 158.72c-35.84 0-66.56 30.72-66.56 66.56s30.72 66.56 66.56 66.56 66.56-30.72 66.56-66.56-28.16-66.56-66.56-66.56z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    grid: 16,
    tags: ["HG icons in square_HG-icon-FITNESS"],
    colorPermutations: {
      "111111111111211211212110119212551937125525525512556101323333148111197163811811": [],
      "1201691211011921255193712552552551255610163811811": [],
      "120169124916551125519371255255255125561015787167163811811": [],
      "12016911969124123628461249165511251178491255255255157871671": []
    }
  },
  attrs: [],
  properties: {
    order: 235,
    id: 13,
    name: "fitness",
    prevSize: 32,
    code: 59667
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 5
}, {
  icon: {
    paths: ["M83.456 758.528v-447.488c0-19.2 12.544-45.568 37.376-45.568h782.336c25.6 0 37.376 25.6 37.376 45.568v447.488", "M300.288 758.528v-303.36", "M511.488 758.528v-303.36", "M194.56 758.528v-303.36", "M405.76 758.528v-303.36", "M616.96 758.528v-303.36", "M828.16 758.528v-303.36", "M722.688 758.528v-303.36"],
    attrs: [{
      fill: "none",
      strokeLinejoin: "miter",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      strokeWidth: 58.624
    }, {
      fill: "none",
      strokeLinejoin: "miter",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      strokeWidth: 58.624
    }, {
      fill: "none",
      strokeLinejoin: "miter",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      strokeWidth: 58.624
    }, {
      fill: "none",
      strokeLinejoin: "miter",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      strokeWidth: 58.624
    }, {
      fill: "none",
      strokeLinejoin: "miter",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      strokeWidth: 58.624
    }, {
      fill: "none",
      strokeLinejoin: "miter",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      strokeWidth: 58.624
    }, {
      fill: "none",
      strokeLinejoin: "miter",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      strokeWidth: 58.624
    }, {
      fill: "none",
      strokeLinejoin: "miter",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      strokeWidth: 58.624
    }],
    isMulticolor: false,
    isMulticolor2: false,
    grid: 16,
    tags: ["HG icons in square_HG-icon-HAIR"],
    colorPermutations: {
      "111111111111211211212110119212551937125525525512556101323333148111197163811811": [{}, {}, {}, {}, {}, {}, {}, {}],
      "1201691211011921255193712552552551255610163811811": [{}, {}, {}, {}, {}, {}, {}, {}],
      "120169124916551125519371255255255125561015787167163811811": [{}, {}, {}, {}, {}, {}, {}, {}],
      "12016911969124123628461249165511251178491255255255157871671": [{}, {}, {}, {}, {}, {}, {}, {}]
    }
  },
  attrs: [{
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: 58.624
  }, {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: 58.624
  }, {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: 58.624
  }, {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: 58.624
  }, {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: 58.624
  }, {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: 58.624
  }, {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: 58.624
  }, {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: 58.624
  }],
  properties: {
    order: 244,
    id: 12,
    name: "hair",
    prevSize: 32,
    code: 59725
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 6
}, {
  icon: {
    paths: ["M327.68 138.24c0 0-48.64 171.52 25.6 307.2 0 0 61.44 110.080-23.040 215.040 0 0-69.12 69.12-48.64 202.24M637.44 885.76c0 0-30.72-66.56 25.6-104.96 0 0 112.64-56.32 122.88-153.6 0 0 10.24-2.56 10.24-12.8 0-2.56-5.12-7.68-10.24-10.24 0 0 15.36-135.68-168.96-209.92 0 0 33.28-51.2-33.28-99.84 0 0-69.12-48.64-92.16-92.16 0 0-7.68-38.4 0-84.48"],
    attrs: [{
      fill: "none",
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      strokeWidth: 54.968320000000006
    }],
    isMulticolor: false,
    isMulticolor2: false,
    grid: 16,
    tags: ["HG icons in square_HG-icon-PREGANCY"],
    colorPermutations: {
      "111111111111211211212110119212551937125525525512556101323333148111197163811811": [{}],
      "1201691211011921255193712552552551255610163811811": [{}],
      "120169124916551125519371255255255125561015787167163811811": [{}],
      "12016911969124123628461249165511251178491255255255157871671": [{}]
    }
  },
  attrs: [{
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: 54.968320000000006
  }],
  properties: {
    order: 243,
    id: 11,
    name: "pregnancy",
    prevSize: 32,
    code: 59724
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 7
}, {
  icon: {
    paths: ["M547.84 924.16c-197.12 0-371.2-143.36-407.040-343.040-17.92-107.52 5.12-217.6 69.12-307.2s158.72-151.040 268.8-171.52c7.68 0 15.36 0 23.040 2.56 23.040 10.24 33.28 35.84 25.6 58.88-69.12 163.84-74.24 291.84-15.36 378.88 94.72 143.36 327.68 145.92 330.24 145.92 17.92 0 33.28 10.24 38.4 25.6v0c5.12 15.36 5.12 30.72-5.12 43.52-64 84.48-156.16 140.8-258.56 158.72-23.040 5.12-46.080 7.68-69.12 7.68zM463.36 163.84c-84.48 20.48-156.16 69.12-207.36 140.8-53.76 76.8-76.8 171.52-58.88 266.24 33.28 192 217.6 322.56 409.6 289.28 79.36-12.8 151.040-53.76 204.8-115.2-71.68-5.12-258.56-33.28-350.72-171.52-64-99.84-64-238.080 2.56-409.6zM842.24 747.52c0 0 0 0 0 0s0 0 0 0zM488.96 161.28c0 0 0 0 0 0s0 0 0 0z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    grid: 16,
    tags: ["HG icons in square_HG-icon-SLEEP"],
    colorPermutations: {
      "111111111111211211212110119212551937125525525512556101323333148111197163811811": [],
      "1201691211011921255193712552552551255610163811811": [],
      "120169124916551125519371255255255125561015787167163811811": [],
      "12016911969124123628461249165511251178491255255255157871671": []
    }
  },
  attrs: [],
  properties: {
    order: 238,
    id: 10,
    name: "sleep",
    prevSize: 32,
    code: 59670
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 8
}, {
  icon: {
    paths: ["M512 96c-123 0-224 101-224 224v96h-96v512h640v-512h-96v-96c0-123-101-224-224-224zM512 160c88.125 0 160 71.875 160 160v96h-320v-96c0-88.125 71.875-160 160-160zM256 480h512v384h-512z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    grid: 16,
    tags: ["icons8-lock-64"],
    colorPermutations: {
      "111111111111211211212110119212551937125525525512556101323333148111197163811811": [],
      "1201691211011921255193712552552551255610163811811": [],
      "120169124916551125519371255255255125561015787167163811811": [],
      "12016911969124123628461249165511251178491255255255157871671": []
    }
  },
  attrs: [],
  properties: {
    order: 239,
    id: 9,
    name: "lock",
    prevSize: 32,
    code: 59671
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 9
}, {
  icon: {
    paths: ["M1638.478 969.397c0 30.175-24.428 54.603-54.603 54.603h-1529.273c-30.175 0-54.603-24.428-54.603-54.603v-914.794c0-30.175 24.428-54.603 54.603-54.603h1529.273c30.175 0 54.603 24.428 54.603 54.603v914.794z", "M1015.901 805.98l15.153-0.392 14.892-1.045 14.761-1.959 14.5-2.613 14.239-3.266 13.977-3.919 13.716-4.703 13.324-5.225 13.063-5.878 12.802-6.531 12.279-7.054 12.018-7.707 11.495-8.23 11.103-8.752 10.712-9.144 10.189-9.797 9.797-10.32 9.144-10.712 8.752-10.973 8.23-11.626 7.707-11.887 7.054-12.41 6.531-12.671 5.878-13.063 5.225-13.324 4.703-13.716 4.049-13.977 3.266-14.239 2.482-14.5 1.959-14.761 1.045-14.892 0.392-15.153-0.392-15.153-1.045-14.892-1.959-14.63-2.482-14.369-3.266-14.239-4.049-13.847-4.703-13.716-5.225-13.194-5.878-13.063-6.531-12.671-7.054-12.148-7.707-12.018-8.23-11.495-8.752-10.973-9.144-10.712-9.797-10.32-10.189-9.667-10.712-9.275-11.103-8.622-11.495-8.23-12.018-7.707-12.279-7.054-12.802-6.401-13.063-6.009-13.324-5.225-13.716-4.703-13.977-3.919-14.239-3.266-14.5-2.613-14.761-1.829-14.892-1.176-15.153-0.392-15.153 0.392-14.892 1.176-14.761 1.829-14.5 2.613-14.108 3.266-13.977 3.919-13.585 4.703-13.455 5.225-12.932 6.009-12.54 6.401-12.279 7.054-12.018 7.707-11.495 8.23-11.103 8.622-10.581 9.275-10.189 9.667-9.797 10.32-9.144 10.712-8.752 10.973-8.099 11.495-7.707 12.018-6.923 12.148-6.662 12.671-5.748 13.063-5.356 13.194-4.572 13.716-3.919 13.847-3.266 14.239-2.613 14.369-1.829 14.63-1.045 14.892-0.523 15.153 0.523 15.153 1.045 14.892 1.829 14.761 2.613 14.5 3.266 14.239 3.919 13.977 4.572 13.716 5.356 13.324 5.748 13.063 6.662 12.671 6.923 12.41 7.707 11.887 8.099 11.626 8.752 10.973 9.144 10.712 9.797 10.32 10.189 9.797 10.581 9.144 11.103 8.752 11.495 8.23 12.018 7.707 12.279 7.054 12.54 6.531 12.932 5.878 13.455 5.225 13.585 4.703 13.977 3.919 14.108 3.266 14.5 2.613 14.761 1.959 14.892 1.045 15.153 0.392z", "M622.577 805.98l15.022-0.392 15.022-1.045 14.761-1.959 14.369-2.613 14.239-3.266 13.977-3.919 13.585-4.703 13.324-5.225 13.063-5.878 12.54-6.531 12.279-7.054 11.887-7.707 11.626-8.23 11.103-8.752 10.581-9.144 10.189-9.797 9.667-10.32 9.275-10.712 8.752-10.973 8.099-11.626 7.576-11.887 7.054-12.41 6.531-12.671 5.878-13.063 5.225-13.324 4.572-13.716 4.049-13.977 3.266-14.239 2.482-14.5 1.959-14.761 1.045-14.892 0.392-15.153-0.392-15.153-1.045-14.892-1.959-14.63-2.482-14.369-3.266-14.239-4.049-13.847-4.572-13.716-5.225-13.194-5.878-13.063-6.531-12.671-7.054-12.148-7.576-12.018-8.099-11.495-8.752-10.973-9.275-10.712-9.667-10.32-10.189-9.667-10.581-9.275-11.103-8.622-11.626-8.23-11.887-7.707-12.279-7.054-12.54-6.401-13.063-6.009-13.324-5.225-13.585-4.703-13.977-3.919-14.239-3.266-14.369-2.613-14.761-1.829-15.022-1.176-15.022-0.392-15.153 0.392-15.022 1.176-14.63 1.829-14.63 2.613-14.108 3.266-13.977 3.919-13.716 4.703-13.324 5.225-13.194 6.009-12.671 6.401-12.279 7.054-12.018 7.707-11.495 8.23-11.103 8.622-10.712 9.275-10.189 9.667-9.797 10.32-9.275 10.712-8.622 10.973-8.36 11.495-7.576 12.018-7.185 12.148-6.401 12.671-6.009 13.063-5.225 13.194-4.572 13.716-4.049 13.847-3.266 14.239-2.482 14.369-1.959 14.63-1.045 14.892-0.392 15.153 0.392 15.153 1.045 14.892 1.959 14.761 2.482 14.5 3.266 14.239 4.049 13.977 4.572 13.716 5.225 13.324 6.009 13.063 6.401 12.671 7.185 12.41 7.576 11.887 8.36 11.626 8.622 10.973 9.275 10.712 9.797 10.32 10.189 9.797 10.712 9.144 11.103 8.752 11.495 8.23 12.018 7.707 12.279 7.054 12.671 6.531 13.194 5.878 13.324 5.225 13.716 4.703 13.977 3.919 14.108 3.266 14.63 2.613 14.63 1.959 15.022 1.045 15.153 0.392z", "M784.818 330.883h156.232v-16.067h-142.777l-13.455 16.067z", "M761.436 366.283h179.615v-15.937h-170.209l-9.405 15.937z", "M743.932 401.684h197.119v-15.937h-190.196l-6.923 15.937z", "M731.914 437.215h209.137v-15.937h-204.173l-4.964 15.937z", "M738.968 608.731h202.475v-15.937h-207.439l4.964 15.937z", "M753.859 644.262h187.583v-15.937h-195.029l7.446 15.937z", "M774.891 679.662h166.552v-15.937h-176.61l10.058 15.937z", "M803.89 715.193h137.552v-16.067h-151.53l13.977 16.067z", "M724.99 472.615h216.060v-15.937h-213.056l-3.004 15.937z", "M856.664 573.33h82.296v-15.937h-79.422l-2.874 15.937z", "M863.196 537.93h75.765v-16.067h-72.891l-2.874 16.067z", "M719.504 521.862h21.423v16.067h-20.509l-0.914-16.067z", "M679.532 502.529l-2.874-0.261-1.176-0.131-1.306-0.261-1.176-0.261-1.306-0.131-1.306-0.261-1.437-0.131-1.306-0.261h-1.568l-3.658-0.261h-2.090l-2.351 0.131-2.613 0.131-2.743 0.261-2.090 0.261-1.829 0.261-1.698 0.653-1.568 0.523-2.613 1.568-1.829 1.829-0.653 1.176-0.523 1.045-0.131 1.176v1.176l0.261 1.306 0.392 1.306 0.784 1.306 1.045 1.306 1.959 1.829 2.351 1.568 2.743 1.176 3.004 1.176 3.135 0.914 3.396 1.176 3.266 1.176 3.135 1.306 3.004 1.698 2.743 1.959 2.482 2.613 2.090 3.004 1.568 3.788 0.914 4.441 0.523 5.356-0.523 6.27-0.653 4.703-1.176 4.049-1.568 3.788-1.959 3.266-2.351 2.874-2.482 2.482-2.874 2.090-3.004 1.959-3.135 1.437-3.396 1.306-3.266 0.914-3.527 0.914-3.396 0.523-6.531 0.523-3.004 0.131h-4.311l-3.919-0.131h-3.527l-3.266-0.131-3.004-0.131-2.613-0.131-2.482-0.261-2.221-0.261-2.090-0.131-1.829-0.392-1.959-0.392-1.698-0.392-1.698-0.523-1.568-0.523-1.568-0.653-1.698-0.523 4.441-21.946 0.914 0.261 1.176 0.261 1.306 0.392 1.698 0.392 1.829 0.392 1.959 0.392 2.221 0.523 2.351 0.392 4.964 0.784 5.486 0.523 5.748 0.261h2.874l2.874-0.131 2.874-0.523 2.351-0.914 1.829-1.045 1.306-1.306 1.045-1.437 0.784-1.568 0.523-1.568 0.392-1.568 0.131-2.874-0.914-2.482-1.698-1.959-2.482-1.698-2.874-1.437-3.527-1.568-3.788-1.306-3.919-1.568-3.919-1.829-3.788-2.090-3.527-2.613-3.135-3.004-2.482-3.788-1.829-4.441-0.914-5.356 0.131-6.401 0.523-3.788 0.653-3.788 1.045-3.266 1.176-3.266 1.568-2.874 1.829-2.613 2.090-2.482 2.482-2.221 2.874-1.829 3.135-1.568 3.527-1.568 4.049-1.045 4.441-0.914 4.833-0.653 5.356-0.392 5.878-0.131h3.658l3.396 0.131 3.004 0.131h2.743l2.482 0.261 2.351 0.131 1.959 0.261 1.829 0.131 1.698 0.261 2.613 0.523 1.176 0.131 1.045 0.261h0.914l0.914 0.261 0.653 0.131-4.964 22.338z", "M703.045 455.634h27.432l-4.049 24.036h16.59l-3.658 22.468-17.374-0.523-9.536 55.256-0.131 1.959 0.523 1.698 0.914 1.306 1.306 1.045 1.829 0.784 1.959 0.523 2.221 0.392 2.351 0.261 2.221-0.131 1.959-0.131 1.829-0.392 1.568-0.392 1.306-0.392 0.784-0.261 0.653-0.261h0.261l-3.527 18.419-0.653 0.523-0.784 0.392-1.306 0.784-1.568 0.523-0.784 0.392-0.914 0.261-2.090 0.523-1.176 0.131-1.176 0.261-1.306 0.131-1.437 0.261-1.568 0.131-1.698 0.261h-7.576l-3.919-0.261-3.527-0.392-3.135-0.653-2.613-0.653-2.351-0.914-1.829-1.045-1.698-1.176-1.306-1.306-1.045-1.306-0.653-1.698-0.523-1.698-0.261-1.959-0.131-2.090v-2.090l0.392-2.351 0.261-2.482 18.941-108.161z", "M1001.401 485.548l-1.306-0.653-1.306-0.523-1.306-0.784-1.568-0.653-1.437-0.653-1.698-0.523-1.698-0.653-3.658-1.045-1.959-0.392-2.090-0.392-2.090-0.261-2.221-0.261-2.221-0.131h-7.446l-2.482 0.131-2.743 0.261-2.743 0.523-2.743 0.784-2.874 1.176-2.743 1.306-2.743 1.829-2.743 2.221-2.482 2.482-2.482 3.266-2.482 3.658-2.090 4.311-2.090 4.964-1.829 5.617-1.698 6.27-0.523 3.527-0.392 3.527-0.261 3.527 0.131 3.266 0.261 3.396 0.784 3.266 0.784 2.874 1.176 3.004 1.437 2.743 1.829 2.482 2.090 2.351 2.351 2.090 2.613 1.698 3.135 1.568 3.396 1.306 3.788 0.784 1.306 0.392 1.437 0.261 1.829 0.261 1.959 0.131 2.090 0.261h4.833l2.482-0.261 2.613-0.261 2.482-0.523 2.482-0.653 2.482-0.784 2.482-1.176 2.351-1.306 1.959-1.568 2.090-1.698-4.441 26.387-0.653 0.523-0.653 0.653-0.784 0.653-0.914 0.523-1.045 0.784-1.306 0.784-3.396 1.306-2.351 0.653-2.482 0.523-3.004 0.392-3.527 0.392-3.788 0.131-4.441 0.131-5.095-0.131-5.617-0.261-4.572-0.523-4.572-0.914-4.572-1.568-4.441-1.959-4.441-2.351-4.18-3.004-3.919-3.396-3.658-4.049-3.266-4.441-2.743-4.964-2.482-5.486-1.698-6.14-1.176-6.662-0.392-6.923 0.131-7.838 1.045-8.23 0.914-4.049 0.784-3.919 1.045-3.919 0.914-3.658 1.176-3.396 1.306-3.527 1.306-3.266 1.306-3.135 1.568-3.004 1.437-2.874 1.698-2.743 1.829-2.613 1.698-2.482 1.959-2.351 2.090-2.221 2.090-2.090 4.441-3.919 2.482-1.568 2.482-1.698 2.613-1.437 2.743-1.306 2.743-1.176 2.874-1.045 3.004-1.045 3.135-0.784 3.135-0.653 3.396-0.653 3.396-0.523 3.527-0.392 7.315-0.261 3.266 0.131 3.004 0.131 6.009 0.784 2.743 0.392 2.743 0.523 2.482 0.523 2.351 0.653 2.351 0.523 1.959 0.653 1.959 0.523 1.568 0.653 1.306 0.523 1.176 0.392 0.914 0.392 0.653 0.131-4.964 27.432z", "M1245.547 585.871h-27.563l2.090-10.973v-1.045l-1.698 1.959-1.568 1.829-1.698 1.568-1.829 1.437-1.829 1.306-1.698 1.045-1.829 0.914-1.959 0.914-1.829 0.653-1.829 0.523-3.919 0.784-3.919 0.523h-3.919l-5.095-0.392-4.833-1.045-4.311-1.698-4.049-2.221-3.527-3.004-3.135-3.266-2.743-3.658-2.482-4.18-1.959-4.572-1.568-4.572-1.045-4.833-0.784-5.095-0.392-5.095 0.131-5.095 0.523-5.095 0.914-5.095 1.437-5.748 1.829-5.617 2.090-5.095 2.482-4.703 2.482-4.441 3.004-4.049 3.135-3.527 3.266-3.266 3.396-2.874 3.658-2.482 3.788-2.221 3.788-1.698 3.919-1.306 4.049-0.914 3.919-0.653 4.049-0.131 2.874 0.131 2.743 0.261 2.613 0.523 2.482 0.653 2.221 0.784 1.959 0.914 1.959 1.045 1.829 1.176 1.568 1.176 1.568 1.306 1.176 1.306 1.176 1.176 1.045 1.306 0.914 1.306 0.784 1.176 0.653 1.176 6.923-38.927h26.91l-22.338 129.715z", "M1200.61 561.835l2.743-0.131 2.613-0.653 2.351-0.653 2.351-1.176 1.959-1.176 2.090-1.437 1.829-1.698 1.698-1.829 1.437-1.959 1.437-2.221 1.306-2.221 1.045-2.351 1.045-2.482 0.784-2.613 0.653-2.613 1.045-5.486 0.261-2.874v-2.743l-0.131-2.743-0.261-2.613-0.392-2.482-0.653-2.351-0.784-2.221-1.045-1.959-1.176-1.959-1.306-1.568-1.437-1.437-1.698-1.176-1.829-0.784-1.829-0.523-2.090-0.131-2.743 0.131-2.482 0.392-2.221 0.784-2.351 1.045-1.959 1.306-1.959 1.568-1.698 1.698-1.698 1.829-1.437 2.221-1.437 2.351-1.306 2.351-1.045 2.482-1.045 2.743-1.568 5.486-0.523 3.004-0.523 4.311 0.131 4.703 0.784 4.964 1.176 4.572 2.090 4.049 2.482 3.266 3.266 2.221 4.049 0.784z", "M591.618 563.794l-3.919 22.076h-24.95l0.653-4.049 0.523-3.658 0.392-2.874 0.392-1.437-1.437 1.568-1.568 1.568-1.829 1.568-2.090 1.306-2.351 1.437-2.613 1.176-2.482 1.176-2.743 1.045-2.874 0.914-5.748 1.306-2.874 0.392-3.004 0.131-2.743 0.131-2.874-0.261-2.613-0.392-3.527-0.914-3.135-1.045-2.743-1.306-2.482-1.437-2.221-1.568-1.959-1.829-1.568-1.829-1.437-2.090-1.176-2.090-1.045-2.090-0.784-2.221-0.523-2.221-0.392-2.221-0.392-2.351-0.131-2.090v-2.221l0.261-3.919 0.653-3.658 0.914-3.396 1.306-3.396 1.568-3.135 1.829-2.874 2.090-2.743 2.351-2.613 2.482-2.221 2.743-2.090 2.874-1.829 3.004-1.698 3.135-1.306 3.266-1.176 3.396-0.784 3.527-0.653h0.131l0.523-0.131h0.653l1.176-0.131 1.176-0.261h1.306l1.568-0.261 1.698-0.131 1.698-0.261 3.396-0.261 1.568-0.261 1.698-0.131h1.437l1.306-0.131h3.396l2.482 0.131h4.311l1.829 0.131 1.306 0.131 1.045 0.131h0.261l0.261-0.784 0.523-1.698 0.523-2.090 0.131-1.959-0.261-2.090-0.914-2.090-1.176-1.698-1.698-1.568-1.829-1.176-2.090-0.914-2.351-0.653-2.613-0.131-2.743-0.131-3.004-0.131h-3.135l-6.401 0.261-3.135 0.392-3.135 0.261-3.135 0.392-3.004 0.392-2.874 0.523-2.482 0.523-2.482 0.392-2.090 0.653-1.829 0.653-1.437 0.653-1.045 0.523 7.054-23.905 2.221-0.784 2.090-0.784 2.482-0.784 2.351-0.523 2.351-0.392 2.613-0.392 2.482-0.392 2.743-0.261 2.743-0.131 2.874-0.131 3.004-0.131h9.536l6.923 0.261 2.743 0.131 3.004 0.523 3.135 0.653 3.135 0.914 3.004 1.176 3.004 1.437 3.004 1.698 2.743 1.829 2.482 2.221 2.221 2.351 1.959 2.613 1.437 3.004 1.045 3.266 0.653 3.266v3.788l-0.653 4.049-10.058 52.252z", "M567.713 537.93v-0.523l-0.392-0.392-0.653-0.392-1.045-0.131-1.045-0.261h-5.878l-1.698 0.261-1.568 0.131-1.568 0.261-1.437 0.131-1.437 0.392-1.176 0.261-1.045 0.261-1.568 0.523-1.045 0.392-2.351 1.045-1.306 0.784-1.437 0.653-1.306 0.784-1.306 1.045-1.306 0.914-1.176 1.176-1.176 1.306-0.914 1.176-0.784 1.437-0.523 1.568-0.261 1.568-0.131 3.396 0.523 2.743 0.914 1.959 1.306 1.437 1.437 1.045 1.698 0.523 1.568 0.392h4.703l5.225-0.784 2.221-0.523 3.919-1.568 1.698-0.914 1.437-1.176 1.306-0.914 1.176-1.176 1.045-1.176 0.784-1.176 1.306-2.351 0.392-1.045 0.392-1.176 0.784-2.874 0.653-3.266 0.653-3.135 0.392-2.613z", "M383.004 585.871h-26.91l22.468-130.237h46.896l4.441 77.332 32.396-77.332h48.986l-22.991 130.237h-26.91l16.982-97.319h-1.045l-40.364 97.319h-30.437l-0.131-4.049-0.784-10.842-0.914-15.414-0.914-17.635-1.959-33.31-0.653-11.234-0.131-4.833h-1.568l-16.459 97.319z", "M1083.828 563.794l-4.049 22.076h-24.95l0.261-4.049v-6.27l0.261-1.176-1.306 1.437-1.568 1.568-1.698 1.306-1.959 1.437-2.090 1.306-2.351 1.176-2.482 1.176-2.482 1.045-5.486 1.568-2.743 0.523-2.874 0.392-2.874 0.131-2.743 0.131-2.743-0.261-2.613-0.392-3.527-0.914-3.135-1.045-2.874-1.306-2.482-1.437-2.221-1.568-1.959-1.829-1.568-1.829-1.437-2.090-1.176-2.090-0.784-2.090-0.784-2.221-0.523-2.221-0.392-2.221-0.392-2.351-0.131-2.090v-2.221l0.131-3.919 0.653-3.658 0.914-3.396 1.306-3.396 1.437-3.135 1.959-2.874 1.959-2.743 2.351-2.613 2.613-2.221 2.613-2.090 2.874-1.829 3.135-1.698 3.004-1.306 3.266-1.176 3.266-0.784 3.396-0.653h0.261l0.392-0.131h0.784l0.914-0.131 1.306-0.261h1.437l1.437-0.261 1.568-0.131 1.698-0.261 1.829-0.131 1.698-0.131 1.698-0.261 1.568-0.131h1.306l1.437-0.131h3.527l2.351 0.131h4.441l1.829 0.131 1.698 0.131 0.914 0.131h0.392l0.131-0.784 0.261-1.698 0.392-2.090 0.131-1.959-0.392-2.090-0.784-2.090-1.306-1.698-1.437-1.568-1.829-1.176-2.090-0.914-2.221-0.653-2.351-0.131-2.743-0.131-3.004-0.131h-3.004l-6.531 0.261-3.135 0.392-3.135 0.261-3.135 0.392-3.004 0.392-2.874 0.523-2.482 0.523-2.482 0.392-2.090 0.653-1.829 0.653-1.437 0.653-1.045 0.523 6.923-23.905 4.441-1.568 2.351-0.784 2.351-0.523 4.964-0.784 2.613-0.392 2.613-0.261 8.491-0.392h9.405l6.793 0.261 2.743 0.131 3.004 0.523 3.004 0.653 3.135 0.914 3.135 1.176 3.004 1.437 3.004 1.698 2.874 1.829 2.351 2.221 2.351 2.351 1.959 2.613 1.437 3.004 1.176 3.266 0.653 3.266v3.788l-0.523 4.049-10.32 52.252z", "M1079.779 586.524l0.523-0.523 4.049-22.076-1.176-0.131-4.049 21.946 0.653-0.523v1.306l0.392-0.131 0.131-0.392-0.523 0.523z", "M1054.175 585.871l0.653 0.653h24.95v-1.306h-24.95l0.523 0.653h-1.176v0.653h0.653l-0.653-0.653z", "M1055.873 574.767l-0.914-0.784-0.392 1.568-0.131 2.613v3.658l-0.261 4.049h1.176l0.261-4.049 0.261-3.658-0.131-2.613v-0.784l-0.914-0.784 1.045 0.784z", "M1017.207 587.438v0l2.743 0.392 2.743 0.261h2.743l2.874-0.261 2.874-0.392 2.874-0.523 5.486-1.568 2.482-1.045 2.613-1.176 2.351-1.176 2.090-1.306 2.090-1.437 1.829-1.437 1.568-1.568 1.306-1.437-1.045-0.784-1.306 1.437-1.437 1.437-1.698 1.306-1.959 1.437-2.090 1.176-4.703 2.351-2.482 1.045-2.613 0.784-2.743 0.784-2.743 0.523-2.743 0.392-2.874 0.261h-2.743l-2.743-0.261-2.482-0.392-0.261 1.176z", "M993.302 557.394v0 2.221l0.261 2.090 0.261 2.482 0.392 2.221 0.523 2.221 0.784 2.221 0.914 2.351 2.613 4.18 1.698 1.829 1.959 1.829 2.221 1.698 2.613 1.568 2.874 1.306 3.266 0.914 3.527 0.914 0.261-1.176-3.527-0.914-3.135-1.045-2.743-1.176-2.482-1.437-2.090-1.568-1.829-1.698-1.568-1.829-1.437-1.959-1.045-2.090-0.914-2.090-0.784-2.090-0.523-2.090-0.392-2.351-0.261-2.221-0.261-2.090 0.131-2.221h-1.306z", "M1028.833 519.381v0l-3.396 0.523-3.396 0.914-3.266 1.045-3.266 1.437-3.004 1.568-3.004 1.959-2.613 2.090-2.613 2.351-2.351 2.482-4.18 5.748-1.437 3.396-1.306 3.266-0.914 3.658-0.523 3.658-0.261 3.919h1.306l0.131-3.919 0.653-3.527 0.784-3.396 1.306-3.396 1.568-3.004 1.698-2.743 2.090-2.874 2.221-2.351 2.482-2.221 2.743-2.090 2.743-1.829 3.135-1.568 3.004-1.437 3.266-1.045 3.135-0.914 3.266-0.523v-1.176z", "M1049.211 517.29v0h-1.045l-1.437 0.131-1.306 0.131-1.568 0.131-3.396 0.261-1.829 0.131-1.698 0.261-1.568 0.261-2.874 0.261-1.306 0.131-0.914 0.131-0.784 0.131-0.392 0.131h-0.261v1.176h0.261l0.523-0.131 0.653-0.131 0.914-0.131 1.306-0.131 2.874-0.261 1.568-0.261 1.698-0.131 1.829-0.261 3.396-0.261 1.568-0.131 1.306-0.131h2.482v-1.306z", "M1062.666 518.336l0.653-0.523h-0.392l-0.914-0.131h-1.698l-1.829-0.261h-4.441l-2.351-0.131h-2.482v1.306h4.833l2.221 0.261h4.049l1.698 0.131h1.306v0l0.392 0.131 0.131-0.523-1.176-0.261z", "M1063.711 511.935h-0.131l-0.131 1.959-0.261 1.959-0.261 1.829-0.261 0.653 1.176 0.261 0.261-0.784 0.261-1.829 0.261-2.090 0.392-1.959h-1.306z", "M1051.824 502.138v0.131l2.351 0.131 2.090 0.523 1.959 0.914 1.698 1.176 1.306 1.437 1.176 1.698 0.914 1.698 0.392 2.090h1.176l-0.392-2.221-0.784-2.221-1.437-1.829-1.568-1.568-1.959-1.437-2.221-0.914-2.221-0.523-2.482-0.392v1.306z", "M1009.37 506.971l0.914 0.523 2.351-1.176 1.568-0.523 2.221-0.653 2.351-0.523 2.613-0.523 5.748-0.784 3.135-0.523 6.27-0.523 3.266-0.131h12.018v-1.176l-2.743-0.131-3.004-0.131h-3.004l-3.266 0.131-3.266 0.261-6.27 0.523-3.135 0.523-3.004 0.261-2.874 0.523-2.613 0.523-2.351 0.523-2.221 0.523-1.829 0.653-1.568 0.653-1.176 0.784 1.045 0.523-1.176-0.131z", "M1016.685 482.543l-0.392 0.523-6.923 23.905 1.176 0.131 6.923-23.905-0.392 0.523-0.392-1.176-0.392 0.131v0.392l0.392-0.523z", "M1060.837 477.971v0l-6.793-0.261h-9.405l-2.743 0.131-2.874 0.131-2.874 0.261-2.613 0.131-2.743 0.392-2.482 0.392-2.482 0.523-2.351 0.523-2.351 0.653-2.351 0.784-2.090 0.914 0.392 1.176 2.221-0.914 2.221-0.784 2.221-0.653 2.351-0.523 2.482-0.523 4.964-0.784 2.613-0.131 2.874-0.261 2.874-0.131h12.148l3.396 0.131h3.396v-1.176z", "M1094.801 511.543v0l0.523-4.049v-3.788l-0.784-3.396-1.045-3.266-1.568-3.135-1.959-2.743-2.482-2.482-2.482-2.221-2.743-1.829-3.004-1.829-6.27-2.613-3.266-0.784-3.135-0.784-3.004-0.392-2.743-0.261v1.176l2.743 0.261 2.874 0.392 3.004 0.784 3.135 0.914 3.004 1.176 3.004 1.306 3.004 1.568 2.613 1.959 2.482 2.221 2.221 2.221 1.959 2.613 1.437 2.874 1.045 3.004 0.784 3.266v3.788l-0.523 3.919 1.176 0.131z", "M1084.351 563.925v0l10.45-52.382-1.176-0.131-10.45 52.382 1.176 0.131z", "M1059.792 537.93l-0.261-0.523-0.392-0.523-0.653-0.261-1.045-0.392h-1.045l-1.306-0.131h-1.437l-3.135 0.261-1.568 0.261-1.568 0.131-1.437 0.261-1.568 0.261-1.306 0.131-1.176 0.392-1.045 0.131-0.653 0.131-0.784 0.261-2.090 0.784-1.306 0.523-2.613 1.306-2.613 1.829-1.306 1.045-1.045 1.045-1.045 1.306-0.914 1.437-0.653 1.437-0.653 1.568-0.261 1.698-0.131 3.396 0.523 2.743 0.784 1.959 1.176 1.437 1.437 1.045 1.698 0.523 1.698 0.392h4.703l2.743-0.392 2.613-0.523 2.221-0.653 2.221-0.784 3.658-1.829 1.568-1.176 1.437-1.176 1.176-1.306 1.045-1.176 0.914-1.306 0.653-1.176 0.523-1.176 0.392-1.176 0.392-1.045 0.261-2.874 0.523-2.874 0.392-2.743 0.261-2.482z", "M1264.096 572.285l0.131-2.351 0.784-2.613 1.437-2.351 1.698-2.090 2.090-1.698 2.351-1.176 2.613-0.784 2.743-0.392 2.743 0.392 2.613 0.784 2.351 1.176 2.090 1.698 1.698 2.090 1.306 2.351 0.914 2.613 0.131 2.351h-3.004v-1.829l-0.653-2.221-0.914-1.959-1.306-1.698-1.698-1.306-1.829-1.045-2.221-0.653-2.221-0.261-2.351 0.261-2.090 0.653-1.959 1.045-1.568 1.306-1.306 1.698-0.914 1.959-0.653 2.221-0.131 1.829h-2.874z", "M1272.979 572.285v-6.009h5.486l1.176 0.131 1.045 0.261 0.784 0.261 0.784 0.392 0.392 0.653 0.392 0.523 0.261 0.653 0.131 0.784-0.131 0.784-0.261 0.784-0.392 0.784h-4.18l0.392-0.131 1.306-0.261 0.523-0.261 0.523-0.523 0.261-0.523v-0.653l-0.131-0.523-0.261-0.392-0.261-0.261-0.261-0.131-1.045-0.261h-4.049v3.919h-2.482z", "M1264.096 572.285l-0.131 0.523 0.261 2.874 0.784 2.743 1.437 2.351 1.698 1.959 2.090 1.698 2.351 1.306 2.613 0.784 2.743 0.392 2.743-0.392 2.613-0.784 2.351-1.306 2.090-1.698 1.698-1.959 1.306-2.351 0.914-2.743 0.261-2.874-0.131-0.523h-3.004l0.131 0.523-0.131 2.482-0.653 2.090-0.914 1.959-1.306 1.698-1.698 1.306-1.829 1.176-2.221 0.653-2.221 0.131-2.351-0.131-2.090-0.653-1.959-1.176-1.568-1.306-1.306-1.698-0.914-1.959-0.653-2.090-0.131-2.482v-0.523h-2.874z", "M1272.979 572.285v6.009h2.482v-4.964h2.482l3.004 4.964h1.959l-3.004-4.964h0.784l0.653-0.131 0.523-0.261 0.523-0.392 0.261-0.261h-4.18l-0.523 0.131h-2.482v-0.131h-2.482z", "M1091.274 585.871h27.955l10.32-58.652 0.653-2.090 0.523-2.221 0.784-2.221 1.045-2.090 1.176-2.090 1.306-2.090 1.568-1.829 1.829-1.698 1.959-1.568 2.221-1.568 2.613-1.176 2.874-0.914 3.135-0.784 3.527-0.653 3.919-0.131h2.482l4.441-25.473-2.743 0.131-2.743 0.261-2.482 0.523-2.351 0.653-2.221 0.784-2.090 1.045-1.959 1.045-3.658 2.613-1.698 1.437-3.135 3.135-1.568 1.698-2.874 3.658-1.437 1.959 3.004-17.896h-27.824l-18.549 106.201z", "M828.71 585.871h28.346l9.536-56.432 0.392-2.221 1.045-4.18 0.653-1.959 0.784-1.959 1.045-1.829 1.176-1.829 1.437-1.698 1.568-1.437 1.698-1.568 2.221-1.176 2.351-1.045 2.874-0.914 3.004-0.784 3.396-0.523 3.919-0.261h0.261l0.392 0.131h0.914l0.523 0.131 0.392 0.131 0.261 0.131h0.131l0.131-0.392 0.261-1.306 0.392-1.698 0.523-2.221 0.653-2.613 0.784-2.743 0.914-2.743 0.784-2.743 0.914-1.959 0.914-1.829 1.045-1.959 0.914-1.698 0.914-1.437 0.653-1.176 0.523-0.653 0.261-0.392h-0.523l-0.523-0.131-0.653-0.131h-0.784l-0.784-0.131h-1.306l-3.135 0.131-2.743 0.261-2.613 0.523-2.351 0.653-2.351 0.784-1.959 0.914-1.959 1.045-1.698 1.176-1.698 1.306-1.568 1.437-1.568 1.568-1.437 1.698-1.568 1.698-1.306 1.829-1.568 1.959-1.437 1.959 3.527-17.896h-28.346l-18.549 106.201z", "M1264.227 690.113v-0.392l0.784-2.482 1.437-2.351 1.698-1.959 2.090-1.568 2.351-1.176 2.613-0.653 2.743-0.392 2.743 0.392 2.613 0.653 2.351 1.176 2.090 1.568 1.698 1.959 1.306 2.351 0.914 2.482v0.392h-2.874l-0.653-1.959-0.914-1.959-1.306-1.698-1.698-1.306-1.829-1.176-2.221-0.653-2.221-0.261-2.351 0.261-2.090 0.653-1.959 1.176-1.568 1.306-1.306 1.698-0.914 1.959-0.653 1.959h-2.874z", "M1272.979 690.113v-3.396h6.662l1.045 0.131 0.784 0.261 0.784 0.392 0.784 1.045 0.261 0.784 0.131 0.784h-1.959v-0.392l-0.131-0.523-0.261-0.392-0.261-0.261-0.261-0.131-1.045-0.261h-4.049v1.959h-2.482z", "M1263.965 692.333l0.261-2.221h2.874v0.131l-0.131 2.090h-3.004z", "M1272.979 692.333v-2.221h2.482v2.090h2.482l0.914-0.261 1.306-0.261 0.523-0.261 0.523-0.523 0.261-0.523v-0.261h1.959l-0.131 0.784-0.523 1.045-0.392 0.392h-9.405z", "M1288.915 692.333l-0.131-2.090v-0.131h2.874l0.261 2.221h-3.004z", "M1263.965 692.333v0.261l0.261 2.874 0.784 2.743 1.437 2.351 1.698 2.090 2.090 1.698 2.351 1.176 2.613 0.784 2.743 0.261 2.743-0.261 2.613-0.784 2.351-1.176 2.090-1.698 1.698-2.090 1.306-2.351 0.914-2.743 0.261-2.874v-0.261h-3.004v0.261l-0.131 2.482-0.653 2.090-0.914 1.959-1.306 1.698-1.698 1.306-1.829 1.176-2.221 0.653-2.221 0.131-2.351-0.131-2.090-0.653-1.959-1.176-1.568-1.306-1.306-1.698-0.914-1.959-0.653-2.090-0.131-2.482v-0.261h-3.004z", "M1272.979 692.333v5.748h2.482v-4.964h2.482l3.004 4.964h1.959l-3.004-4.964h0.784l0.653-0.131 0.523-0.261 0.523-0.392h-9.405z", "M831.714 511.282l-0.784-5.878-1.437-5.225-1.959-4.572-2.482-3.919-3.004-3.396-3.266-2.743-3.527-2.351-3.788-1.829-3.919-1.568-4.049-1.045-4.049-0.653-4.049-0.392-3.788-0.131-8.099 0.392-7.185 1.176-6.401 1.829-5.748 2.482-4.964 3.004-4.311 3.396-3.788 3.788-3.135 3.919-2.743 4.18-2.351 4.311-1.698 4.311-1.568 4.18-1.045 4.18-0.784 3.788-0.523 3.658-0.392 3.135-0.523 8.099 0.261 7.315 1.045 6.662 1.698 5.878 2.351 5.225 2.874 4.572 3.396 4.049 3.919 3.396 4.18 2.874 4.441 2.482 4.703 1.959 4.833 1.437 4.964 1.176 4.964 0.653 4.964 0.523 4.833 0.131h3.266l3.004-0.131h2.743l2.613-0.131 2.351-0.131 2.090-0.131 1.959-0.261 1.829-0.261 1.698-0.261 1.568-0.392 1.568-0.523 1.437-0.523 1.437-0.653 1.568-0.523 3.135-1.568 3.919-24.428-2.874 1.698-2.743 1.568-2.874 1.176-2.743 1.045-2.743 0.914-5.486 1.045-2.743 0.392-2.613 0.261-2.613 0.131h-2.743l-2.613-0.131-5.225-0.523-2.482-0.261-2.613-0.392-1.959-0.392-2.090-0.653-1.959-0.914-1.698-1.045-1.829-1.176-1.568-1.437-1.437-1.437-1.437-1.698-1.176-1.698-1.045-1.829-0.784-1.829-0.653-1.829-0.392-1.829-0.131-1.829 0.131-1.698 0.261-1.306h64.269l0.523-6.009 1.437-8.36 0.653-7.576-0.261-6.923zM804.805 520.426h-36.184v-0.131l0.261-1.437 0.392-2.090 0.523-1.959 0.653-1.959 0.914-1.829 0.914-1.568 1.045-1.568 1.176-1.437 1.306-1.437 1.306-1.176 1.568-1.045 1.437-0.914 1.698-0.784 1.698-0.523 1.698-0.392 1.698-0.261 1.959-0.131 3.396 0.523 1.568 0.392 1.568 0.523 1.568 0.784 1.437 0.914 1.306 1.045 1.176 1.176 2.090 2.874 0.653 1.437 0.653 1.829 0.392 1.959 0.261 2.221 0.131 2.351-0.261 2.613z"],
    attrs: [{
      fill: "rgb(19, 69, 124)"
    }, {
      fill: "rgb(251, 178, 49)"
    }, {
      fill: "rgb(236, 28, 46)"
    }, {
      fill: "rgb(251, 178, 49)"
    }, {
      fill: "rgb(251, 178, 49)"
    }, {
      fill: "rgb(251, 178, 49)"
    }, {
      fill: "rgb(251, 178, 49)"
    }, {
      fill: "rgb(251, 178, 49)"
    }, {
      fill: "rgb(251, 178, 49)"
    }, {
      fill: "rgb(251, 178, 49)"
    }, {
      fill: "rgb(251, 178, 49)"
    }, {
      fill: "rgb(251, 178, 49)"
    }, {
      fill: "rgb(251, 178, 49)"
    }, {
      fill: "rgb(251, 178, 49)"
    }, {
      fill: "rgb(251, 178, 49)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(251, 178, 49)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(236, 28, 46)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(251, 178, 49)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(251, 178, 49)"
    }, {
      fill: "rgb(251, 178, 49)"
    }, {
      fill: "rgb(251, 178, 49)"
    }, {
      fill: "rgb(251, 178, 49)"
    }, {
      fill: "rgb(251, 178, 49)"
    }, {
      fill: "rgb(251, 178, 49)"
    }, {
      fill: "rgb(251, 178, 49)"
    }, {
      fill: "rgb(255, 255, 255)"
    }],
    grid: 16,
    tags: ["icons8-mastercard"],
    isMulticolor: true,
    isMulticolor2: false,
    colorPermutations: {
      "120169124916551125519371255255255125561015787167163811811": [{
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 0
      }, {
        f: 6
      }, {
        f: 0
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 0
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 6
      }],
      "12016911969124123628461249165511251178491255255255157871671": [{
        f: 0
      }, {
        f: 4
      }, {
        f: 3
      }, {
        f: 4
      }, {
        f: 4
      }, {
        f: 4
      }, {
        f: 4
      }, {
        f: 4
      }, {
        f: 4
      }, {
        f: 4
      }, {
        f: 4
      }, {
        f: 4
      }, {
        f: 4
      }, {
        f: 4
      }, {
        f: 4
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 4
      }, {
        f: 6
      }, {
        f: 3
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 4
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 4
      }, {
        f: 4
      }, {
        f: 4
      }, {
        f: 4
      }, {
        f: 4
      }, {
        f: 4
      }, {
        f: 4
      }, {
        f: 6
      }]
    },
    width: 1632
  },
  attrs: [{
    fill: "rgb(19, 69, 124)"
  }, {
    fill: "rgb(251, 178, 49)"
  }, {
    fill: "rgb(236, 28, 46)"
  }, {
    fill: "rgb(251, 178, 49)"
  }, {
    fill: "rgb(251, 178, 49)"
  }, {
    fill: "rgb(251, 178, 49)"
  }, {
    fill: "rgb(251, 178, 49)"
  }, {
    fill: "rgb(251, 178, 49)"
  }, {
    fill: "rgb(251, 178, 49)"
  }, {
    fill: "rgb(251, 178, 49)"
  }, {
    fill: "rgb(251, 178, 49)"
  }, {
    fill: "rgb(251, 178, 49)"
  }, {
    fill: "rgb(251, 178, 49)"
  }, {
    fill: "rgb(251, 178, 49)"
  }, {
    fill: "rgb(251, 178, 49)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(251, 178, 49)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(236, 28, 46)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(251, 178, 49)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(251, 178, 49)"
  }, {
    fill: "rgb(251, 178, 49)"
  }, {
    fill: "rgb(251, 178, 49)"
  }, {
    fill: "rgb(251, 178, 49)"
  }, {
    fill: "rgb(251, 178, 49)"
  }, {
    fill: "rgb(251, 178, 49)"
  }, {
    fill: "rgb(251, 178, 49)"
  }, {
    fill: "rgb(255, 255, 255)"
  }],
  properties: {
    order: 240,
    id: 8,
    name: "mastercard",
    prevSize: 32,
    code: 59672,
    codes: [59672, 59673, 59674, 59668, 59669, 59675, 59676, 59677, 59678, 59679, 59680, 59681, 59682, 59683, 59684, 59685, 59686, 59687, 59688, 59689, 59690, 59691, 59692, 59693, 59694, 59695, 59696, 59697, 59698, 59699, 59700, 59701, 59702, 59703, 59704, 59705, 59706, 59707, 59708, 59709, 59710, 59711, 59712, 59713, 59714, 59715, 59716, 59717, 59718, 59719, 59720, 59721, 59722, 59723]
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 10
}, {
  icon: {
    paths: ["M1638.478 969.397c0 30.175-24.428 54.603-54.603 54.603h-1529.273c-30.175 0-54.603-24.428-54.603-54.603v-914.794c0-30.175 24.428-54.603 54.603-54.603h1529.273c30.175 0 54.603 24.428 54.603 54.603v914.794z", "M753.99 665.816h-80.076l50.031-307.37h80.076z", "M606.641 358.446l-76.287 211.358-9.013-45.589-26.91-138.205c0 0-3.266-27.693-38.013-27.693h-126.188l-1.437 5.225c0 0 38.536 7.968 83.733 35.139l69.495 267.136h83.341l127.363-307.37h-86.084z", "M1236.141 665.816h73.413l-64.008-307.37h-64.4c-29.783 0-36.968 22.86-36.968 22.86l-119.395 284.51h83.472l16.721-45.72h101.76l9.405 45.72zM1148.097 557.132l42.063-115.084 23.644 115.084h-65.706z", "M1031.185 432.382l11.365-65.968c0 0-35.27-13.455-71.977-13.455-39.711 0-134.025 17.374-134.025 101.76 0 79.422 110.773 80.467 110.773 122.138s-99.278 34.225-132.066 7.968l-11.887 68.972c0 0 35.792 17.374 90.395 17.374s137.030-28.346 137.030-105.287c0-79.945-111.688-87.391-111.688-122.138-0.131-34.747 77.855-30.306 112.080-11.365z", "M521.34 524.344l-26.91-138.205c0 0-3.266-27.693-38.013-27.693h-126.188l-1.437 5.225c0 0 60.612 12.54 118.742 59.697 55.648 44.936 73.805 100.976 73.805 100.976z"],
    attrs: [{
      fill: "rgb(57, 87, 167)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(249, 165, 51)"
    }],
    grid: 16,
    tags: ["icons8-visa"],
    isMulticolor: true,
    isMulticolor2: false,
    colorPermutations: {
      "1201691211011921255193712552552551255610163811811": [{
        f: 0
      }, {
        f: 5
      }, {
        f: 5
      }, {
        f: 5
      }, {
        f: 5
      }, {
        f: 0
      }],
      "120169124916551125519371255255255125561015787167163811811": [{
        f: 1
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 5
      }],
      "12016911969124123628461249165511251178491255255255157871671": [{
        f: 2
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 6
      }, {
        f: 5
      }]
    },
    width: 1632
  },
  attrs: [{
    fill: "rgb(57, 87, 167)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(249, 165, 51)"
  }],
  properties: {
    order: 250,
    id: 7,
    name: "visa",
    prevSize: 32,
    code: 59729,
    codes: [59729, 59730, 59731, 59732, 59733, 59734]
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 11
}, {
  icon: {
    paths: ["M512 960c-247.424 0-448-200.576-448-448s200.576-448 448-448v0c247.424 0 448 200.576 448 448s-200.576 448-448 448v0zM512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512v0c-282.77 0-512 229.23-512 512s229.23 512 512 512v0z", "M702.080 318.080c-0.449 0.436-0.868 0.895-1.257 1.379l-0.023 0.029-222.272 283.2-133.952-134.016c-8.549-7.982-20.063-12.883-32.723-12.883-26.51 0-48 21.49-48 48 0 12.659 4.901 24.174 12.908 32.751l-0.026-0.028 169.344 169.408c8.683 8.668 20.671 14.028 33.91 14.028 13.865 0 26.357-5.879 35.119-15.279l0.026-0.029 255.488-319.36c8.201-8.596 13.248-20.264 13.248-33.11 0-26.51-21.49-48-48-48-13.181 0-25.121 5.313-33.795 13.914l0.003-0.003z"],
    attrs: [{}, {}],
    isMulticolor: false,
    isMulticolor2: false,
    grid: 16,
    tags: ["check-circle"],
    colorPermutations: {
      "111111111111211211212110119212551937125525525512556101323333148111197163811811": [{}, {}],
      "1201691211011921255193712552552551255610163811811": [{}, {}],
      "120169124916551125519371255255255125561015787167163811811": [{}, {}],
      "12016911969124123628461249165511251178491255255255157871671": [{}, {}]
    }
  },
  attrs: [{}, {}],
  properties: {
    order: 60,
    id: 6,
    name: "check-circle",
    prevSize: 32,
    code: 59653
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 12
}, {
  icon: {
    paths: ["M726.656 105.344c5.808 5.794 9.401 13.805 9.401 22.656s-3.593 16.862-9.401 22.655l-0.001 0.001-361.408 361.344 361.408 361.344c5.798 5.798 9.384 13.808 9.384 22.656 0 17.695-14.345 32.040-32.040 32.040-8.848 0-16.858-3.586-22.656-9.384v0l-384-384c-5.808-5.794-9.401-13.805-9.401-22.656s3.593-16.862 9.401-22.655l0.001-0.001 384-384c5.794-5.808 13.805-9.401 22.656-9.401s16.862 3.593 22.655 9.401l0.001 0.001z"],
    attrs: [{}],
    isMulticolor: false,
    isMulticolor2: false,
    grid: 16,
    tags: ["chevron-left"],
    colorPermutations: {
      "111111111111211211212110119212551937125525525512556101323333148111197163811811": [{}],
      "1201691211011921255193712552552551255610163811811": [{}],
      "120169124916551125519371255255255125561015787167163811811": [{}],
      "12016911969124123628461249165511251178491255255255157871671": [{}]
    }
  },
  attrs: [{}],
  properties: {
    order: 58,
    id: 5,
    name: "chevron-left",
    prevSize: 32,
    code: 59652
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 13
}, {
  icon: {
    paths: ["M2309.879 773.958c-85.992 92.628-184.326 125.644-247.679 125.644-76.637-1.38-139.935-56.789-153.493-129.679l-0.152-0.982c90.208-175.194 149.736-380.169 165.705-597.252l0.309-5.226v-2.123c0-95.176-61.283-164.235-145.736-164.235s-148.815 69.006-148.947 160.838c0 0 0 578.591 0.372 583.899-42.864 45.677-152 154.786-295.108 154.786-100.484 0-136.261-88.275-136.261-170.87v-262.303h297.762v-124.397h-297.682v-296.037h-124.397v295.984h-108.818v124.397h108.818v287.358c-68.311 83.121-169.16 137.341-282.794 143.045l-0.928 0.037c-0.095 0-0.207 0.001-0.32 0.001-44.593 0-80.772-36.022-81.028-80.554l-0-0.024v-474.684h-124.397v474.684c0.347 113.279 92.258 204.975 205.585 204.975 0.056 0 0.113-0 0.169-0l-0.009 0c124.315-4.121 236.645-52.269 322.61-129.255l-0.484 0.426c8.209 15.164 16.872 28.19 26.565 40.36l-0.422-0.548c45.232 56.184 114.004 91.832 191.103 91.832 1.798 0 3.592-0.019 5.381-0.058l-0.267 0.005c149.346 0 264.666-80.18 334.415-143.135 12.032 20.92 25.495 39.007 40.809 55.338l-0.148-0.159c50.242 54.168 121.802 87.957 201.253 87.957 0.254 0 0.508-0 0.762-0.001l-0.039 0c116.010 0 242.69-61.814 338.847-165.403zM1897.46 176.072c0-1.805 0-27.523 0-27.629-0-0.061-0.001-0.132-0.001-0.204 0-17.080 13.379-31.036 30.228-31.96l0.082-0.004c0.034-0 0.074-0 0.115-0 16.652 0 30.15 13.499 30.15 30.15 0 0.252-0.003 0.503-0.009 0.754l0.001-0.037c-3.503 142.894-25.264 279.282-63.035 408.846l2.813-11.264z", "M491.935 341.926c8.623 28.065 13.589 60.327 13.589 93.748 0 0.073-0 0.145-0 0.218l0-0.011c0 124.344-25.851 227.163-160.811 427.308l-210.549-521.13h-134.191l272.761 675.12h115.002l15.925-20.728c170.605-239.080 226.341-378.977 226.341-560.411 0-0.023 0-0.051 0-0.078 0-33.243-3.548-65.658-10.285-96.886l0.544 3.009z", "M797.208 209.859c45.224-0.015 81.879-36.68 81.879-81.905 0-45.235-36.67-81.905-81.905-81.905s-81.905 36.67-81.905 81.905v-0c0.060 45.22 36.71 81.86 81.927 81.905l0.004 0z"],
    width: 2401,
    attrs: [{}, {}, {}],
    isMulticolor: false,
    isMulticolor2: false,
    tags: ["logo"],
    grid: 16,
    colorPermutations: {
      "111111111111211211212110119212551937125525525512556101323333148111197163811811": [{}, {}, {}],
      "1201691211011921255193712552552551255610163811811": [{}, {}, {}],
      "120169124916551125519371255255255125561015787167163811811": [{}, {}, {}],
      "12016911969124123628461249165511251178491255255255157871671": [{}, {}, {}]
    }
  },
  attrs: [{}, {}, {}],
  properties: {
    order: 231,
    id: 0,
    name: "logo",
    prevSize: 32,
    code: 59651
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 14
}, {
  icon: {
    paths: ["M1129.931 0c-35.31 0-58.851 11.77-70.621 35.31 0 11.77-659.126 765.057-670.897 753.287l-117.701-141.241c-58.851-70.621-117.701-129.471-129.471-141.241-35.31-23.54-70.621-23.54-105.931 11.77s-47.080 58.851-23.54 94.161c0 23.54-11.77 0 176.552 211.862 153.011 164.782 164.782 176.552 188.322 188.322 0 0 11.77 0 35.31 0s35.31 0 47.080-11.77c11.77 0 741.517-847.448 765.057-870.989 11.77-11.77 11.77-35.31 11.77-58.851-11.77-47.080-47.080-70.621-105.931-70.621z"],
    width: 1224,
    attrs: [{}],
    isMulticolor: false,
    isMulticolor2: false,
    tags: ["check"],
    grid: 16,
    colorPermutations: {
      "111111111111211211212110119212551937125525525512556101323333148111197163811811": [{}],
      "1201691211011921255193712552552551255610163811811": [{}],
      "120169124916551125519371255255255125561015787167163811811": [{}],
      "12016911969124123628461249165511251178491255255255157871671": [{}]
    }
  },
  attrs: [{}],
  properties: {
    order: 230,
    id: 1,
    name: "check",
    prevSize: 32,
    code: 59648
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 15
}, {
  icon: {
    paths: ["M993.92 849.536l-336.768-336.64 336.768-336.64c15.209-17.761 24.465-41.011 24.465-66.422 0-56.554-45.846-102.4-102.4-102.4-25.188 0-48.252 9.094-66.088 24.179l0.151-0.124-336.768 336.64-337.408-336.64c-17.789-15.304-41.11-24.623-66.607-24.623-56.554 0-102.4 45.846-102.4 102.4 0 25.497 9.319 48.818 24.736 66.742l-0.113-0.135 336.768 336.64-336.768 336.64c-19.343 18.065-31.4 43.721-31.4 72.192s12.057 54.127 31.343 72.139l0.057 0.053c18.409 18.619 43.954 30.15 72.192 30.15s53.783-11.531 72.183-30.141l0.009-0.009 336.768-336.64 337.408 337.024c18.509 18.402 44.022 29.777 72.192 29.777s53.683-11.375 72.197-29.782l-0.005 0.005c18.499-18.371 29.949-43.818 29.949-71.94 0-28.374-11.657-54.026-30.444-72.427l-0.017-0.017z"],
    attrs: [{}],
    isMulticolor: false,
    isMulticolor2: false,
    tags: ["close"],
    grid: 16,
    colorPermutations: {
      "111111111111211211212110119212551937125525525512556101323333148111197163811811": [{}],
      "1201691211011921255193712552552551255610163811811": [{}],
      "120169124916551125519371255255255125561015787167163811811": [{}],
      "12016911969124123628461249165511251178491255255255157871671": [{}]
    }
  },
  attrs: [{}],
  properties: {
    order: 229,
    id: 2,
    name: "close",
    prevSize: 32,
    code: 59649
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 16
}, {
  icon: {
    paths: ["M1000.286 581.193l0.375-2.847c1.199-8.766 2.173-17.607 2.847-26.523 0.077-0.898 0.122-1.942 0.122-2.997 0-20.447-16.575-37.022-37.022-37.022-19.392 0-35.301 14.909-36.891 33.89l-0.009 0.135q-1.349 16.334-3.821 32.368c-33.58 200.96-206.194 352.233-414.14 352.233-149.015 0-279.886-77.682-354.327-194.76l-1.013-1.704h98.227c20.442 0 37.013-16.571 37.013-37.013s-16.571-37.013-37.013-37.013h-198.851c-0-0-0-0-0-0-20.415 0-36.97 16.529-37.013 36.934l-0 0.004v199.75c0 20.442 16.571 37.013 37.013 37.013s37.013-16.571 37.013-37.013v0-124.6c88.463 140.922 243.020 233.225 419.135 233.225 248.003 0 453.256-183.038 488.037-421.392l0.319-2.667zM24.838 434.415l-0.45 2.772c-1.723 11.464-3.072 23.152-4.046 34.915-0.077 0.898-0.122 1.942-0.122 2.997 0 20.447 16.575 37.022 37.022 37.022 19.392 0 35.301-14.909 36.891-33.89l0.009-0.135c1.229-15.63 3.088-29.615 5.633-43.359l-0.388 2.525c37.029-196.984 207.704-344.027 412.722-344.027 149.061 0 279.967 77.73 354.396 194.868l1.014 1.707h-98.227c-20.442 0-37.013 16.571-37.013 37.013s16.571 37.013 37.013 37.013h199.001c20.442 0 37.013-16.571 37.013-37.013v0-199.525c0-20.442-16.571-37.013-37.013-37.013s-37.013 16.571-37.013 37.013v-0 124.6c-88.415-141.177-243.112-233.677-419.415-233.677-245.207 0-448.622 178.933-486.796 413.351l-0.382 2.843z"],
    attrs: [{
      strokeLinejoin: "miter",
      strokeLinecap: "butt",
      strokeMiterlimit: "4",
      strokeWidth: 36.57142857142857
    }],
    isMulticolor: false,
    isMulticolor2: false,
    tags: ["subscribe"],
    grid: 16,
    colorPermutations: {
      "111111111111211211212110119212551937125525525512556101323333148111197163811811": [{}],
      "1201691211011921255193712552552551255610163811811": [{}],
      "120169124916551125519371255255255125561015787167163811811": [{}],
      "12016911969124123628461249165511251178491255255255157871671": [{}]
    }
  },
  attrs: [{
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: "4",
    strokeWidth: 36.57142857142857
  }],
  properties: {
    order: 246,
    id: 3,
    name: "subscribe",
    prevSize: 32,
    code: 59727
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 17
}];
var height = 1024;
var metadata = {
  name: "VITL"
};
var preferences = {
  showGlyphs: true,
  showCodes: true,
  showQuickUse: true,
  showQuickUse2: true,
  showSVGs: true,
  fontPref: {
    prefix: "icon-",
    metadata: {
      fontFamily: "VITL",
      majorVersion: 1,
      minorVersion: 0
    },
    metrics: {
      emSize: 1024,
      baseline: 6.25,
      whitespace: 50
    },
    embed: false
  },
  imagePref: {
    prefix: "icon-",
    png: true,
    useClassSelector: true,
    color: 0,
    bgColor: 16777215,
    name: "icomoon",
    classSelector: ".icon"
  },
  historySize: 50,
  gridSize: 16,
  showGrid: true
};
var iconSet = {
  IcoMoonType: IcoMoonType,
  icons: icons,
  height: height,
  metadata: metadata,
  preferences: preferences
};

/**
 *
 * USAGE
 * Use https://svgps.app/collection/ or https://icomoon.io/app/#/select to load `selection.json`
 * Then add the font you like and generate selection.json again
 * Commit new version here and update versions
 */
var Icon = function Icon(_a) {
  var _b = _a.color,
    color = _b === void 0 ? "#333333" : _b,
    rest = __rest$1(_a, ["color"]);
  return React.createElement(_default, _assign$({
    iconSet: iconSet,
    color: color
  }, rest));
};
var styles$g = {
  "list": "list-module_list__eRKTA",
  "smallFont": "list-module_smallFont__ubZrK",
  "mediumFont": "list-module_mediumFont__3MKBD",
  "horizontal": "list-module_horizontal__jrLqX",
  "vertical": "list-module_vertical__kbFOP",
  "smallSpacing": "list-module_smallSpacing__h4Bq-",
  "mediumSpacing": "list-module_mediumSpacing__Qw0gr",
  "fadeInDown": "list-module_fadeInDown__Xu05I",
  "fadeInUp": "list-module_fadeInUp__1w-AS",
  "fadeInDropdown": "list-module_fadeInDropdown__cgBSC",
  "fadeOutDropdown": "list-module_fadeOutDropdown__gOhfz"
};
var getIconComponent = function getIconComponent(icon, iconColor) {
  if (icon === "cross") {
    return React.createElement(Icon, {
      icon: "close",
      color: iconColor,
      size: 9
    });
  }
  if (icon === "check") {
    return React.createElement(Icon, {
      icon: "check",
      color: iconColor,
      size: 9
    });
  }
  return null;
};
var List = function List(_a) {
  var items = _a.items,
    icon = _a.icon,
    _b = _a.spacing,
    spacing = _b === void 0 ? "small" : _b,
    _c = _a.direction,
    direction = _c === void 0 ? "vertical" : _c,
    iconColor = _a.iconColor,
    _d = _a.fontSize,
    fontSize = _d === void 0 ? "small" : _d,
    _e = _a.className,
    className = _e === void 0 ? "" : _e;
  var getFontStyles = function getFontStyles(size) {
    if (size === "small") {
      return styles$g.smallFont;
    }
    if (size === "medium") {
      return styles$g.mediumFont;
    }
    return "";
  };
  return React.createElement("ul", {
    className: "".concat(styles$g.list, " ").concat(styles$g[direction], " ").concat(className)
  }, items.map(function (item) {
    return React.createElement("li", {
      key: item,
      className: getFontStyles(fontSize)
    }, icon ? React.createElement("span", {
      className: styles$g["".concat(spacing, "Spacing")]
    }, getIconComponent(icon, iconColor)) : null, item);
  }));
};
var formatPrice = function formatPrice(price, currency) {
  if (!currency || !price) {
    return "";
  }
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: currency
  }).format(price);
};
var getCurrency = function getCurrency(currency) {
  var priceParts = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: currency
  }).formatToParts(1);
  return priceParts[0].value;
};
var getPriceDiscountPercentage = function getPriceDiscountPercentage(currentPrice, oldPrice) {
  return Math.round((oldPrice - currentPrice) * 100 / oldPrice);
};
var styles$f = {
  "badge": "badge-module_badge__kTvKz",
  "badgeSquare": "badge-module_badgeSquare__7l1g4",
  "small": "badge-module_small__X6W34",
  "fadeInDown": "badge-module_fadeInDown__e4o6D",
  "fadeInUp": "badge-module_fadeInUp__0as8r",
  "fadeInDropdown": "badge-module_fadeInDropdown__-gN3W",
  "fadeOutDropdown": "badge-module_fadeOutDropdown__ABtBb"
};
var Badge = function Badge(_a) {
  var label = _a.label,
    _b = _a.bgColor,
    bgColor = _b === void 0 ? "#00B7AB" : _b,
    _c = _a.labelColor,
    labelColor = _c === void 0 ? "#FFFFFF" : _c,
    isSquare = _a.isSquare,
    isSmall = _a.isSmall,
    className = _a.className;
  return React.createElement("div", {
    style: {
      backgroundColor: bgColor,
      color: labelColor
    },
    className: "".concat(styles$f.badge, " \n      ").concat(isSquare ? styles$f.badgeSquare : "", " \n      ").concat(isSmall ? styles$f.small : "", " \n      ").concat(className || "")
  }, label);
};
var styles$e = {
  "addToBasket": "add-to-basket-module_addToBasket__IibuK",
  "pricingPlansHeader": "add-to-basket-module_pricingPlansHeader__foefS",
  "planHeaderIcon": "add-to-basket-module_planHeaderIcon__bd09m",
  "selected": "add-to-basket-module_selected__5eWWO",
  "pricingPlanDetails": "add-to-basket-module_pricingPlanDetails__CoBZu",
  "price": "add-to-basket-module_price__Oj8j8",
  "priceValue": "add-to-basket-module_priceValue__hZh1N",
  "priceCurrency": "add-to-basket-module_priceCurrency__NM7LX",
  "planFrequency": "add-to-basket-module_planFrequency__mUAyC",
  "saveBadge": "add-to-basket-module_saveBadge__V9tQx",
  "usualPrice": "add-to-basket-module_usualPrice__guLwU",
  "planDescription": "add-to-basket-module_planDescription__HZiD6",
  "planBenefits": "add-to-basket-module_planBenefits__a8Epo",
  "addButton": "add-to-basket-module_addButton__5WAou",
  "outOfStock": "add-to-basket-module_outOfStock__hNSNI",
  "fadeInDown": "add-to-basket-module_fadeInDown__52nUF",
  "fadeInUp": "add-to-basket-module_fadeInUp__ymHNy",
  "fadeInDropdown": "add-to-basket-module_fadeInDropdown__PSAHm",
  "fadeOutDropdown": "add-to-basket-module_fadeOutDropdown__oWFh-"
};
var OUT_OF_STOCK = "Back in stock soon";
var getOneOffPlanPrice = function getOneOffPlanPrice(plans) {
  var _a;
  return ((_a = plans.find(function (plan) {
    return !plan.deliveryFrequency;
  })) === null || _a === void 0 ? void 0 : _a.rrpPrice) || 0;
};
// TODO there is a lot of things hard coded, should be updated with the next usage of this component
var AddToBasket = function AddToBasket(_a) {
  var _b = _a.plans,
    plans = _b === void 0 ? [] : _b,
    _c = _a.preselectedPlan,
    preselectedPlan = _c === void 0 ? "subscription" : _c,
    onAddToBasketClick = _a.onAddToBasketClick,
    _d = _a.className,
    className = _d === void 0 ? "" : _d,
    isLoading = _a.isLoading,
    onPlanClick = _a.onPlanClick,
    _e = _a.planDetails,
    planDetails = _e === void 0 ? "30 capsules" : _e,
    ref = _a.ref;
  var _f = useState(),
    selectedPlan = _f[0],
    setSelectedPlan = _f[1];
  var planBenefitsList = useMemo(function () {
    var subscriptionBenefits = ["Pause or cancel at any time", "Free UK delivery"];
    var buyOnceBenefits = ["Free UK delivery on orders over £20"];
    return (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.deliveryFrequency) ? subscriptionBenefits : buyOnceBenefits;
  }, [selectedPlan]);
  useEffect(function () {
    if (!plans) {
      return;
    }
    var productPlan = plans.find(function (plan, index) {
      if (preselectedPlan === "subscription") {
        return plan.deliveryFrequency;
      }
      if (preselectedPlan === "oneOff") {
        return !plan.deliveryFrequency;
      }
      return index === 0;
    });
    setSelectedPlan(productPlan);
  }, [plans, preselectedPlan]);
  var discountLabel = useMemo(function () {
    if (plans.length < 2) {
      // This is only for current use case, this should be updated later
      return "";
    }
    if (!(selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.deliveryFrequency)) {
      // At the moment one off is not discounted, update this later
      return "";
    }
    var discountPercentage = getPriceDiscountPercentage(selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.rrpPrice, getOneOffPlanPrice(plans));
    if (!discountPercentage) {
      return "";
    }
    return "Save ".concat(discountPercentage, "%");
  }, [plans, selectedPlan]);
  if (!plans.length || !selectedPlan) {
    // Should be out of stock or something?
    return null;
  }
  var handlePlanSelection = function handlePlanSelection(plan) {
    setSelectedPlan(plan);
    if (onPlanClick) {
      onPlanClick(plan);
    }
  };
  return React.createElement("div", {
    className: "".concat(styles$e.addToBasket, " ").concat(className),
    ref: ref
  }, React.createElement("div", {
    className: styles$e.pricingPlansHeader
  }, plans.map(function (plan) {
    return React.createElement("div", {
      key: plan.sku,
      className: plan.sku === selectedPlan.sku ? styles$e.selected : "",
      onClick: function onClick() {
        return handlePlanSelection(plan);
      }
    }, plan.deliveryFrequency ? React.createElement(React.Fragment, null, React.createElement("span", {
      className: styles$e.planHeaderIcon
    }, React.createElement(Icon, {
      icon: "subscribe",
      size: 14
    })), "Subscribe") : "Buy once");
  })), React.createElement("div", {
    className: styles$e.pricingPlanDetails
  }, React.createElement("div", {
    className: styles$e.price
  }, React.createElement("div", {
    className: styles$e.priceCurrency
  }, getCurrency(selectedPlan.currency)), React.createElement("div", {
    className: styles$e.priceValue
  }, selectedPlan.rrpPrice), selectedPlan.deliveryFrequency ? React.createElement("div", {
    className: styles$e.planFrequency
  }, "/mo") : null, selectedPlan.deliveryFrequency && discountLabel ? React.createElement(Badge, {
    label: discountLabel
  }) : null), selectedPlan.deliveryFrequency && discountLabel ? React.createElement("div", {
    className: styles$e.usualPrice
  }, "Normally", " ", formatPrice(getOneOffPlanPrice(plans), selectedPlan.currency)) : null, React.createElement("div", {
    className: styles$e.planDescription
  }, selectedPlan.deliveryFrequency ? "".concat(planDetails, " delivered monthly") : planDetails), React.createElement("div", {
    className: styles$e.planBenefits
  }, React.createElement(List, {
    items: planBenefitsList,
    direction: "vertical",
    icon: "check",
    iconColor: "#6F6F6F"
  })), selectedPlan.purchasable ? React.createElement(Button, {
    title: "Add to basket",
    primary: true,
    onClick: function onClick() {
      return onAddToBasketClick(selectedPlan.sku);
    },
    className: styles$e.addButton,
    loading: isLoading
  }) : React.createElement("h4", {
    className: styles$e.outOfStock
  }, OUT_OF_STOCK)));
};
var styles$d = {
  "componentContent": "add-to-basket-offer-module_componentContent__AqXtO",
  "upsellHeader": "add-to-basket-offer-module_upsellHeader__zmNBi",
  "contentWrapper": "add-to-basket-offer-module_contentWrapper__tWIa-",
  "upsellOption": "add-to-basket-offer-module_upsellOption__QUMdH",
  "badgeWrapper": "add-to-basket-offer-module_badgeWrapper__OWCjS",
  "divider": "add-to-basket-offer-module_divider__WxIfF",
  "radioContainer": "add-to-basket-offer-module_radioContainer__r5u8i",
  "radioCheckmark": "add-to-basket-offer-module_radioCheckmark__I7p01",
  "radioLabel": "add-to-basket-offer-module_radioLabel__-mUVv",
  "optionTitle": "add-to-basket-offer-module_optionTitle__L0nPW",
  "optionPrice": "add-to-basket-offer-module_optionPrice__DguCz add-to-basket-offer-module_optionTitle__L0nPW",
  "checkmark": "add-to-basket-offer-module_checkmark__3OJ2m",
  "upsellDescription": "add-to-basket-offer-module_upsellDescription__rg8KG",
  "upsellFeaturesList": "add-to-basket-offer-module_upsellFeaturesList__KalKR",
  "fadeInDown": "add-to-basket-offer-module_fadeInDown__HMcvl",
  "fadeInUp": "add-to-basket-offer-module_fadeInUp__XC1ST",
  "fadeInDropdown": "add-to-basket-offer-module_fadeInDropdown__Boh0f",
  "fadeOutDropdown": "add-to-basket-offer-module_fadeOutDropdown__-OtaU"
};
var AddToBasket30Percent3MonthsOffer = function AddToBasket30Percent3MonthsOffer(_a) {
  var _b;
  var plans = _a.plans,
    onAddToBasketClick = _a.onAddToBasketClick,
    loading = _a.loading,
    getPrice = _a.getPrice;
  var _c = useState("4ppOnly"),
    selectedOption = _c[0],
    setSelectedOption = _c[1];
  return React.createElement("div", {
    className: styles$d.componentContent
  }, React.createElement("div", {
    className: styles$d.contentWrapper
  }, React.createElement("div", {
    className: styles$d.upsellHeader
  }, "FREE UK DELIVERY"), React.createElement("div", {
    className: styles$d.upsellOption,
    onClick: function onClick() {
      return setSelectedOption("4ppOnly");
    }
  }, React.createElement("label", {
    className: styles$d.radioContainer
  }, React.createElement("input", {
    type: "radio",
    checked: selectedOption === "4ppOnly"
  }), React.createElement("span", {
    className: styles$d.radioCheckmark
  }), React.createElement("div", {
    className: styles$d.radioLabel
  }, React.createElement("div", {
    className: styles$d.optionTitle
  }, "Monthly subscription"), React.createElement("div", {
    className: styles$d.optionPrice
  }, React.createElement("span", null, React.createElement("b", null, (_b = plans[0]) === null || _b === void 0 ? void 0 : _b.rrpPriceLabel), "/mo")))), React.createElement("ul", {
    className: styles$d.upsellFeaturesList
  }, React.createElement("li", null, React.createElement("i", null, React.createElement(Icon, {
    icon: "check",
    color: "#6F6F6F",
    size: "10"
  })), React.createElement("span", null, "Paid monthly")), React.createElement("li", null, React.createElement("i", null, React.createElement(Icon, {
    icon: "check",
    color: "#6F6F6F",
    size: "10"
  })), React.createElement("span", null, "Pause or cancel at any time")))), React.createElement("hr", {
    className: styles$d.divider
  }), React.createElement("div", {
    className: styles$d.upsellOption,
    onClick: function onClick() {
      return setSelectedOption("offer");
    }
  }, React.createElement("div", {
    className: styles$d.badgeWrapper
  }, React.createElement(Badge, {
    isSmall: true,
    label: "OFFER"
  })), React.createElement("label", {
    className: styles$d.radioContainer
  }, React.createElement("input", {
    type: "radio",
    checked: selectedOption === "offer"
  }), React.createElement("span", {
    className: styles$d.radioCheckmark
  }), React.createElement("div", {
    className: styles$d.radioLabel
  }, React.createElement("div", {
    className: styles$d.optionTitle
  }, "30% off first 3 months"), React.createElement("div", {
    className: styles$d.optionPrice
  }, React.createElement("b", null, getPrice("thirtyPercentOff")), "/mo"))), React.createElement("ul", {
    className: styles$d.upsellFeaturesList
  }, React.createElement("li", null, React.createElement("i", null, React.createElement(Icon, {
    icon: "check",
    color: "#6F6F6F",
    size: "10"
  })), React.createElement("span", null, "Paid monthly")), React.createElement("li", null, React.createElement("i", null, React.createElement(Icon, {
    icon: "check",
    color: "#6F6F6F",
    size: "10"
  })), React.createElement("span", null, "Save ", getPrice("roundedSavings"), " on first 3 packs")), React.createElement("li", null, React.createElement("i", null, React.createElement(Icon, {
    icon: "check",
    color: "#6F6F6F",
    size: "10"
  })), React.createElement("span", null, "Recommended: Give it 3 months ", React.createElement("br", null), " to feel the full impact"))))), React.createElement(Button, {
    primary: true,
    onClick: function onClick() {
      return onAddToBasketClick(selectedOption);
    },
    title: "Add to basket",
    loading: loading
  }));
};
var styles$c = {
  "container": "section-module_container__UJbK6",
  "section": "section-module_section__WQ44Z",
  "sectionTitle": "section-module_sectionTitle__hdGwU",
  "sectionSubtitle": "section-module_sectionSubtitle__8FWOC",
  "fadeInDown": "section-module_fadeInDown__DWv0s",
  "fadeInUp": "section-module_fadeInUp__2RsnB",
  "fadeInDropdown": "section-module_fadeInDropdown__kvYnt",
  "fadeOutDropdown": "section-module_fadeOutDropdown__c8HUj"
};
var Section = function Section(_a) {
  var title = _a.title,
    subTitle = _a.subTitle,
    className = _a.className,
    _b = _a.backgroundColor,
    backgroundColor = _b === void 0 ? "#FFFFFF" : _b,
    children = _a.children;
  var classNames = "".concat(styles$c.section, " ").concat(className ? className : "");
  return React.createElement("section", {
    style: {
      backgroundColor: backgroundColor
    },
    className: classNames
  }, React.createElement("div", {
    className: styles$c.container
  }, title ? React.createElement("h2", {
    className: styles$c.sectionTitle
  }, title) : null, subTitle ? React.createElement("p", {
    className: styles$c.sectionSubtitle
  }, subTitle) : null, children));
};
var styles$b = {
  "addToBacketSticky": "add-to-basket-sticky-module_addToBacketSticky__fAZpz",
  "price": "add-to-basket-sticky-module_price__gDWgH",
  "fadeInDown": "add-to-basket-sticky-module_fadeInDown__HAOT0",
  "fadeInUp": "add-to-basket-sticky-module_fadeInUp__MV6Kf",
  "fadeInDropdown": "add-to-basket-sticky-module_fadeInDropdown__ShsTK",
  "fadeOutDropdown": "add-to-basket-sticky-module_fadeOutDropdown__u5qO2"
};
var AddToBacketSticky = function AddToBacketSticky(_a) {
  var plan = _a.plan,
    onAddToBasketClick = _a.onAddToBasketClick,
    _b = _a.className,
    className = _b === void 0 ? "" : _b,
    isLoading = _a.isLoading;
  if (!plan.purchasable) {
    return null;
  }
  return React.createElement("div", {
    className: "".concat(styles$b.addToBacketSticky, " ").concat(className)
  }, React.createElement("span", {
    className: styles$b.price
  }, plan.offerPriceLabel || plan.rrpPriceLabel), React.createElement(Button, {
    primary: true,
    title: "Add to basket",
    onClick: function onClick() {
      return onAddToBasketClick(plan.sku);
    },
    loading: isLoading
  }));
};
var styles$a = {
  "slider": "partners-slider-module_slider__teJQI",
  "partnerLogo": "partners-slider-module_partnerLogo__E0ZKb",
  "swiperContainer": "partners-slider-module_swiperContainer__59m6h",
  "swiperContent": "partners-slider-module_swiperContent__njxGW",
  "slidePicture": "partners-slider-module_slidePicture__NLcKx",
  "leftArrowWrapper": "partners-slider-module_leftArrowWrapper__DzbBr",
  "rightArrowWrapper": "partners-slider-module_rightArrowWrapper__EE-ky",
  "fadeInDown": "partners-slider-module_fadeInDown__GxUnV",
  "fadeInUp": "partners-slider-module_fadeInUp__98PyU",
  "fadeInDropdown": "partners-slider-module_fadeInDropdown__tpuFD",
  "fadeOutDropdown": "partners-slider-module_fadeOutDropdown__CG9Wk"
};
var DEFAULT_BACKGROUND_COLOR = "#fef6dc";
var PartnersSliderComponent = function PartnersSliderComponent(_a) {
  var _b;
  var partners = _a.partners,
    isWhite = _a.isWhite,
    backgroundColor = _a.backgroundColor,
    className = _a.className;
  var _c = useState(),
    swiperInstance = _c[0],
    setSwiperInstance = _c[1];
  var getBackgroundColor = function getBackgroundColor() {
    if (isWhite) return "#ffffff";
    if (backgroundColor) return backgroundColor;
    return DEFAULT_BACKGROUND_COLOR;
  };
  var ArrowPrev = function ArrowPrev() {
    return React.createElement("div", {
      className: styles$a.leftArrowWrapper,
      onClick: function onClick() {
        return swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.slidePrev();
      }
    }, React.createElement("img", {
      alt: "swiper arrow left",
      src: img$5,
      width: 20,
      className: styles$a.arrowLeft
    }));
  };
  var ArrowNext = function ArrowNext() {
    return React.createElement("div", {
      className: styles$a.rightArrowWrapper,
      onClick: function onClick() {
        return swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.slideNext();
      }
    }, React.createElement("img", {
      alt: "swiper arrow right",
      src: img$5,
      width: 20,
      className: styles$a.arrowRight
    }));
  };
  return React.createElement("section", {
    className: "".concat(styles$a.slider, " ").concat(className ? className : ""),
    style: {
      backgroundColor: getBackgroundColor()
    }
  }, React.createElement("p", null, partners.partners_header), React.createElement("div", {
    className: styles$a.swiperContainer
  }, React.createElement("div", {
    className: styles$a.swiperContent
  }, React.createElement(ArrowPrev, null), React.createElement(SwiperComponent, {
    onInit: function onInit(swiper) {
      return setSwiperInstance(swiper);
    },
    pagination: false,
    spaceBetween: 16,
    slideToClickedSlide: true,
    breakpoints: {
      320: {
        slidesPerView: 1
      },
      375: {
        slidesPerView: 3
      },
      768: {
        slidesPerView: 4
      },
      1024: {
        slidesPerView: 3.8
      },
      1366: {
        slidesPerView: 5
      }
    }
  }, (_b = partners === null || partners === void 0 ? void 0 : partners.partner_logos) === null || _b === void 0 ? void 0 : _b.map(function (item, index) {
    return React.createElement("div", {
      key: index,
      className: styles$a.slidePicture
    }, React.createElement(Image, {
      className: styles$a.partnerLogo,
      filename: item.image_hash,
      width: 500
    }));
  })), React.createElement(ArrowNext, null))));
};
var styles$9 = {
  "navContainer": "nav-desktop-module_navContainer__zal1h",
  "fadeInDown": "nav-desktop-module_fadeInDown__mMMEh",
  "fadeInUp": "nav-desktop-module_fadeInUp__a0T5H",
  "fadeInDropdown": "nav-desktop-module_fadeInDropdown__oTplW",
  "fadeOutDropdown": "nav-desktop-module_fadeOutDropdown__qVX-P"
};
var NavDesktop = function NavDesktop(_a) {
  var logo = _a.logo,
    letfNavSection = _a.letfNavSection,
    rightNavSection = _a.rightNavSection;
  return React.createElement("nav", {
    className: styles$9.navDesktop
  }, React.createElement("ul", {
    className: styles$9.navContainer
  }, letfNavSection, logo, rightNavSection));
};
var styles$8 = {
  "navMobile": "nav-mobile-module_navMobile__OPLkV",
  "navMobileOpen": "nav-mobile-module_navMobileOpen__QpRLf",
  "hamburgerMenu": "nav-mobile-module_hamburgerMenu__WMZbz",
  "navContainer": "nav-mobile-module_navContainer__cAe3L",
  "navToggle": "nav-mobile-module_navToggle__8RBFK",
  "navToggleInner": "nav-mobile-module_navToggleInner__dGuf2",
  "navToggleOpen": "nav-mobile-module_navToggleOpen__SNONa nav-mobile-module_navToggle__8RBFK",
  "fadeInDown": "nav-mobile-module_fadeInDown__kb3vG",
  "fadeInUp": "nav-mobile-module_fadeInUp__XCrsV",
  "fadeInDropdown": "nav-mobile-module_fadeInDropdown__RvQFZ",
  "fadeOutDropdown": "nav-mobile-module_fadeOutDropdown__eY-De"
};
var NavMobile = function NavMobile(_a) {
  var logo = _a.logo,
    sidebar = _a.sidebar,
    setSidebar = _a.setSidebar,
    rightNavSectionMobile = _a.rightNavSectionMobile;
  var handleToggle = function handleToggle() {
    setSidebar("navigation");
  };
  return React.createElement("nav", {
    className: styles$8.navMobile
  }, React.createElement("ul", {
    className: styles$8.navContainer
  }, React.createElement("li", {
    className: "".concat(styles$8.hamburgerMenu, " ").concat(sidebar ? styles$8.navToggleOpen : styles$8.navToggle)
  }, React.createElement("div", {
    onClick: handleToggle
  }, React.createElement("span", {
    className: styles$8.navToggleInner
  }))), logo, rightNavSectionMobile));
};
var styles$7 = {
  "navLogo": "nav-logo-module_navLogo__6dkKx"
};
var NavLogo = function NavLogo(_a) {
  var navigateTo = _a.navigateTo;
  return React.createElement("li", {
    className: styles$7.navLogo,
    onClick: function onClick() {
      return navigateTo("/");
    }
  }, React.createElement(Icon, {
    icon: "logo",
    size: 60,
    "data-testid": "vitl-logo"
  }));
};
var useClickedOutside = function useClickedOutside(ref, callback) {
  var handleClickOutside = function handleClickOutside(event) {
    if ((ref === null || ref === void 0 ? void 0 : ref.current) && !ref.current.contains(event.target)) {
      callback();
    }
  };
  useEffect(function () {
    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });
};
var styles$6 = {
  "dropdownWrapper": "dropdown-module_dropdownWrapper__OYhdy",
  "dropdownToggle": "dropdown-module_dropdownToggle__nTxP3",
  "dropdown": "dropdown-module_dropdown__G8lk1",
  "dropdownOpen": "dropdown-module_dropdownOpen__SbzKN",
  "fadeInDropdown": "dropdown-module_fadeInDropdown__u-7ew",
  "fadeInDown": "dropdown-module_fadeInDown__zWq30",
  "fadeInUp": "dropdown-module_fadeInUp__YkFMq",
  "fadeOutDropdown": "dropdown-module_fadeOutDropdown__Jm5nW"
};
var Dropdown = function Dropdown(_a) {
  var options = _a.options,
    dropdownClass = _a.dropdownClass,
    location = _a.location,
    children = _a.children;
  var elementRef = useRef(null);
  var _b = useState(false),
    dropdownIsOpen = _b[0],
    setDropdownIsOpen = _b[1];
  var outsideElementClicked = function outsideElementClicked() {
    if (dropdownIsOpen) {
      setDropdownIsOpen(false);
    }
  };
  useClickedOutside(elementRef, outsideElementClicked);
  useEffect(function () {
    setDropdownIsOpen(false);
  }, [location]);
  return React.createElement("div", {
    className: styles$6.dropdownWrapper
  }, React.createElement("div", {
    className: styles$6.dropdownToggle,
    onClick: function onClick() {
      return setDropdownIsOpen(!dropdownIsOpen);
    }
  }, children), React.createElement("ul", {
    ref: elementRef,
    className: "".concat(dropdownIsOpen ? styles$6.dropdownOpen : styles$6.dropdown, " ").concat(dropdownClass)
  }, options));
};
var styles$5 = {
  "arrow": "desktop-nav-sections-module_arrow__4T8gx",
  "side": "desktop-nav-sections-module_side__YWdkv",
  "navLink": "desktop-nav-sections-module_navLink__v06-u",
  "navLinkInner": "desktop-nav-sections-module_navLinkInner__s1Rk6",
  "search": "desktop-nav-sections-module_search__fYpJo",
  "button": "desktop-nav-sections-module_button__OCdx4",
  "accountDropdown": "desktop-nav-sections-module_accountDropdown__tHVCq",
  "mobileView": "desktop-nav-sections-module_mobileView__e0XiU",
  "fadeInDown": "desktop-nav-sections-module_fadeInDown__wGujF",
  "fadeInUp": "desktop-nav-sections-module_fadeInUp__HK6er",
  "fadeInDropdown": "desktop-nav-sections-module_fadeInDropdown__IjBYf",
  "fadeOutDropdown": "desktop-nav-sections-module_fadeOutDropdown__hLVho"
};
var img$1 = "data:image/svg+xml,%3csvg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 39.39 34.48'%3e%3cdefs%3e%3cstyle%3e.cls-1%2c.cls-2%7bfill:none%3bstroke:%23333%3bstroke-width:2.8px%3b%7d.cls-1%7bstroke-miterlimit:10%3b%7d.cls-2%7bstroke-linecap:round%3bstroke-linejoin:round%3b%7d%3c/style%3e%3c/defs%3e%3cpath class='cls-1' d='M5.68%2c32.68a1.59%2c1.59%2c0%2c0%2c1-1.36-2.11%2c21.35%2c21.35%2c0%2c0%2c1%2c3.92-7.33c4.26-5.3%2c11.29-7%2c17.44-3.44a13.39%2c13.39%2c0%2c0%2c1%2c2.69%2c2.14l.09.09a14.33%2c14.33%2c0%2c0%2c1%2c1%2c1.16%2c21.38%2c21.38%2c0%2c0%2c1%2c3.94%2c7.38%2c1.58%2c1.58%2c0%2c0%2c1-1.36%2c2.11Z'/%3e%3ccircle class='cls-2' cx='18.88' cy='8.9' r='7.09'/%3e%3c/svg%3e";
var RightNavSection = function RightNavSection(_a) {
  var isPrivateRoute = _a.isPrivateRoute,
    accountDropdown = _a.accountDropdown,
    cartButton = _a.cartButton,
    search = _a.search,
    location = _a.location;
  return React.createElement("div", {
    className: styles$5.side
  }, React.createElement("li", {
    className: "".concat(styles$5.navLink, "  ").concat(styles$5.search)
  }, search), React.createElement("li", null, React.createElement(Dropdown, {
    options: accountDropdown,
    location: location,
    dropdownClass: "".concat(isPrivateRoute ? styles$5.accountDropdown : "", " ").concat(styles$5.mobileView)
  }, React.createElement("div", {
    className: styles$5.navLink,
    "data-testid": "user-section-in-menu"
  }, React.createElement("img", {
    src: img$1,
    width: 21,
    height: 21,
    alt: ""
  }), React.createElement("span", {
    className: styles$5.arrow
  })))), React.createElement("li", {
    "data-test-id": "cart"
  }, cartButton));
};
var LeftNavSection = function LeftNavSection(_a) {
  var showStickyNav = _a.showStickyNav,
    showShopModal = _a.showShopModal,
    isLoggedIn = _a.isLoggedIn,
    rootUrl = _a.rootUrl,
    isPrivateRoute = _a.isPrivateRoute,
    resultDropdown = _a.resultDropdown,
    learnDropdown = _a.learnDropdown,
    location = _a.location,
    navigateTo = _a.navigateTo;
  var onNavigateClick = function onNavigateClick(e, path) {
    e.preventDefault();
    navigateTo(path);
  };
  if (isPrivateRoute && isLoggedIn) {
    return React.createElement("div", {
      className: styles$5.side
    }, React.createElement("li", null, React.createElement("a", {
      onClick: function onClick(e) {
        return onNavigateClick(e, "/shop");
      },
      href: "".concat(rootUrl, "/shop"),
      "aria-label": "Go to shop",
      title: "Go to Vitl shop",
      className: styles$5.navLink
    }, React.createElement("span", {
      className: styles$5.navLinkInner
    }, "Shop"))), React.createElement("li", null, React.createElement("a", {
      onClick: function onClick(e) {
        return onNavigateClick(e, "/account/dashboard");
      },
      href: "".concat(rootUrl, "/account/dashboard"),
      "aria-label": "My Vitl",
      title: "My Vitl",
      className: styles$5.navLink
    }, React.createElement("span", {
      className: styles$5.navLinkInner
    }, "My Vitl"))), React.createElement("li", null, React.createElement(Dropdown, {
      options: resultDropdown,
      location: location
    }, React.createElement("span", {
      className: styles$5.navLink
    }, "View Results", React.createElement("span", {
      className: styles$5.arrow
    })))));
  }
  return React.createElement("div", {
    className: styles$5.side
  }, React.createElement("li", null, React.createElement("a", {
    onClick: function onClick(e) {
      return onNavigateClick(e, "/shop");
    },
    href: "".concat(rootUrl, "/shop"),
    "aria-label": "Go to shop",
    title: "Go to Vitl shop",
    className: styles$5.navLink
  }, React.createElement("span", {
    className: styles$5.navLinkInner
  }, "Shop"))), React.createElement("li", null, React.createElement(Dropdown, {
    options: learnDropdown,
    location: location
  }, React.createElement("span", {
    className: styles$5.navLink
  }, "Learn", React.createElement("span", {
    className: styles$5.arrow
  })))), React.createElement("li", null, React.createElement("a", {
    onClick: function onClick(e) {
      return onNavigateClick(e, "/consultation");
    },
    href: "".concat(rootUrl, "/consultation"),
    "aria-label": "Take Health Quiz",
    title: "Take Health Quiz",
    className: styles$5.navLink
  }, React.createElement("span", {
    className: "".concat(showStickyNav && !showShopModal ? styles$5.button : styles$5.navLinkInner)
  }, "Take Health Quiz"))));
};
var isSSR = typeof window === "undefined";
var LEARN_DROPDOWN = [{
  actionValue: "/about",
  label: "About us"
}, {
  actionValue: "".concat(process.env.GATSBY_HOST_NAME || "", "/blog"),
  label: "Blog"
}, {
  actionValue: "/science",
  label: "Science"
}, {
  actionValue: "/contact",
  label: "FAQs"
}];
var RESULT_DROPDOWN = [{
  label: "Health Quiz",
  actionValue: "/account/result"
}, {
  label: "Blood Test",
  actionValue: "/account/result/blood"
}, {
  label: "DNA Test",
  actionValue: "/account/result/dna"
}];
var ACCOUNT_DROPDOWN = {
  notLogedIn: [{
    actionValue: "/account/signin",
    label: " Sign In"
  }, {
    actionValue: "/kit",
    label: "Register Kit"
  }],
  loggedIn: [{
    actionValue: "/account",
    label: "My Account"
  }, {
    actionValue: "/kit",
    label: "Register Kit"
  }, {
    actionValue: "/account/referral",
    label: "Refer a Friend"
  }, {
    actionValue: "/contact",
    label: "Contact Us"
  }, {
    actionValue: "logout",
    label: "Sign out",
    actionType: "callback"
  }],
  dashboard: [{
    label: "Personal Details",
    actionType: "navigate",
    actionValue: "/account/details",
    hasDivider: true
  }, {
    label: "Orders",
    actionType: "navigate",
    actionValue: "/account/orders",
    hasDivider: false
  }, {
    label: "Subscriptions",
    actionType: "navigate",
    actionValue: "/account/subscriptions",
    hasDivider: false
  }, {
    label: "Payment Methods",
    actionType: "navigate",
    actionValue: "/account/payment",
    hasDivider: false
  }, {
    label: "Refer a friend",
    actionType: "navigate",
    actionValue: "/account/referral",
    hasDivider: false
  }, {
    label: "Register Kit",
    actionType: "navigate",
    actionValue: "/kit",
    hasDivider: true
  }, {
    label: "Logout",
    actionType: "callback",
    actionValue: "logout",
    hasDivider: false
  }]
};
var styles$4 = {
  "navLink": "dropdown-items-module_navLink__cMH8h",
  "navLinkInner": "dropdown-items-module_navLinkInner__s-9Ia",
  "divider": "dropdown-items-module_divider__iteiU",
  "fadeInDown": "dropdown-items-module_fadeInDown__naONd",
  "fadeInUp": "dropdown-items-module_fadeInUp__gvl3y",
  "fadeInDropdown": "dropdown-items-module_fadeInDropdown__Ayrjs",
  "fadeOutDropdown": "dropdown-items-module_fadeOutDropdown__sIeye"
};
var LearnDropdown = function LearnDropdown(_a) {
  var rootUrl = _a.rootUrl,
    navigateTo = _a.navigateTo;
  var onNavigateClick = function onNavigateClick(e, path) {
    e.preventDefault();
    navigateTo(path);
  };
  return React.createElement("div", null, LEARN_DROPDOWN.map(function (item) {
    return item.actionValue.startsWith("/") ? React.createElement("a", {
      key: item.actionValue,
      onClick: function onClick(e) {
        return onNavigateClick(e, item.actionValue);
      },
      href: "".concat(rootUrl).concat(item.actionValue),
      "aria-label": item.label,
      title: item.label,
      className: styles$4.navLink
    }, React.createElement("span", {
      className: styles$4.navLinkInner
    }, item.label)) : React.createElement("a", {
      key: item.actionValue,
      href: item.actionValue,
      "aria-label": item.label,
      title: item.label,
      className: styles$4.navLink
    }, React.createElement("span", {
      className: styles$4.navLinkInner
    }, item.label));
  }));
};
var ResultDropdown = function ResultDropdown(_a) {
  var rootUrl = _a.rootUrl,
    navigateTo = _a.navigateTo;
  var onNavigateClick = function onNavigateClick(e, path) {
    e.preventDefault();
    navigateTo(path);
  };
  return React.createElement("div", null, RESULT_DROPDOWN.map(function (item) {
    return React.createElement("a", {
      key: item.actionValue,
      onClick: function onClick(e) {
        return onNavigateClick(e, item.actionValue);
      },
      href: "".concat(rootUrl).concat(item.actionValue),
      "aria-label": item.label,
      title: item.label,
      className: styles$4.navLink
    }, React.createElement("span", {
      className: styles$4.navLinkInner
    }, item.label));
  }));
};
var AccountDropdown = function AccountDropdown(_a) {
  var isPrivateRoute = _a.isPrivateRoute,
    isLoggedIn = _a.isLoggedIn,
    rootUrl = _a.rootUrl,
    navigateTo = _a.navigateTo,
    setShowAddCoupon = _a.setShowAddCoupon,
    logoutUser = _a.logoutUser;
  var handleAction = function handleAction(action) {
    switch (action) {
      case "addCoupon":
        setShowAddCoupon(true);
        break;
      case "logout":
        logoutUser();
    }
  };
  var onNavigateClick = function onNavigateClick(e, path) {
    e.preventDefault();
    navigateTo(path);
  };
  var mapAccountRoutes = function mapAccountRoutes(routes) {
    return React.createElement("div", null, routes.map(function (item) {
      if (item.actionType === "callback") {
        return React.createElement("span", {
          className: "".concat(styles$4.navLink, " ").concat(item.hasDivider ? styles$4.divider : ""),
          onClick: function onClick() {
            return handleAction(item.actionValue);
          }
        }, React.createElement("span", {
          className: styles$4.navLinkInner
        }, item.label));
      }
      return React.createElement("a", {
        key: item.actionValue,
        onClick: function onClick(e) {
          return onNavigateClick(e, item.actionValue);
        },
        href: "".concat(rootUrl).concat(item.actionValue),
        "aria-label": item.label,
        title: item.label,
        className: "".concat(styles$4.navLink, " ").concat(item.hasDivider ? styles$4.divider : "")
      }, React.createElement("span", {
        className: styles$4.navLinkInner
      }, item.label));
    }));
  };
  if (isLoggedIn) {
    if (isPrivateRoute) return mapAccountRoutes(ACCOUNT_DROPDOWN.dashboard);
    return mapAccountRoutes(ACCOUNT_DROPDOWN.loggedIn);
  }
  return React.createElement("div", null, ACCOUNT_DROPDOWN.notLogedIn.map(function (item) {
    return React.createElement("a", {
      key: item.actionValue,
      onClick: function onClick(e) {
        return onNavigateClick(e, item.actionValue);
      },
      href: "".concat(rootUrl).concat(item.actionValue),
      "aria-label": item.label,
      title: item.label,
      className: styles$4.navLink
    }, React.createElement("span", {
      className: styles$4.navLinkInner
    }, item.label));
  }));
};
var styles$3 = {
  "cart": "header-cart-button-module_cart__vv1R-",
  "cartQty": "header-cart-button-module_cartQty__tQvd9",
  "fadeInDown": "header-cart-button-module_fadeInDown__RSe--",
  "fadeInUp": "header-cart-button-module_fadeInUp__EPwrd",
  "fadeInDropdown": "header-cart-button-module_fadeInDropdown__iKckE",
  "fadeOutDropdown": "header-cart-button-module_fadeOutDropdown__jkI0q"
};
var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 39.39 34.48'%3e%3cdefs%3e%3cstyle%3e.cls-1%7bfill:none%3bstroke:%23333%3bstroke-linecap:round%3bstroke-linejoin:round%3bstroke-width:2.87px%3b%7d.cls-2%7bfill:%23333%3b%7d%3c/style%3e%3c/defs%3e%3cg id='Layer_2' data-name='Layer 2'%3e%3cg id='Layer_1-2' data-name='Layer 1'%3e%3cpolyline class='cls-1' points='1.44 1.44 7.4 1.44 8.26 6.51 11.12 25.88 35.56 25.88 37.95 6.5 13.24 6.5'/%3e%3ccircle class='cls-2' cx='15.82' cy='31.89' r='2.59'/%3e%3ccircle class='cls-2' cx='30.08' cy='31.89' r='2.59'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";
var CartButton = function CartButton(_a) {
  var _b;
  var showCart = _a.showCart,
    setShowCart = _a.setShowCart,
    dataCart = _a.dataCart,
    loadingCart = _a.loadingCart,
    shouldClearCart = _a.shouldClearCart;
  if (loadingCart || !(dataCart === null || dataCart === void 0 ? void 0 : dataCart.content)) return null;
  return React.createElement(React.Fragment, null, React.createElement("button", {
    className: styles$3.cart,
    type: "button",
    onClick: function onClick() {
      return setShowCart(!showCart);
    }
  }, React.createElement("img", {
    src: img,
    alt: "Basket"
  }), ((_b = dataCart.content) === null || _b === void 0 ? void 0 : _b.itemCount) > 0 && !shouldClearCart() && React.createElement("span", {
    className: styles$3.cartQty
  }, dataCart.content.itemCount)));
};
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
var propTypesExports = {};
var propTypes = {
  get exports() {
    return propTypesExports;
  },
  set exports(v) {
    propTypesExports = v;
  }
};
var reactIsExports = {};
var reactIs = {
  get exports() {
    return reactIsExports;
  },
  set exports(v) {
    reactIsExports = v;
  }
};
var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w = b ? Symbol.for("react.fundamental") : 60117,
    x = b ? Symbol.for("react.responder") : 60118,
    y = b ? Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function (a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function (a) {
    return z(a) === k;
  };
  reactIs_production_min.isContextProvider = function (a) {
    return z(a) === h;
  };
  reactIs_production_min.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function (a) {
    return z(a) === n;
  };
  reactIs_production_min.isFragment = function (a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function (a) {
    return z(a) === t;
  };
  reactIs_production_min.isMemo = function (a) {
    return z(a) === r;
  };
  reactIs_production_min.isPortal = function (a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function (a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function (a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function (a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}
var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function () {
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' ||
        // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode

      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIsExports;
  hasRequiredReactIs = 1;
  (function (module) {
    if (process.env.NODE_ENV === 'production') {
      module.exports = requireReactIs_production_min();
    } else {
      module.exports = requireReactIs_development();
    }
  })(reactIs);
  return reactIsExports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  /* eslint-disable no-unused-vars */
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }

      // Detect buggy property enumeration order in older V8 versions.

      // https://bugs.chromium.org/p/v8/issues/detail?id=4118
      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
      test1[5] = 'de';
      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });
      if (order2.join('') !== '0123456789') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }
      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);
      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function printWarning() {};
  if (process.env.NODE_ENV !== 'production') {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has = requireHas();
    printWarning = function printWarning(text) {
      var message = 'Warning: ' + text;
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {/**/}
    };
  }

  /**
   * Assert that the values match with the type specs.
   * Error messages are memorized and will only be shown once.
   *
   * @param {object} typeSpecs Map of name to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @param {string} componentName Name of the component for error messages.
   * @param {?Function} getStack Returns the component stack.
   * @private
   */
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== 'production') {
      for (var typeSpecName in typeSpecs) {
        if (has(typeSpecs, typeSpecName)) {
          var error;
          // Prop type validation may throw. In case they do, we don't want to
          // fail the render phase where it didn't fail before. So we log it.
          // After these have been cleaned up, we'll let them throw.
          try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
              var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
              err.name = 'Invariant Violation';
              throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
          }
        }
      }
    }
  }

  /**
   * Resets warning cache when testing.
   *
   * @private
   */
  checkPropTypes.resetWarningCache = function () {
    if (process.env.NODE_ENV !== 'production') {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function printWarning() {};
  if (process.env.NODE_ENV !== 'production') {
    printWarning = function printWarning(text) {
      var message = 'Warning: ' + text;
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
    /* global Symbol */
    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

    /**
     * Returns the iterator method function contained on the iterable object.
     *
     * Be sure to invoke the function with the iterable as context:
     *
     *     var iteratorFn = getIteratorFn(myIterable);
     *     if (iteratorFn) {
     *       var iterator = iteratorFn.call(myIterable);
     *       ...
     *     }
     *
     * @param {?object} maybeIterable
     * @return {?function}
     */
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }

    /**
     * Collection of methods that allow declaration and validation of props that are
     * supplied to React components. Example usage:
     *
     *   var Props = require('ReactPropTypes');
     *   var MyArticle = React.createClass({
     *     propTypes: {
     *       // An optional string prop named "description".
     *       description: Props.string,
     *
     *       // A required enum prop named "category".
     *       category: Props.oneOf(['News','Photos']).isRequired,
     *
     *       // A prop named "dialog" that requires an instance of Dialog.
     *       dialog: Props.instanceOf(Dialog).isRequired
     *     },
     *     render: function() { ... }
     *   });
     *
     * A more formal specification of how these methods are used:
     *
     *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
     *   decl := ReactPropTypes.{type}(.isRequired)?
     *
     * Each and every declaration produces a function with the same signature. This
     * allows the creation of custom validation functions. For example:
     *
     *  var MyLink = React.createClass({
     *    propTypes: {
     *      // An optional string or URI prop named "href".
     *      href: function(props, propName, componentName) {
     *        var propValue = props[propName];
     *        if (propValue != null && typeof propValue !== 'string' &&
     *            !(propValue instanceof URI)) {
     *          return new Error(
     *            'Expected a string or an URI for ' + propName + ' in ' +
     *            componentName
     *          );
     *        }
     *      }
     *    },
     *    render: function() {...}
     *  });
     *
     * @internal
     */

    var ANONYMOUS = '<<anonymous>>';

    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker('array'),
      bigint: createPrimitiveTypeChecker('bigint'),
      bool: createPrimitiveTypeChecker('boolean'),
      func: createPrimitiveTypeChecker('function'),
      number: createPrimitiveTypeChecker('number'),
      object: createPrimitiveTypeChecker('object'),
      string: createPrimitiveTypeChecker('string'),
      symbol: createPrimitiveTypeChecker('symbol'),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };

    /**
     * inlined Object.is polyfill to avoid requiring consumers ship their own
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
     */
    /*eslint-disable no-self-compare*/
    function is(x, y) {
      // SameValue algorithm
      if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
      } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
      }
    }
    /*eslint-enable no-self-compare*/

    /**
     * We use an Error-like object for backward compatibility as people may call
     * PropTypes directly and inspect their output. However, we don't use real
     * Errors anymore. We don't inspect their stack anyway, and creating them
     * is prohibitively expensive if they are created too often, such as what
     * happens in oneOfType() for any type before the one that matched.
     */
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && typeof data === 'object' ? data : {};
      this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== 'production') {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            // New behavior only for users of `prop-types` package
            var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
            err.name = 'Invariant Violation';
            throw err;
          } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
            // Old behavior for people using React.PropTypes
            var cacheKey = componentName + ':' + propName;
            if (!manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
            }
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          // `propValue` being instance of, say, date/regexp, pass the 'object'
          // check, but we can offer a more precise error message here rather than
          // 'of type `object`'.
          var preciseType = getPreciseType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
            expectedType: expectedType
          });
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== 'production') {
          if (arguments.length > 1) {
            printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
          } else {
            printWarning('Invalid argument supplied to oneOf, expected an array.');
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === 'symbol') {
            return String(value);
          }
          return value;
        });
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
        }
        for (var key in propValue) {
          if (has(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== 'function') {
          printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== 'function') {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        // We need to check all keys in case some are required but missing from props.
        var allKeys = assign({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has(shapeTypes, key) && typeof checker !== 'function') {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case 'number':
        case 'string':
        case 'undefined':
          return true;
        case 'boolean':
          return !propValue;
        case 'object':
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              // Iterator will provide entry [k,v] tuples rather than values.
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      // Native Symbol.
      if (propType === 'symbol') {
        return true;
      }

      // falsy value can't be a Symbol
      if (!propValue) {
        return false;
      }

      // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
      if (propValue['@@toStringTag'] === 'Symbol') {
        return true;
      }

      // Fallback for non-spec compliant Symbols which are polyfilled.
      if (typeof Symbol === 'function' && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }

    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return 'array';
      }
      if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
      }
      if (isSymbol(propType, propValue)) {
        return 'symbol';
      }
      return propType;
    }

    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
      if (typeof propValue === 'undefined' || propValue === null) {
        return '' + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === 'object') {
        if (propValue instanceof Date) {
          return 'date';
        } else if (propValue instanceof RegExp) {
          return 'regexp';
        }
      }
      return propType;
    }

    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case 'array':
        case 'object':
          return 'an ' + type;
        case 'boolean':
        case 'date':
        case 'regexp':
          return 'a ' + type;
        default:
          return type;
      }
    }

    // Returns class name of the object, if any.
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {}
  function emptyFunctionWithReset() {}
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function factoryWithThrowingShims() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        // It is still safe when called from React.
        return;
      }
      var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
      err.name = 'Invariant Violation';
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    } // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function removeClass$1(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}
var config = {
  disabled: false
};
var TransitionGroupContext = React.createContext(null);
var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};
var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);
  function Transition(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;
    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }
    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }
  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;
    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }
    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;
      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };
  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;
    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }
    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };
  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }
    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };
  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;
    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing],
      maybeNode = _ref2[0],
      maybeAppearing = _ref2[1];
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }
    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);
      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };
  _proto.performExit = function performExit() {
    var _this3 = this;
    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }
    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);
      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };
  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };
  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };
  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;
    var active = true;
    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };
    this.nextCallback.cancel = function () {
      active = false;
    };
    return this.nextCallback;
  };
  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
        maybeNode = _ref3[0],
        maybeNextCallback = _ref3[1];
      this.props.addEndListener(maybeNode, maybeNextCallback);
    }
    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };
  _proto.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }
    var _this$props = this.props,
      children = _this$props.children;
    _this$props.in;
    _this$props.mountOnEnter;
    _this$props.unmountOnExit;
    _this$props.appear;
    _this$props.enter;
    _this$props.exit;
    _this$props.timeout;
    _this$props.addEndListener;
    _this$props.onEnter;
    _this$props.onEntering;
    _this$props.onEntered;
    _this$props.onExit;
    _this$props.onExiting;
    _this$props.onExited;
    _this$props.nodeRef;
    var childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return /*#__PURE__*/(
      // allows for nested Transitions
      React.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React.cloneElement(React.Children.only(children), childProps))
    );
  };
  return Transition;
}(React.Component);
Transition.contextType = TransitionGroupContext;
// Name the function so it is clearer in the documentation

function noop() {}
Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var _addClass = function addClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass$1(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */

var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);
  function CSSTransition() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };
    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
        node = _this$resolveArgument[0],
        appearing = _this$resolveArgument[1];
      _this.removeClasses(node, 'exit');
      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };
    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
        node = _this$resolveArgument2[0],
        appearing = _this$resolveArgument2[1];
      var type = appearing ? 'appear' : 'enter';
      _this.addClass(node, type, 'active');
      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };
    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
        node = _this$resolveArgument3[0],
        appearing = _this$resolveArgument3[1];
      var type = appearing ? 'appear' : 'enter';
      _this.removeClasses(node, type);
      _this.addClass(node, type, 'done');
      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };
    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
        node = _this$resolveArgument4[0];
      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      _this.addClass(node, 'exit', 'base');
      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };
    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
        node = _this$resolveArgument5[0];
      _this.addClass(node, 'exit', 'active');
      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };
    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
        node = _this$resolveArgument6[0];
      _this.removeClasses(node, 'exit');
      _this.addClass(node, 'exit', 'done');
      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };
    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };
    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };
    return _this;
  }
  var _proto = CSSTransition.prototype;
  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];
    var _this$getClassNames = this.getClassNames('enter'),
      doneClassName = _this$getClassNames.doneClassName;
    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.

    if (phase === 'active') {
      if (node) forceReflow(node);
    }
    if (className) {
      this.appliedClasses[type][phase] = className;
      _addClass(node, className);
    }
  };
  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
      baseClassName = _this$appliedClasses$.base,
      activeClassName = _this$appliedClasses$.active,
      doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};
    if (baseClassName) {
      removeClass(node, baseClassName);
    }
    if (activeClassName) {
      removeClass(node, activeClassName);
    }
    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };
  _proto.render = function render() {
    var _this$props = this.props;
    _this$props.classNames;
    var props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);
    return /*#__PURE__*/React.createElement(Transition, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };
  return CSSTransition;
}(React.Component);
CSSTransition.defaultProps = {
  classNames: ''
};
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };
  var result = Object.create(null);
  if (children) Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};
  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list

  var nextKeysPending = Object.create(null);
  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }
  var i;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`

  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }
  return childMapping;
}
function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!isValidElement(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}
var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};
var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);
  function TransitionGroup(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear

    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }
  var _proto = TransitionGroup.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };
  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
      handleExited = _ref.handleExited,
      firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;
    if (child.props.onExited) {
      child.props.onExited(node);
    }
    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);
        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };
  _proto.render = function render() {
    var _this$props = this.props,
      Component = _this$props.component,
      childFactory = _this$props.childFactory,
      props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;
    if (Component === null) {
      return /*#__PURE__*/React.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }
    return /*#__PURE__*/React.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/React.createElement(Component, props, children));
  };
  return TransitionGroup;
}(React.Component);
TransitionGroup.defaultProps = defaultProps;

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);
  function ReplaceTransition() {
    var _this;
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return _this.handleLifecycle('onEnter', 0, args);
    };
    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return _this.handleLifecycle('onEntering', 0, args);
    };
    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return _this.handleLifecycle('onEntered', 0, args);
    };
    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }
      return _this.handleLifecycle('onExit', 1, args);
    };
    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }
      return _this.handleLifecycle('onExiting', 1, args);
    };
    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }
      return _this.handleLifecycle('onExited', 1, args);
    };
    return _this;
  }
  var _proto = ReplaceTransition.prototype;
  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;
    var children = this.props.children;
    var child = React.Children.toArray(children)[idx];
    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) {
      var maybeNode = child.props.nodeRef ? undefined : ReactDOM.findDOMNode(this);
      this.props[handler](maybeNode);
    }
  };
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      inProp = _this$props.in,
      props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
    var _React$Children$toArr = React.Children.toArray(children),
      first = _React$Children$toArr[0],
      second = _React$Children$toArr[1];
    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return /*#__PURE__*/React.createElement(TransitionGroup, props, inProp ? React.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : React.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };
  return ReplaceTransition;
}(React.Component);
var _leaveRenders, _enterRenders;
function areChildrenDifferent(oldChildren, newChildren) {
  if (oldChildren === newChildren) return false;
  if (React.isValidElement(oldChildren) && React.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
    return false;
  }
  return true;
}
/**
 * Enum of modes for SwitchTransition component
 * @enum { string }
 */

var modes = {
  out: 'out-in',
  in: 'in-out'
};
var callHook = function callHook(element, name, cb) {
  return function () {
    var _element$props;
    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
    cb();
  };
};
var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
  var current = _ref.current,
    changeState = _ref.changeState;
  return React.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(ENTERING, null);
    })
  });
}, _leaveRenders[modes.in] = function (_ref2) {
  var current = _ref2.current,
    changeState = _ref2.changeState,
    children = _ref2.children;
  return [current, React.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(ENTERING);
    })
  })];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
  var children = _ref3.children,
    changeState = _ref3.changeState;
  return React.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(ENTERED, React.cloneElement(children, {
        in: true
      }));
    })
  });
}, _enterRenders[modes.in] = function (_ref4) {
  var current = _ref4.current,
    children = _ref4.children,
    changeState = _ref4.changeState;
  return [React.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(ENTERED, React.cloneElement(children, {
        in: true
      }));
    })
  }), React.cloneElement(children, {
    in: true
  })];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */

var SwitchTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SwitchTransition, _React$Component);
  function SwitchTransition() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      status: ENTERED,
      current: null
    };
    _this.appeared = false;
    _this.changeState = function (status, current) {
      if (current === void 0) {
        current = _this.state.current;
      }
      _this.setState({
        status: status,
        current: current
      });
    };
    return _this;
  }
  var _proto = SwitchTransition.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };
  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.children == null) {
      return {
        current: null
      };
    }
    if (state.status === ENTERING && props.mode === modes.in) {
      return {
        status: ENTERING
      };
    }
    if (state.current && areChildrenDifferent(state.current, props.children)) {
      return {
        status: EXITING
      };
    }
    return {
      current: React.cloneElement(props.children, {
        in: true
      })
    };
  };
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      mode = _this$props.mode,
      _this$state = this.state,
      status = _this$state.status,
      current = _this$state.current;
    var data = {
      children: children,
      current: current,
      changeState: this.changeState,
      status: status
    };
    var component;
    switch (status) {
      case ENTERING:
        component = enterRenders[mode](data);
        break;
      case EXITING:
        component = leaveRenders[mode](data);
        break;
      case ENTERED:
        component = current;
    }
    return /*#__PURE__*/React.createElement(TransitionGroupContext.Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, component);
  };
  return SwitchTransition;
}(React.Component);
SwitchTransition.defaultProps = {
  mode: modes.out
};
var useClickInsideElement = function useClickInsideElement() {
  var _a = useState(false),
    isClickInside = _a[0],
    setIsClickInside = _a[1];
  var ref = useRef(null);
  var handleClickOutside = function handleClickOutside(event) {
    var _a;
    if (ref.current && !((_a = ref.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
      setIsClickInside(false);
    }
  };
  useEffect(function () {
    document.addEventListener("click", handleClickOutside, true);
    return function () {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);
  return {
    ref: ref,
    isClickInside: isClickInside,
    setIsClickInside: setIsClickInside
  };
};
var styles$2 = {
  "searchInput": "search-module_searchInput__6wVri",
  "searchIcon": "search-module_searchIcon__JUs4M",
  "headerSearch": "search-module_headerSearch__MdkeY",
  "opened": "search-module_opened__FF6YK",
  "searchDropdown": "search-module_searchDropdown__j20at",
  "searchDesc": "search-module_searchDesc__BkFHK",
  "searchList": "search-module_searchList__cN04u",
  "searchItem": "search-module_searchItem__fSsSc",
  "fadeInDown": "search-module_fadeInDown__zafsC",
  "fadeInUp": "search-module_fadeInUp__3E6vj",
  "fadeInDropdown": "search-module_fadeInDropdown__bc9en",
  "fadeOutDropdown": "search-module_fadeOutDropdown__ZMzHq"
};
var fadeTransition = {
  "enter": "fade-module_enter__jaIpt",
  "enterActive": "fade-module_enterActive__GdrOq",
  "exit": "fade-module_exit__FGAy7",
  "exitActive": "fade-module_exitActive__FwUH0",
  "fadeInDown": "fade-module_fadeInDown__gUzje",
  "fadeInUp": "fade-module_fadeInUp__BzNi5",
  "fadeInDropdown": "fade-module_fadeInDropdown__f0X5l",
  "fadeOutDropdown": "fade-module_fadeOutDropdown__tYWxV"
};
var Search = function Search(_a) {
  var navigateTo = _a.navigateTo,
    useSearch = _a.useSearch,
    tracking = _a.tracking;
  var _b = useClickInsideElement(),
    ref = _b.ref,
    isClickInside = _b.isClickInside,
    setIsClickInside = _b.setIsClickInside;
  var _c = useSearch(),
    filteredProducts = _c.filteredProducts,
    filterProducts = _c.filterProducts,
    redirectToCbd = _c.redirectToCbd;
  var _d = useState(false),
    showSearchInput = _d[0],
    setShowSearchInput = _d[1];
  var _e = useState(false),
    showSearchDropdown = _e[0],
    setShowSearchDropdown = _e[1];
  var _f = useState(""),
    searchValue = _f[0],
    setSearchValue = _f[1];
  var openSearch = function openSearch() {
    setSearchValue("");
    setShowSearchInput(true);
  };
  var closeSearch = function closeSearch() {
    setShowSearchInput(false);
    setShowSearchDropdown(false);
  };
  var handleSearchInput = function handleSearchInput(value) {
    if (value) {
      setShowSearchDropdown(true);
      filterProducts(value);
    } else setShowSearchDropdown(false);
    setSearchValue(value);
  };
  var handleClickProduct = function handleClickProduct(link) {
    // ! Figure out better tracking callback
    tracking.trackClickSearchedProduct(searchValue, link);
    navigateTo(link);
  };
  var handleClickSearchButton = function handleClickSearchButton() {
    setIsClickInside(true);
    // ! Figure out better tracking callback
    tracking.trackClickSearchButton();
  };
  useEffect(function () {
    if (isClickInside) openSearch();else closeSearch();
  }, [isClickInside]);
  return React.createElement("div", {
    ref: ref,
    className: "".concat(styles$2.headerSearch, " ").concat(showSearchInput ? styles$2.opened : ""),
    onFocus: handleClickSearchButton,
    id: "search-button",
    "data-test-id": "search-button"
  }, React.createElement(React.Fragment, null, React.createElement("input", {
    id: "search-input",
    className: styles$2.searchInput,
    "data-test-id": "search-input",
    placeholder: "Search products",
    onInput: function onInput(e) {
      return handleSearchInput(e.target.value);
    },
    onKeyPress: function onKeyPress(e) {
      return e.key === "Enter" ? redirectToCbd(e.target.value) : null;
    },
    value: searchValue
  }), React.createElement("label", {
    className: styles$2.searchIcon
  }, React.createElement(Icon, {
    size: 18,
    icon: "search"
  })), React.createElement(CSSTransition, {
    in: showSearchDropdown,
    timeout: 300,
    classNames: _assign$({}, fadeTransition),
    unmountOnExit: true
  }, React.createElement("div", {
    className: styles$2.searchDropdown,
    "data-test-id": "search-dropdown"
  }, React.createElement("span", {
    className: styles$2.searchDesc
  }, "".concat(filteredProducts.length, " products found")), React.createElement("ul", {
    className: styles$2.searchList
  }, filteredProducts.map(function (product) {
    return React.createElement("li", {
      className: styles$2.searchItem,
      key: product.name
    }, React.createElement("a", {
      onClick: function onClick() {
        return handleClickProduct(product.link);
      }
    }, React.createElement("span", null, product.name)));
  }))))));
};
var styles$1 = {
  "header": "top-navigation-module_header__Igx7y",
  "scrolled": "top-navigation-module_scrolled__2dKKe",
  "showSticky": "top-navigation-module_showSticky__dyc-R",
  "headerShopModal": "top-navigation-module_headerShopModal__fD-T-",
  "fixed": "top-navigation-module_fixed__bpW-e",
  "easing": "top-navigation-module_easing__os5cy",
  "fadeInDown": "top-navigation-module_fadeInDown__Um24N",
  "fadeInUp": "top-navigation-module_fadeInUp__4U58P",
  "fadeInDropdown": "top-navigation-module_fadeInDropdown__0vfDD",
  "fadeOutDropdown": "top-navigation-module_fadeOutDropdown__yaSxv"
};
var TopNavigation = function TopNavigation(_a) {
  _a.logo;
  _a.siteTitle;
  var rootUrl = _a.rootUrl,
    bannerHeight = _a.bannerHeight,
    showStickyNav = _a.showStickyNav,
    setShowStickyNav = _a.setShowStickyNav,
    windowIsScrolled = _a.windowIsScrolled,
    setWindowIsScrolled = _a.setWindowIsScrolled,
    showShopModal = _a.showShopModal,
    isLoggedIn = _a.isLoggedIn,
    sidebar = _a.sidebar,
    showCart = _a.showCart,
    setShowCart = _a.setShowCart,
    setSidebar = _a.setSidebar,
    isPrivateRoute = _a.isPrivateRoute,
    useLogoutUser = _a.useLogoutUser,
    useSearch = _a.useSearch,
    navigateTo = _a.navigateTo,
    setShowAddCoupon = _a.setShowAddCoupon,
    dataCart = _a.dataCart,
    loadingCart = _a.loadingCart,
    location = _a.location,
    tracking = _a.tracking,
    _b = _a.hideSearch,
    hideSearch = _b === void 0 ? false : _b,
    shouldClearCart = _a.shouldClearCart;
  var headerHeight = 80;
  var isMobile = reactResponsiveExports.useMediaQuery({
    query: "(max-width: 1023px)"
  });
  var logoutUser = useLogoutUser();
  var _c = useState(-1),
    scrollPrevPos = _c[0],
    setScrollPrevPos = _c[1];
  useEffect(function () {
    if (!isSSR) {
      var onScroll_1 = function onScroll_1() {
        setWindowIsScrolled(window.pageYOffset > headerHeight);
        setScrollPrevPos(window.pageYOffset);
        setShowStickyNav(window.pageYOffset > 0 && window.pageYOffset < scrollPrevPos);
      };
      window.addEventListener("scroll", onScroll_1);
      return function () {
        return window.removeEventListener("scroll", onScroll_1);
      };
    }
  }, [!isSSR && window.pageYOffset]);
  useEffect(function () {
    setShowStickyNav(showShopModal);
  }, [showShopModal]);
  var classes = "".concat(styles$1.header, " ").concat(showShopModal ? "".concat(styles$1.headerShopModal) : "", " ").concat(windowIsScrolled ? "".concat(styles$1.scrolled) : "", " ").concat(showStickyNav ? "".concat(styles$1.showSticky, " ").concat(styles$1.fixed) : "", " ").concat(styles$1.easing);
  var rightNav = function rightNav() {
    return React.createElement(RightNavSection, {
      isPrivateRoute: isPrivateRoute,
      location: location,
      accountDropdown: React.createElement(AccountDropdown, {
        rootUrl: rootUrl,
        navigateTo: navigateTo,
        isPrivateRoute: isPrivateRoute,
        logoutUser: logoutUser,
        isLoggedIn: isLoggedIn,
        setShowAddCoupon: setShowAddCoupon
      }),
      cartButton: React.createElement(CartButton, {
        showCart: showCart,
        setShowCart: setShowCart,
        dataCart: dataCart,
        loadingCart: loadingCart,
        shouldClearCart: shouldClearCart
      }),
      search: hideSearch ? null : React.createElement(Search, {
        navigateTo: navigateTo,
        useSearch: useSearch,
        tracking: tracking
      })
    });
  };
  if (isMobile) {
    return React.createElement("header", {
      className: classes,
      style: {
        paddingTop: bannerHeight
      }
    }, React.createElement(NavMobile, {
      sidebar: sidebar,
      setSidebar: setSidebar,
      logo: React.createElement(NavLogo, {
        navigateTo: navigateTo
      }),
      rightNavSectionMobile: rightNav()
    }));
  }
  return React.createElement("header", {
    className: classes,
    style: {
      paddingTop: bannerHeight
    }
  }, React.createElement(NavDesktop, {
    logo: React.createElement(NavLogo, {
      navigateTo: navigateTo
    }),
    letfNavSection: React.createElement(LeftNavSection, {
      navigateTo: navigateTo,
      rootUrl: rootUrl,
      isLoggedIn: isLoggedIn,
      showStickyNav: showStickyNav,
      showShopModal: showShopModal,
      isPrivateRoute: isPrivateRoute,
      resultDropdown: React.createElement(ResultDropdown, {
        navigateTo: navigateTo,
        rootUrl: rootUrl
      }),
      learnDropdown: React.createElement(LearnDropdown, {
        navigateTo: navigateTo,
        rootUrl: rootUrl
      }),
      location: location
    }),
    rightNavSection: rightNav()
  }));
};
var styles = {
  "trustpilot": "trustpilot-iframe-module_trustpilot__iUetP"
};
var injectScript = function injectScript(src) {
  // Create script
  var script = document.createElement("script");
  script.src = src;
  script.async = true;
  script.setAttribute("data-status", "loading");
  // Add script to document body
  document.body.appendChild(script);
  return script;
};
// Hook
var useScript = function useScript(src) {
  // Keep track of script status ("idle", "loading", "ready", "error")
  var _a = useState(src ? "loading" : "idle"),
    status = _a[0],
    setStatus = _a[1];
  useEffect(function () {
    // Allow falsy src value if waiting on other data needed for
    // constructing the script URL passed to this hook.
    if (!src) {
      setStatus("idle");
      return;
    }
    // Fetch existing script element by src
    // It may have been added by another intance of this hook
    var script = document.querySelector("script[src=\"".concat(src, "\"]"));
    if (!script) {
      script = injectScript(src);
      // Store status in attribute on script
      // This can be read by other instances of this hook
      var setAttributeFromEvent = function setAttributeFromEvent(event) {
        script === null || script === void 0 ? void 0 : script.setAttribute("data-status", event.type === "load" ? "ready" : "error");
      };
      script.addEventListener("load", setAttributeFromEvent);
      script.addEventListener("error", setAttributeFromEvent);
    } else {
      // Grab existing script status from attribute and set to state.
      setStatus(script.getAttribute("data-status"));
    }
    // Script event handler to update status in state
    // Note: Even if the script already exists we still need to add
    // event handlers to update the state for *this* hook instance.
    var setStateFromEvent = function setStateFromEvent(event) {
      setStatus(event.type === "load" ? "ready" : "error");
    };
    // Add event listeners
    script.addEventListener("load", setStateFromEvent);
    script.addEventListener("error", setStateFromEvent);
    // Remove event listeners on cleanup
    return function () {
      if (script) {
        script.removeEventListener("load", setStateFromEvent);
        script.removeEventListener("error", setStateFromEvent);
      }
    };
  }, [src]);
  return status;
};
var TRUST_PILOT_WIDGET_TYPES;
(function (TRUST_PILOT_WIDGET_TYPES) {
  TRUST_PILOT_WIDGET_TYPES["MicroStar"] = "MicroStar";
  TRUST_PILOT_WIDGET_TYPES["Carousel"] = "Carousel";
  TRUST_PILOT_WIDGET_TYPES["MicroCombo"] = "MicroCombo";
})(TRUST_PILOT_WIDGET_TYPES || (TRUST_PILOT_WIDGET_TYPES = {}));
var TrustPilot = function TrustPilot(_a) {
  var type = _a.type,
    _b = _a.className,
    className = _b === void 0 ? "" : _b;
  var refTrustpilot = useRef(null);
  useScript("https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js");
  useEffect(function () {
    var loadTrustpilotWidget = function loadTrustpilotWidget() {
      var isTrustpilot = !isSSR && window.Trustpilot;
      if (isTrustpilot && refTrustpilot.current) window.Trustpilot.loadFromElement(refTrustpilot.current);
    };
    loadTrustpilotWidget();
  }, [refTrustpilot]);
  if (type === TRUST_PILOT_WIDGET_TYPES.MicroStar) {
    return React.createElement("div", {
      ref: refTrustpilot,
      className: "trustpilot-widget ".concat(className),
      "data-locale": "en-GB",
      "data-template-id": "5419b732fbfb950b10de65e5",
      "data-businessunit-id": "5698fb5e0000ff000587a69a",
      "data-style-height": "24px",
      "data-style-width": "100%",
      "data-theme": "light"
    }, React.createElement("a", {
      href: "https://uk.trustpilot.com/review/vitl.com",
      target: "_blank",
      rel: "noopener"
    }, "Trustpilot"));
  }
  if (type === TRUST_PILOT_WIDGET_TYPES.Carousel) {
    return React.createElement("div", {
      ref: refTrustpilot,
      className: "trustpilot-widget ".concat(className),
      "data-locale": "en-GB",
      "data-template-id": "53aa8912dec7e10d38f59f36",
      "data-businessunit-id": "5698fb5e0000ff000587a69a",
      "data-style-height": "300px",
      "data-style-width": "100%",
      "data-theme": "light",
      "data-stars": "5"
    }, React.createElement("a", {
      href: "https://uk.trustpilot.com/review/vitl.com",
      target: "_blank",
      rel: "noopener"
    }, "Trustpilot"));
  }
  if (type === TRUST_PILOT_WIDGET_TYPES.MicroCombo) {
    return React.createElement("div", {
      ref: refTrustpilot,
      className: "trustpilot-widget ".concat(className),
      "data-locale": "en-GB",
      "data-template-id": "5419b6ffb0d04a076446a9af",
      "data-businessunit-id": "5698fb5e0000ff000587a69a",
      "data-style-height": "20px",
      "data-style-width": "100%",
      "data-theme": "light"
    }, React.createElement("a", {
      href: "https://uk.trustpilot.com/review/vitl.com",
      target: "_blank",
      rel: "noopener"
    }, "Trustpilot"));
  }
  return React.createElement("section", {
    className: styles.trustpilot
  }, React.createElement("div", {
    ref: refTrustpilot,
    className: "trustpilot-widget ".concat(className),
    "data-locale": "en-GB",
    "data-template-id": "53aa8807dec7e10d38f59f32",
    "data-businessunit-id": "5698fb5e0000ff000587a69a",
    "data-style-height": "100px",
    "data-style-width": "150px",
    "data-theme": "light"
  }, React.createElement("a", {
    href: "https://uk.trustpilot.com/review/vitl.com",
    target: "_blank",
    rel: "noopener",
    "aria-label": "trustpilot",
    title: "trustpilot"
  }, "Trustpilot")));
};
export { Accordion, AddToBacketSticky, AddToBasket, AddToBasket30Percent3MonthsOffer, AsSeenInUI, Badge, Button, Card, ExpertApproval, HowItWorks, Icon, Image, JoinTheCommunityUI, List, NutritionalInformationUI, PartnersSliderComponent as PartnersSliderUI, ReviewNewUI, ReviewsUI, Section, StillHaveQuestionUI, SwiperComponent, TopNavigation, TrustPilot };